// en, de, fr, pt
export default {
  en: {
    Dashboard: 'Dashboard',
    eCommerce: 'eCommerce',
    KnowledgeTree: 'Knowledge Tree',
    codesearch: 'Code Search',
    Apps: 'Apps',
    Use:'Use',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    Projects: 'Projects',
    People: 'People',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UIElements: 'UI Elements',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    Password:'Password',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    Reset: 'Reset',
    RecoverPassword:'Recover Password',
    ConfirmPassword: 'Confirm Password',
    RememberMe: "Remember Мe",
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    ToggleFullscreen: 'Toggle Fullscreen',
    SomethingIsntQuiteRight: 'Something isn\'t quite right',
    // OnboardingPDF Tour
    SopTitleTour: 'This is the title of your SOP. You can see the name and description here.',
    StepsTour: 'These are your steps. Click on the header to expand/collapse the content.',
    ToolsTour: 'Use these controls to mark steps as complete or flag them for review.',
    MenuTour: 'Finally - actions for the onboarding can be found here as well + more advanced things.',

    // OnboardingPDF.vue additions (en)
    VerifyYourEmail: 'Verify your email',
    VerificationCode: 'Verification code',
    PleaseEnterYourEmailVerification: 'Please enter your email to continue.',
    WeHaveJustSentEmailWithPin: 'We have just sent an email with a PIN. Please enter it below to proceed.',
    Code: 'Code',
    ViewAsSlideshow: 'View as slideshow',
    RecordedWith: 'Recorded with',
    ClickLinkBetterExperience: 'Click the link for a better experience',
    ExternalContentMessage: 'This step links to external content. You will be redirected to an external page.',
    IUnderstandProceed: 'I understand, proceed',
    ImageView: 'Image view',
    GuestUsersViewOnly: 'Guest users can only view content.',
    ProblemCompletingStep: 'There was a problem completing this step.',
    OnboardingSharedSuccessfully: 'Onboarding shared successfully.',
    ErrorsSharingOnboarding: 'There were errors while sharing this onboarding.',
    FieldCannotBeEmpty: 'This field cannot be empty',
    SuccessfullyAddedToSpace: 'Successfully added to space.',
    ProblemAddingToSpace: 'There was a problem adding to space.',
    SuccessfullyRemovedFromSpace: 'Successfully removed from space.',
    ProblemRemovingFromSpace: 'There was a problem removing from space.',
    SendLoginLink: 'Send login link?',
    ProblemSendingLink: 'There was a problem sending the link.',
    PageBeingConverted: 'Page is being converted...',
    ProblemConvertingToPDF: 'There was a problem converting to PDF.',
    PageCannotBeAccessed: 'This page cannot be accessed.',
    InvalidLink: 'Invalid link.',
    NoAccessEmailMessage: 'Access denied for this email. Please contact the person who shared it.',
    EditorNotFound: 'Editor not found',
    CopyToClipboard: 'Copy to clipboard',
    ExpandStepContents: 'Expand step contents',
    CollapseStepContent: 'Collapse step content',
    MarkStepCompleted: 'Mark step completed',
    Fullscreen: 'Fullscreen',
    FlagThisStep: 'Flag this step',
    AddCommentToStep: 'Flag this step',
    ContentMissingOrNoPermissions: 'The content you are looking for is missing or you don\'t have permissions to access it.',

    SubmitFeedbackIfError: 'If you believe this is an error - submit feedback.',
    BackToHome: 'Back to Home',
    LoginAndRetry: 'Login and retry',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    EditorView: 'Editor View',
    AdminView: 'Admin View',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    Learning: "Learning",
    Exercises: "Exercises",
    Tags: "Tags",
    Logs: "Logs",
    CloudAdmin: "Cloud Admin",
    Users: "Users",
    Accounts: "Accounts",
    Embeds: "Embeds",
    AccountLogs: "Account Logs",
    AccountAdmin: "Account Admin",
    Helping: "Helping",
    Positions: "Positions",
    Working: "Working",
    Guides: "Guides",
    CodeReviews: "Code Reviews",
    WorkAnalytics: "Work Analytics",
    Tours: "Tours",
    OnboardingAndContext: "My Alignment",
    demoText: '',
    Record: 'Record',
    Open: 'Open',
    Save: 'Save',
    Share: 'Share',
    SOPEditor:'SOP Editor',
    DiscoverImprove: 'Discover & Improve',
    Spaces: 'Spaces',
    SpaceManager: 'Space Manager',
    Latest: 'Latest',
    MostUseful: 'Most useful',
    TailoredForYou: 'Tailored for you',
    Browse: 'Browse',
    Logout: 'Logout',
    MarkAsComplete: 'Mark as Complete',
    COMPLETED:"COMPLETED",
    Yes: "Yes",
    No: "No",
    Next: "Next",
    Back: "Back",
    Folders: 'Folders',
    BackToLogin: "Обратно към Login",
    //FEEDBACK CARD SPECIFIC(FeedbackCard.vue)
    FeedbackTitle:"We'd love your feedback",
    RateTitle: "How would you rate this SOP overall?",
    SaveTimeTitle: "Did this SOP save you time?",
    SaveTimeDescription: "Understanding time saved helps us prioritize improvements.",
    SaveTimeApproxTitle: "Approximately how much time did it save?",
    SaveTimeApproxDescription: "Rough estimate is fine - this helps us understand impact.",
    LessThanAnHour:"Less than 1 hour",
    OneToTwoHours:"1-2 hours",
    TwoToFourHours: "2-4 hours",
    MoreThanFourHours: "More than 4 hours",
    NotSure:'Not sure',
    AlreadyKnowHowTitle: "Did you already know how to do this?",
    AlreadyKnowHowDescription: "This helps us understand if we're adding value beyond existing knowledge.",
    DocumentationBetterTitle:"Was our documentation better than what you knew?",
    RecommendSOPTitle: "Would you recommend this SOP to others?",
    RecommendSOPDescriptiion: "This helps us understand the overall effectiveness.",
    SOPEasyToFollowTitle: "Was this SOP easy to follow?",
    CommentsTitle: "Comments or suggestions for improvement?",
    CommentsDescription: "Optional: Any additional feedback helps us improve.",
    CommentTextAreaPlaceholder:"Tell us what could be better...",
    SubmitFeedbackButtonText: "Submit Feedback",
    PopupFeedbackCompletionText: "Thank you for your feedback!",

    //FORGOTTEN PASSWORD SPECIFIC (ForgottenPassword.vue)
    RecoverYourPassword: 'Recover your password',
    RecoverYourPasswordInstuctions: 'Please enter your email address and we\'ll send you instructions on how to reset your password.',
    RecoverPasswordMessage: 'If your email is in our system - you will receive a password reset email.',

    // SOPEditorMenu
    File: 'File',
    Import: 'Import',
    Export: 'Export',
    ExportAs: 'Export As...',
    DownloadAsPPTX: 'Download as PPTX',
    TCVelikSOPFormat: 'TCVelik SOP Format',
    AddToSpace: 'Add to Space',
    OpenReviewMenu: 'Open Review Menu',
    GeneratePreviewLink: 'Generate Preview Link',
    Delete: 'Delete',
    Close: 'Close',
    Edit: 'Edit',
    Undo: 'Undo',
    Redo: 'Redo',
    SelectAll: 'Select All',
    View: 'View',
    HTMLSource: 'HTML Source',
    Tools: 'Tools',
    Properties: 'Properties',
    Assign: 'Assign',
    AssignToRole: 'Assign to Role',
    EditIntent: 'Edit Intent',
    ExitEditor: 'Exit Editor',
    Menu: 'Menu',

    // MainToolbar and Components
    // AlignmentButtons
    AlignLeft: 'Align left',
    AlignCenter: 'Align center',
    AlignRight: 'Align right',
    // TextFormattingButtons
    Heading: 'Heading',
    Paragraph: 'Paragraph',
    Bold: 'Bold',
    Italic: 'Italic',
    Underline: 'Underline',
    // ListButtons
    BulletList: 'Bullet list',
    NumberedList: 'Numbered list',
    ManualSteps: 'Manual steps',
    DefaultManual: 'Default',
    Warning: 'Warning',
    Success: 'Success',
    Informational: 'Informational',
    CameraPicture: 'Camera',
    CodeStep: 'Code',
    ErrorStep: 'Error',
    Image: 'Image',
    Line: 'Line',
    // ContentButtons
    AddLink: 'Add link',
    AddImage: 'Add image',
    // AdvancedButtons
    EditHTML: 'Edit HTML',
    // LineManagementButtons
    AddBlankLineAbove: 'Add blank line above',
    AddBlankLineBelow: 'Add blank line below',
    // FileOperationsButtons
    ShareOnboarding: 'Share onboarding',
    AssignOnboarding: 'Assign onboarding',
    AssignToRoleTitle: 'Assign to role',
    OpenPropertiesMenu: 'Properties',
    DeleteOnboarding: 'Delete onboarding',

    // SignalsView.vue
    SignalsManagement: 'Signals Management',
    QuickFilters: 'Quick Filters',
    System: 'System',
    Action: 'Action',
    UserEmail: 'User Email',
    ProcessedStatus: 'Processed Status',
    All: 'All',
    Processed: 'Processed',
    Unprocessed: 'Unprocessed',
    Refresh: 'Refresh',
    ManageFilters: 'Manage Filters',
    ManageTags: 'Manage Tags',
    ApplyTags: 'Apply Tags',
    CreateTestSignal: 'Create Test Signal',
    Context: 'Context',
    SOPHint: 'SOP Hint',
    Created: 'Created',
    ViewDetails: 'View Details',
    Showing: 'Showing',
    to: 'to',
    of: 'of',
    signals: 'signals',
    CreateNewFilter: 'Create New Filter',
    Name: 'Name',
    Field: 'Field',
    Operation: 'Operation',
    Value: 'Value',
    CreateFilter: 'Create Filter',
    FilterName: 'Filter Name',
    Description: 'Description',
    SelectField: 'Select Field',
    SelectOperation: 'Select Operation',
    SecondValue: 'Second Value',
    CreateNewTag: 'Create New Tag',
    Color: 'Color',
    CreateTag: 'Create Tag',
    TagName: 'Tag Name',
    ColorHex: 'Color (Hex)',
    ApplyTagsToSignals: 'Apply Tags to Signals',
    SelectFilters: 'Select Filters',
    SelectFiltersToApply: 'Select filters to apply',
    SelectTags: 'Select Tags',
    SelectTagsToApply: 'Select tags to apply',
    FilterCreatedSuccessfully: 'Filter created successfully',
    FailedToCreateFilter: 'Failed to create filter',
    TagCreatedSuccessfully: 'Tag created successfully',
    FailedToCreateTag: 'Failed to create tag',
    FailedToLoadSignals: 'Failed to load signals',
    FailedToApplyTags: 'Failed to apply tags',
    TestSignalCreatedSuccessfully: 'Test signal created successfully',
    FailedToCreateTestSignal: 'Failed to create test signal',

    // SuggestionsList.vue
    SuggestedUsers: 'Suggested Users',
    SignalCount: 'Signal Count',
    LastActivity: 'Last Activity',
    AlreadyInvited: 'Already Invited',
    NewLabel: 'New',
    InvitationSent: 'Invitation Sent',
    Invite:'Invite',
    ReadyToInvite: 'Ready to Invite',
    ForceProcess: 'Force Process',
    FailedToLoadSuggestedUsers: 'Failed to load suggested users',
    ProcessedSignals: 'Processed {count} signals',
    FailedToProcessSignals: 'Failed to process signals',

    // Profile.vue
    Hey: 'Hey',
    Stranger: 'Stranger',
    SOPsOpened: 'SOPs Opened',
    SOPsCompleted: 'SOPs Completed',
    StepsCompleted: 'Steps Completed',
    RatingsGiven: 'Ratings Given',
    CertificatesEarned: 'Certificates Earned',
    Filters: 'Filters',
    Position: 'Position',
    Manager: 'Manager',
    Supervisor: 'Supervisor',
    Status: 'Status',
    Completed: 'Completed',
    Pending: 'Pending',
    ManagerPosition: 'Manager Position',
    SupervisorPosition: 'Supervisor Position',
    Completion: 'Completion',
    OpeningProcedures: 'Opening Procedures',
    ClosingProcedures: 'Closing Procedures',
    SafetyProtocol: 'Safety Protocol',
    EmployeeTraining: 'Employee Training',

    // UserJourneyTimeline.vue
    YourJourney: 'Your Journey',
    Last7Days: 'Last 7 days',
    Last30Days: 'Last 30 days',
    Last90Days: 'Last 90 days',
    LastYear: 'Last year',
    LoadingYourJourney: 'Loading your journey...',
    FailedToLoadJourneyTimeline: 'Failed to load your journey timeline. Please try again.',
    TryAgain: 'Try Again',
    NoActivityYet: 'No activity yet',
    JourneyTimelineWillAppear: 'Your journey timeline will appear here once you start interacting with SOPs.',
    Resolved: 'Resolved',
    PendingResolution: 'Pending Resolution',
    Reason: 'Reason',
    Resolution: 'Resolution',
    StepCompletedSuccessfully: 'Step {stepId} completed successfully',
    Stars: 'stars',
    Comment: 'Comment',
    Helpful: 'Helpful',
    SavedMinutes: 'Saved {minutes} minutes',
    AlreadyKnewThis: 'Already knew this',
    ViewSOP: 'View SOP',
    Today: 'Today',
    Yesterday: 'Yesterday',
    DaysAgo: '{days} days ago',
    WeekAgo: '{weeks} week ago',
    WeeksAgo: '{weeks} weeks ago',
    Times: 'times',
    Opened: 'Opened',
    EarnedCertificateFor: 'Earned certificate for',
    FlaggedStepIn: 'Flagged step in',
    CompletedStepIn: 'Completed step in',
    Rated: 'Rated',

    // Onboarding.vue
    NothingMatchesThisPage: 'Nothing matches this page.',
    YouCanAddInfo: 'You can add information and make this page part of existing or new onboarding, by using the button below.',
    ShareAsEmail: 'Share as email',
    SubjectLabel: 'Subject:',
    EmailsCommaSeparated: 'Emails (comma separated)',
    SendEmail: 'Send Email',
    PreviewLink: 'Preview Link',
    PreviewLinkLabel: 'Preview Link:',
    SavePopupTitle: 'Save',
    TitleLabel: 'Title:',
    DescriptionLabel: 'Description',
    ExternalUrl: 'External Url',
    ManageNDomains: 'Manage {count} domains',
    SpaceLabel: 'Space:',
    OpenPreviewInNewTab: 'Open preview in new tab',
    Publish: 'Publish',
    SaveChangesToVersion: 'Save changes to v. {major}.{minor}',
    SaveChangesToNewDraft: 'Save changes to new draft',
    ManageDomains: 'Manage Domains',
    OpenOnboarding: 'Open Onboarding',
    SearchPlaceholder: 'Type something and hit enter...',
    ArtefactsDiscovered: 'Artefacts discovered',
    OnboardingsForThisUrl: 'Onboardings for this url',
    ViewInNewTab: 'View in new tab',
    GuideMode: 'Guide mode',
    AddStep: 'Add step',
    EditStep: 'Edit step',
    DeleteStep: 'Delete Step',
    AddOnboardingToSpaceTitle: 'Add onboarding to space',
    OnboardingProperties: 'Onboarding properties'
    ,
    // Spaces.vue
    PremiumSpace: 'Premium Space',
    PremiumSpaceDescription: 'This is a premium space that requires payment to access.',
    ProceedToPayment: 'Proceed to Payment',
    PropertiesTitle: 'Properties',
    ShareSpace: 'Share Space',
    AssignSpace: 'Assign Space',
    Verification: 'Verification',
    PleaseEnterYourEmail: 'Please enter your email.',
    EmailLabel: 'Email:',
    Send: 'Send',
    PinVerification: 'PIN Verification',
    CodeSentPrompt: 'We have just sent an email with a code. Please enter it below to proceed.',
    YourCode: 'Your code',
    DidntReceiveCode: "Didn't receive a code?",
    ClickHereToResend: 'Click here to resend',
    ClickHereToLogin: 'Click here to login.',
    Validate: 'Validate',
    CreateSubspace: 'Create subspace',
    CreateSpace: 'Create Space',
    NoDescriptionYet: 'This space has no description yet.',
    NoSubspacesHere: 'No subspaces here',
    NothingHere: 'Nothing here...',
    SOPs: 'SOPs',
    NoSOPsInThisSpace: 'No SOPs in this Space',
    NoSOPsInThisSpaceDesc: "This space doesn't have any Standard Operating Procedures (SOPs) yet. You can start capturing your processes using any of these methods:",
    SaveOnboardingOrder: 'Save onboarding order',
    SaveSubspaceOrder: 'Save subspace order',
    OnboardingsHeader: 'Onboardings',
    SubspacesHeader: 'Subspaces',
    GridView: 'Grid view',
    GoBack: 'Go back',
    PDFLinkedInFormat: 'PDF (LinkedIn Format)',
    HTMLFull: 'HTML Full',
    AssignSpaceToUser: 'Assign space to user',
    AddSubspace: 'Add subspace'
    ,
    // SpacesManage.vue (Space Manager)
    Link: 'Link',
    CreateSpaceTitle: 'Create Space',
    HideSpaceFromSidebar: 'Hide space from sidebar',
    ManageSpaces: 'Manage Spaces',
    ManageSpacesDescription: 'Use the commands below to manage spaces, assign users, and add onboardings to them.',
    CreateNewSpace: 'Create New Space',
    NoSpacesYet: 'No Spaces Yet',
    NoSpacesYetDescription: 'Get started by creating your first space to organize your onboardings.',
    CreateYourFirstSpace: 'Create Your First Space',
    OnboardingNoDescriptionYet: 'This onboarding has no description yet.',
    // App.vue
    NoPasswordWarning: 'Your account does not have a password.',
    CreatePasswordCTA: 'Click here to create one.',
    TCVelikTip: 'TCVelik Tip',
    RecommendExtensionText: 'We recommend using Chrome with the extension installed for best experience and contextual results. Click here to install it.',
    AutoLoginSuccessful: 'Auto-login successful',
    AutoLoginSuccessfulText: 'You have been automatically logged in via the TCVelik extension.',
    PasswordResetEmailSent: 'An email has been sent with a link to set a new password.',
    PleaseCheckInbox: 'Please check your inbox.',
    UserErrorPleaseLogin: 'There was an error with your user. Please login again.',
    LicenseWarningTitle: 'License Warning:',
    ManageLicenseCTA: 'Click here to manage your license.',
    // Cadence options
    Now: 'Now',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    Yearly: 'Yearly',
    SpecificDate: 'Specific date'
    ,
    // OnboardingScheduleComponent
    Reviewer: 'Reviewer',
    Cadence: 'Cadence',
    DateDue: 'Date Due',
    SetReviewCadence: 'Set the review cadence of this onboarding'
    ,
    // AssignComponent.vue
    AllUsers: 'All Users',
    AssignedUsers: 'Assigned Users',
    SuccessfullyAssignedItem: 'Successfully assigned this item.',
    NoSuchUserExists: 'No such user exists.',
    ProblemSharingOnboarding: 'A problem occurred while attempting to share this onboarding.',
    ErrorFetchingUsers: 'There were some errors fetching the users',
    SelectedUsers: 'Selected users',
    ZeroSelected: '0 selected'
    ,
    // AssignToRoleComponent.vue
    ErrorFetchingAssignedRoles: 'There were some errors fetching the assigned roles',
    ErrorFetchingRoles: 'There were some errors fetching the roles',
    NoSuchRoleExists: 'No such role exists.',
    ProblemAssigningItemToRole: 'A problem occurred while attempting to assign this item to the role.',
    SuccessfullyUnassignedItem: 'Successfully unassigned this item.'
    ,
    // AssignComponent placeholders
    SearchUserPlaceholder: 'Search user ...',
    SortByPlaceholder: 'Sort by...',
    OrderOfSortPlaceholder: 'Order of sort',
    FullNameHeader: 'Full Name',
    ActionsHeader: 'Actions'
    ,
    // LicensingCatalog.vue
    TCVelikLicensing: 'Licensing',
    ChoosePerfectPlan: 'Choose the perfect plan for your organization.',
    LicensingHelpText: 'If you have questions or need guidance on how our licensing works - please visit our',
    Website: 'website',
    Or: 'or',
    BookMeeting: 'book a meeting',
    WithUsDirectly: 'with us directly.',
    YourLicenses: 'Your Licenses',
    LicenseHolder: 'License Holder',
    Edition: 'Edition',
    RenewsAt: 'Renews at',
    Domain: 'Domain',
    NA: 'N/A',
    AvailableForUse: 'Available for use',
    UseThisLicense: 'Use This License',
    PurchaseAdditionalLicenses: 'Purchase additional licenses:',
    NoDescriptionAvailable: 'No description available',
    Here: 'here',
    LoadingLicensingOptions: 'Loading licensing options...',
    NoLicensingOptionsAvailable: 'No Licensing Options Available',
    NoLicensingOptionsText: 'There are currently no licensing options available. Please contact support.',
    ActivateLicense: 'Activate License',
    EnterEmailToActivate: 'Please enter your email address to activate this license:',
    EmailPlaceholder: 'your.email@example.com',
    EmailAddress: 'Email Address',
    Cancel: 'Cancel',
    Processing: 'Processing...',
    OnlyAvailableOnPersonal: 'Only available on personal.tcvelik.com',
    FreeForever: 'Free forever',
    ContactSales: 'Contact Sales',
    NoCreditCardRequired: 'No credit card required',
    Per: 'per',
    OneTimePayment: 'One-time payment',
    PurchaseNow: 'Purchase Now',
    YouAndYourTeamCanDownload: 'You and your team can download and use TCVelik Personal Edition',
    FailedToLoadProducts: 'Failed to load licensing products',
    NoPricingAvailable: 'No Pricing Available',
    NoPricingOptionsText: 'This product has no pricing options',
    SelectionRequired: 'Selection Required',
    PleaseSelectPricing: 'Please select a pricing option',
    FailedToCreatePaymentLink: 'Failed to create payment link. Please try again.',
    InvalidEmail: 'Invalid Email',
    PleaseEnterValidEmail: 'Please enter a valid email address',
    LicenseActivated: 'License Activated!',
    LicenseActivatedSuccess: 'Your license has been successfully activated.',
    ActivationFailed: 'Activation Failed',
    FailedToActivateLicense: 'Failed to activate license. Please try again.',
    LicenseSwitched: 'License Switched!',
    LicenseSwitchedSuccess: 'You are now using a different license. The previous domain will stop working within 2 hours.',
    SwitchFailed: 'Switch Failed',
    FailedToSwitchLicense: 'Failed to switch license. Please try again.',
    SwitchLicenseConfirmation: 'Are you sure you want to switch to the {product} license?\n\n⚠️ Important: This will make your current license unavailable on this domain for up to 2 hours due to caching. The other domain will stop working temporarily.\n\nDo you want to continue?',
    Renewed: 'Renewed',
    RenewsToday: 'Renews today',
    RenewsTomorrow: 'Renews tomorrow',
    RenewsInDays: 'Renews in {days} days',
    Expired: 'Expired',
    ExpiresToday: 'Expires today',
    ExpiresTomorrow: 'Expires tomorrow',
    ExpiresInDays: 'Expires in {days} days',

    // Search.vue
    BasicSearch: 'Basic Search',
    Results: 'results',
    FoundNothing: 'found nothing.',
    NoResults: 'No results',
    SearchReturnedNoResults: 'The search returned no results.',
    KeepTrying: 'Keep trying...',
    WorkingSearch: 'Working ...',
    ResultsComingShortly: 'Results coming shortly ...',
    IntentFilters: 'Intent Filters:',
    ShowAll: 'Show All',
    ClearAll: 'Clear All',
    Filter: 'Filter',
    SuccessNotification: 'Success!',
    TextCopiedSuccessfully: 'Text copied successfully.',
    Failed: 'Failed!',
    ErrorInCopyingText: 'Error in copying text.',

    // AccountBranding.vue
    AccountBranding: 'Account Branding',
    Favicon: 'Favicon',
    ChangedIcon: 'Changed icon.',
    ProblemSavingIcon: 'There was a problem saving your icon.',
    Saved: 'Saved',

    // AdminControlPanel.vue
    CreateWebhook: 'Create Webhook',
    Database: 'Database',
    SystemSettings: 'System settings',
    ChangeLanguage: 'Change language',
    CreateMagicLink: 'Create a magic link',
    Webhooks: 'Webhooks',
    CreateEmbedScript: 'Create an embed script for execution',
    EventType: 'Event type',
    FilterByRoles: 'Filter by roles',
    MagicLink: 'Magic link',
    CampaignName: 'Campaign Name',
    ExistingMagicLinkTokens: 'Existing Magic Link Tokens',
    LoadTokens: 'Load Tokens',
    DateCreated: 'Date Created',
    TargetURL: 'Target URL',
    RoleToken: 'Role Token',
    CopyLink: 'Copy Link',
    LoadingMagicLinkTokens: 'Loading magic link tokens...',
    CreateWebhookButton: 'Create webhook',
    FormatDocument: 'Format Document',
    SuccessfullyUpdatedSettings: 'Successfully updated settings.',
    ProblemOccurredDownloading: 'A problem occurred while downloading the database.',
    ProblemOccurredSaving: 'A problem occurred while attempting to save changes.',
    ProblemOccurredCreating: 'A problem occurred while attempting to create a webhook.',
    ProblemOccurredFetching: 'A problem occurred while attempting to fetch the webhooks.',
    ProblemOccurredDeleting: 'A problem occurred while attempting to delete this webhook.',
    ProblemOccurredLoading: 'A problem occurred while attempting to load the inject script\'s code.',
    SuccessfullyCreatedMagicLink: 'Successfully created magic link.',
    SuccessfullyCreatedWebhook: 'Successfully created webhook.',
    SuccessfullyDeletedWebhook: 'Successfully deleted webhook.',
    FailedToLoadMagicLinkTokens: 'Failed to load magic link tokens',
    LinkCopiedToClipboard: 'Link copied to clipboard',
    
    // Additional notification messages
    SuccessExclamation: 'Success!',
    SuccessfullyDeletedSubspace: 'Successfully deleted subspace!',
    ProblemOccurredDeletingSubspace: 'A problem occurred while attempting to delete this subspace!',
    InvalidPassword: 'Invalid password',
    NoAccessToResource: 'No access to this resource',
    NoAccessToResourceText: 'It looks like you are trying to access this article with an email that does not have access. If you believe this is a mistake - please contact the person that shared it.',
    CodeSentToEmail: 'A code has been sent to your email.',
    CodeAlreadySentToEmail: 'A code has already been sent to your email.',
    SavedOrderOfOnboardings: 'Saved order of onboardings',
    FailedToSaveOrder: 'Failed to save order.',
    SavedOrderOfSubspaces: 'Saved order of subspaces',
    LinkSent: 'Link sent',
    SomethingWentWrongSendingLink: 'Something went wrong while attempting to send the link...',
    CouldNotLoadSpaceDetails: 'Could not load space details',
    FailedToLoadSpaceInformation: 'Failed to load space information',
    SavedChanges: 'Saved changes',
    ProblemAddingImage: 'There was a problem adding your image.',
    TCVelikContentPasted: 'TCVelik content pasted',
    StepsAddedSuccessfully: '{count} step(s) added successfully',
    CursorNotInsideCustomNode: 'Cursor is not inside a custom node.',
    SOPFormatExport: 'SOP Format Export',
    SOPFormatExportComingSoon: 'SOP format export functionality will be implemented soon!',
    SuccessfullySavedImage: 'Successfully saved image!',
    DocumentFormatted: 'Document formatted',
    UserHasBeenDeleted: 'User has been deleted',
    SomethingWentWrongDeletingUser: 'Something went wrong while attempting to delete this user...',
    CannotGeneratePreviewForUnsavedOnboarding: 'Cannot generate preview for unsaved onboarding!',
    CameraNotAllowed: 'Camera not allowed. Please allow access.',
    ErrorAccessingCamera: 'Error accessing camera.',
    PleaseOpenAnOnboarding: 'Please open an onboarding',
    OnboardingNotSavedCannotBeShared: 'Onboarding has not been saved and cannot be shared',
    DraftDeleted: 'Draft Deleted',
    ErrorOccurredDeletingDraft: 'An error occurred while attempting to delete this draft.',
    OnboardingDeleted: 'Onboarding Deleted',
    ErrorOccurredDeletingOnboarding: 'An error occurred while attempting to delete this onboarding.',
    InvalidURL: 'Invalid URL',
    PleaseFillInValidURL: 'Please fill in a valid URL',
    OnboardingWasSaved: '{name} was saved.',
    SuccessfullyCreatedAndAddedOnboardingToSpace: 'Successfully created and added onboarding to Space!',
    DomainLabelsHaveBeenApplied: 'Domain labels have been applied.',
    
    // Navbar and Sidebar localization
    GetTheExtention:"Get the extension",
    SearchWithAI: 'Search with AI',
    SearchPlaceholderNavbar: 'Search...',
    ManageUsers: 'Manage Users',
    Skills: 'Skills',
    Focus: 'Focus',
    AnalysisCompleted: 'Analysis completed',
    ProjectWasAnalyzed: 'Project {projectName} was analyzed.',
    AnalysisStarted: 'Analysis started',
    AnalysisWithTitle: 'Analysis {title}',
    UserDoesNotHaveSlug: 'This user does not have a slug, please go to Account Admin and update user slug.',
    YearsAgo: '{years} {yearsText} ago',
    YearAgo: '{years} Year ago',
    DaysAgoSidebar: '{days} {daysText} ago',
    DayAgo: '{days} Day ago',
    HoursAgo: '{hours} {hoursText} ago',
    HourAgo: '{hours} Hour ago',
    MinutesAgo: '{minutes} {minutesText} ago',
    MinuteAgo: '{minutes} Min ago',
    SecondsAgo: '{seconds} sec ago',
    JustNow: 'Just Now',
    Years: 'Years',
    Days: 'Days',
    Hours: 'Hrs',
    Min: 'Min',
    NoInfo: 'No info',
    UnknownAccount: 'Unknown account',
    English: 'English',
    Portuguese: 'Portuguese',
    French: 'French',
    German: 'German',
    DownloadDatabase: 'Download Database',
    DownloadVersionHistoryDatabase: 'Download Version History Database',
    SaveChanges: 'Save changes',
    NoMagicLinkTokensFound: 'No magic link tokens found.',
    SafelyReloading: 'Safely reloading page...',

    // NoItemsCard.vue
    NoSOPsAvailable: 'No SOPs Available',
    NoSOPsAvailableDescription: 'It looks like there are no Standard Operating Procedures (SOPs) in your account yet. You can start capturing your processes using any of these methods:',
    SubspacesDescription: 'TCVelik provides the ability for you to further group your item via the ability to create subspaces within spaces.',
    ManualCreation: 'Manual Creation',
    ManualCreationDescription: 'Create SOPs step by step using our manual editor',
    ChromeExtension: 'Chrome Extension',
    ChromeExtensionDescription: 'Install our browser extension for seamless recording while you work',
    DesktopRecorder: 'Desktop Recorder',
    DesktopRecorderDescription: 'Use our desktop application for advanced screen recording',
    MobileRecording: 'Mobile Recording',
    MobileRecordingDescription: 'Record physical world SOPs with your mobile phone - no app required',
    MoreInformationText: 'More information on capturing your SOPs can be found',

    // Login.vue and Register.vue notifications
    WelcomeAdminCreated: '🎉 Welcome! Your admin account has been created successfully.',
    PleaseLoginWithCredentials: 'Please log in with your credentials to access the system.',
    LinkedInAuthentication: 'LinkedIn Authentication',
    ConnectingToLinkedIn: 'Connecting to LinkedIn...',
    LoginFailed: 'Login Failed',
    LinkedInAuthNotConfigured: 'LinkedIn authentication service is not properly configured.',
    CannotConnectLinkedIn: 'Cannot connect to LinkedIn authentication service.',
    LoginAttempt: 'Login Attempt',
    AlreadyLoggedIn: 'You are already logged in!',
    CreateAccount: 'Create Account',
    WelcomeToTCVelik: '🎉 Welcome to TCVelik! This is your first time setup.',
    YouWillBeAdmin: 'You will be created as the Administrator of this system.',
    FillFormToCreateAccount: 'Fill the below form to create a new account.',
    AcceptTermsConditions: 'I accept the terms & conditions.',
    RegistrationInProgress: 'Registration in progress!',
    PleaseWait: 'Please wait..',
    AdminAccountCreatedSuccessfully: 'Admin account created successfully! Please log in to continue.',
    AccountCreatedRedirecting: 'Account created. Redirecting you to login..',
    AccountNotCreated: 'Account not created.',

    // ImageUploadPopup.vue
    UploadImage: 'Upload Image',
    DragDropImageOrClick: 'Drag & drop an image here, or click to select',
    Preview: 'Preview',
    OR: 'OR',
    EnterImageURL: 'Enter image URL',
    Submit: 'Submit',

    // GenericProgressPopup.vue
    YourTypeIsInProgress: 'Your {type} is in progress',
    ContinueWorkingFileWillDownload: 'You can continue working. Once ready - the file will be automatically downloaded.',
    Step: 'Step',

    // CameraStepScreen.vue
    Capture: 'Capture',
    Done: 'Done',
    ImagesCaptured: '{count} images captured',
    SaveSteps: 'Save Steps',
    StepImage: 'Step image',
    StepTitle: 'Step Title',
    StepDescription: 'Step Description',
    BrowserNotSupportCamera: "Your browser doesn't support camera access.",

    // OnboardingAnalytics.vue
    ResolveFlaggedStepTitle: 'Resolve Flagged Step',
    CommentLabel: 'Comment',
    NotifyReporter: 'Notify the person who reported this',
    MarkAsResolved: 'Mark as Resolved',
    SaveSearchQueryTitle: 'Save Search Query',
    NameLabel: 'Name',
    UrlLabel: 'URL',
    EditSearchQueryTitle: 'Edit Search Query',
    FilterBySpaces: 'Filter by Spaces',
    FilterByOnboardings: 'Filter by Onboardings',
    DateRange: 'Date Range',
    SaveThisSearchQuery: 'Save This Search Query',
    SaveFilters: 'Save Filters',
    Options: 'Options',
    DeleteThisSearchQuery: 'Delete This Search Query',
    EditNameAndUrl: 'Edit Name and URL',
    EditFilters: 'Edit Filters',
    TotalSOPs: 'Total SOPs',
    TotalUsers: 'Total Users',
    CompletionRate: 'Completion Rate',
    InProgressLabel: 'In Progress',
    NotStarted: 'Not Started',
    EstimatedHoursSaved: 'Estimated Hours Saved',
    DocumentationRequests: 'Documentation Requests',
    FlaggedSteps: 'Flagged Steps',
    UsersCompletedMostOnboardings: 'Users Who Completed Most Onboardings',
    CompletedCountForPeriod: 'Completed {count} onboardings for this period',
    NoDataForThisOnboarding: 'No data for this onboarding',
    SOPStats: 'SOP Stats',
    RatingsCount: '{count} ratings',
    EstimatedHoursSavedShort: '{hours} hours saved',
    NoItemsToShow: 'No items to show',
    ErrorFetchingData: 'There was an error fetching the data',
    ResolvedStep: 'Step has been resolved',
    ProblemResolvingStep: 'A problem occurred while resolving this step',
    ErrorFetchingHeatmap: 'There was an error fetching the heatmap data',
    SavedQuery: 'Search query saved successfully',
    ProblemSavingQuery: 'A problem occurred while saving the query',
    DeletedQuery: 'Search query deleted successfully',
    SavedChangesGeneric: 'Changes saved successfully',
    ProblemSavingFilters: 'A problem occurred while saving the filters',

    // Users.vue
    UsersTitle: 'Users',
    InviteUser: 'Invite User',
    Invitations: 'Invitations',
    Suggestions: 'Suggestions',

    // InviteUserModal.vue
    InviteUserTitle: 'Invite User',
    EmailAddressLabel: 'Email Address',
    EmailPlaceholderUser: 'user@example.com',
    SelectRoles: 'Select Roles',
    CustomMessagePlaceholder: 'Optional: Add a personal message...',
    CustomMessageLabel: 'Custom Message (Optional)',
    LinkExpirationLabel: 'Link Expiration (hours)',
    ExpirationPlaceholder: '120',
    AllowUserRegistration: 'Allow user to register if they don\'t exist',
    Sending: 'Sending...',
    SendInvitation: 'Send Invitation',
    FailedToLoadRoles: 'Failed to load roles',
    RoleCreatedSuccessfully: 'Role created successfully',
    RoleAlreadyExists: 'A role with this name already exists',
    FailedToCreateRole: 'Failed to create role',
    InvitationSentSuccessfully: 'Invitation sent successfully for {count} role(s).',
    FailedToSendInvitation: 'Failed to send invitation',

    // InvitationList.vue
    InvitationLinkTitle: 'Invitation Link',
    UseThisLinkToInvite: 'Use this link to invite the user.',
    EmailHeader: 'Email',
    RolesHeader: 'Roles',
    CreatedHeader: 'Created',
    ExpiresHeader: 'Expires',
    StatusHeader: 'Status',
    VisitsHeader: 'Visits',
    InvitedByHeader: 'Invited By',
    ExpiredStatus: 'Expired',
    ActiveStatus: 'Active',
    LastVisit: 'Last:',
    InvitationGroup: 'Invitation',
    CopyLinkAction: 'Copy Link',
    ResendEmailAction: 'Resend Email',
    ErrorLoadingInvitations: 'Error loading invitations',
    InvitationLinkCopied: 'Invitation link copied successfully.',
    ResendInvitationConfirm: 'Resend invitation email to {email}?',
    InvitationResent: 'Invitation resent',
    ErrorResendingInvitation: 'Error resending invitation',

    // UserList.vue
    LoginLinkTitle: 'Log in link',
    UseThisLinkToSignIn: 'Use the link to sign in as this user.',
    LastLoginHeader: 'Last Login',
    RoleHeader: 'Role',
    SourceHeader: 'Source',
    NotAvailable: 'N/A',
    EditGroup: 'Edit',
    EditAction: 'Edit',
    DeleteAction: 'Delete',
    SendLoginLinkAction: 'Send login link',
    ResetPasswordAction: 'Reset password',
    AscendingSort: 'Ascending',
    DescendingSort: 'Descending',
    LastLoginDateSort: 'Last login date',
    CreatedSort: 'Created',
    ProblemsSavingChanges: 'There were some problems saving your changes.',
    ResetPasswordConfirm: 'Reset this user\'s password?',
    ResetPasswordError: 'Reset password',
    SendLoginLinkConfirm: 'Send a login link?',
    DeleteUserConfirm: 'Are you ABSOLUTELY SURE, this action cannot be undone!',

    // UserEditorScreen.vue
    EditUserTitle: 'Edit User',
    AddNewUserTitle: 'Add new user',
    UploadImageTitle: 'Upload image',
    CreateUserTab: 'Create User',
    AddUserToRoleTab: 'Add User to Role',
    ChangePasswordTab: 'Change Password',
    APIAccessTab: 'API Access',
    InviteUserTab: 'Invite User',
    FirstNameLabel: 'First Name',
    LastNameLabel: 'Last Name',
    NewPasswordLabel: 'New password',
    ConfirmPasswordLabel: 'Confirm password',
    APIKeyLabel: 'API Key',
    ManageRoles: 'Manage roles',
    SaveButton: 'Save',
    CreateUserButton: 'Create user',
    ChangeButton: 'Change',
    ResetAPIKeyButton: 'Reset API Key',
    GenerateNewButton: 'Generate new',
    InviteButton: 'Invite',
    AddedRole: 'Added role.',
    RoleNameAlreadyExists: 'A Role with this name already exists.',
    ChangedAvatar: 'Changed avatar.',
    ProblemSavingAvatar: 'There was a problem saving your avatar.',
    UserInvited: '{email} was invited. Keep adding.',
    SuccessfullyCreatedUser: 'Successfully created user!',
    ProblemCreatingUser: 'A problem occurred while attempting to create user.',
    GeneratedAPIKey: 'Generated API key.',
    ProblemGeneratingAPIKey: 'Something went wrong while attempting to generate an API key...',
    ResetAPIKey: 'Reset API key.',
    ProblemResettingAPIKey: 'Something went wrong while attempting to reset the API key...',
    PasswordResetEmailSentUserEditor: 'If your email is in our system - you will receive a password reset email.',
    GenerateAPIKeyConfirm: 'Generate an API key for this user?',
    ResetAPIKeyConfirm: 'Reset the API key for this user?'
  },
  de: {
    Dashboard: 'Instrumententafel',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Machen',
    Chat: 'Plaudern',
    Email: 'Email',
    Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
    Shop: 'Geschäft',
    Cart: 'Wagen',
    WishList: 'Wunschzettel',
    Checkout: 'Auschecken',
    UIElements: 'Elemente der Benutzeroberfläche',
    DataList: 'Datenliste',
    ListView: 'Listenansicht',
    ThumbView: 'Daumenansicht',
    Grid: 'Gitter',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Farben',
    Card: 'Karte',
    Basic: 'Basic',
    Statistics: 'Statistiken',
    Analytics: 'Analytics',
    CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
    Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
    Components: 'Komponenten',
    Alert: 'Warnen',
    Avatar: 'Benutzerbild',
    Badge: 'Abzeichen',
    Breadcrumb: 'Breadcrumb',
    Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
    Chip: 'Chip',
    Collapse: 'Zusammenbruch',
    Dialogs: 'Dialoge',
    Divider: 'Teiler',
    DropDown: 'Dropdown-Liste',
    List: 'Liste',
    Loading: 'Wird geladen',
    Navbar: 'Navbar',
    Notifications: 'Benachrichtigungen',
    Pagination: 'Seitennummerierung',
    Popup: 'Pop-up',
    Progress: 'Fortschritt',
    Sidebar: 'Seitenleiste',
    Slider: 'Schieberegler',
    Tabs: 'Tabs',
    Tooltip: 'QuickInfo',
    Upload: 'Hochladen',
    FormsAndTable: 'Formulare und Tabelle',
    FormElements: 'Formularelemente',
    Select: 'Wählen',
    Switch: 'Schalter',
    Checkbox: 'Ankreuzfeld',
    Radio: 'Radio',
    Input: 'Eingang',
    NumberInput: 'Nummer eingeben',
    Textarea: 'Textbereich',
    FormLayouts: 'Formularlayouts',
    FormWizard: 'Formzauberer',
    FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    Password: 'Password',
    ForgotPassword: 'Passwort vergessen',
    ResetPassword: 'Passwort zurücksetzen',
    Reset: 'Zurücksetzen',
    RecoverPassword: 'Recover Password',
    ConfirmPassword: 'Passwort bestätigen',
    RememberMe: "Remember me",
    LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
    ComingSoon: 'Demnächst',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Nicht berechtigt',
    ToggleFullscreen: 'Vollbild umschalten',
    SomethingIsntQuiteRight: 'Etwas stimmt nicht ganz',
    // OnboardingPDF Tour
    SopTitleTour: 'Dies ist der Titel Ihres SOP. Hier sehen Sie Name und Beschreibung.',
    StepsTour: 'Dies sind Ihre Schritte. Klicken Sie auf die Überschrift, um den Inhalt ein-/auszuklappen.',
    ToolsTour: 'Verwenden Sie diese Schaltflächen, um Schritte abzuschließen oder zur Überprüfung zu markieren.',
    MenuTour: 'Schließlich finden Sie hier Aktionen für das Onboarding sowie weitere erweiterte Optionen.',
    // OnboardingPDF.vue additions (de)
    VerifyYourEmail: 'E-Mail verifizieren',
    VerificationCode: 'Verifizierungscode',
    PleaseEnterYourEmailVerification: 'Bitte geben Sie Ihre E-Mail ein, um fortzufahren.',
    WeHaveJustSentEmailWithPin: 'Wir haben soeben eine E-Mail mit einem PIN gesendet. Bitte geben Sie ihn unten ein, um fortzufahren.',
    Code: 'Code',
    ViewAsSlideshow: 'Als Diashow anzeigen',
    RecordedWith: 'Aufgezeichnet mit',
    ClickLinkBetterExperience: 'Klicken Sie auf den Link für ein besseres Erlebnis',
    ExternalContentMessage: 'Dieser Schritt verweist auf externe Inhalte. Sie werden auf eine externe Seite weitergeleitet.',
    IUnderstandProceed: 'Ich verstehe, fortfahren',
    ImageView: 'Bildansicht',
    GuestUsersViewOnly: 'Gastnutzer können Inhalte nur ansehen.',
    ProblemCompletingStep: 'Beim Abschließen dieses Schritts ist ein Problem aufgetreten.',
    OnboardingSharedSuccessfully: 'Onboarding erfolgreich geteilt.',
    ErrorsSharingOnboarding: 'Beim Teilen dieses Onboardings sind Fehler aufgetreten.',
    FieldCannotBeEmpty: 'Dieses Feld darf nicht leer sein',
    SuccessfullyAddedToSpace: 'Erfolgreich zum Bereich hinzugefügt.',
    ProblemAddingToSpace: 'Problem beim Hinzufügen zum Bereich.',
    SuccessfullyRemovedFromSpace: 'Erfolgreich aus dem Bereich entfernt.',
    ProblemRemovingFromSpace: 'Problem beim Entfernen aus dem Bereich.',
    SendLoginLink: 'Anmeldelink senden?',
    ProblemSendingLink: 'Problem beim Senden des Links.',
    PageBeingConverted: 'Seite wird konvertiert...',
    ProblemConvertingToPDF: 'Problem beim Konvertieren in PDF.',
    PageCannotBeAccessed: 'Auf diese Seite kann nicht zugegriffen werden.',
    InvalidLink: 'Ungültiger Link.',
    NoAccessEmailMessage: 'Kein Zugriff für diese E-Mail. Bitte wenden Sie sich an den Absender.',
    EditorNotFound: 'Editor nicht gefunden',
    CopyToClipboard: 'In die Zwischenablage kopieren',
    ExpandStepContents: 'Schrittinhalt erweitern',
    CollapseStepContent: 'Schrittinhalt reduzieren',
    MarkStepCompleted: 'Schritt als abgeschlossen markieren',
    Fullscreen: 'Vollbild',
    FlagThisStep: 'Diesen Schritt markieren',
    AddCommentToStep: 'Diesen Schritt markieren',
    ContentMissingOrNoPermissions: 'Der gesuchte Inhalt fehlt oder Sie haben keine Berechtigung darauf zuzugreifen.',
    SubmitFeedbackIfError: 'Wenn Sie glauben, dass dies ein Fehler ist - senden Sie Feedback.',
    BackToHome: 'Zurück zur Startseite',
    LoginAndRetry: 'Anmelden und erneut versuchen',
    Maintenance: 'Instandhaltung',
    Profile: 'Profil',
    Invoice: 'Rechnung',
    FAQ: 'FAQ',
    Search: 'Suche',
    KnowledgeBase: 'Wissensbasis',
    ChartsAndMaps: 'Diagramme und Karten',
    Charts: 'Diagramme',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Karte',
    Extensions: 'Erweiterungen',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Ziehen und loslassen',
    Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
    AccessControl: 'Zugangskontrolle',
    EditorView: 'Editoransicht',
    AdminView: 'Admin View',
    I18n: 'I18n',
    Carousel: 'Karussell',
    Clipboard: 'Zwischenablage',
    ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    Others: 'Andere',
    MenuLevels: 'Menüebenen',
    MenuLevel2p1: 'Menüebene 2.1',
    MenuLevel2p2: 'Menüebene 2.2',
    MenuLevel3p1: 'Menüebene 3.1',
    MenuLevel3p2: 'Menüebene 3.2',
    DisabledMenu: 'Deaktiviertes Menü',
    Support: 'Unterstützung',
    Documentation: 'Dokumentation',
    RaiseSupport: 'Unterstützung erheben',
    demoTitle: 'Kartentitel',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.',
    Record: 'Record',
    Open: 'Open',
    Save: 'Save',
    Share: 'Сподели',
    SOPEditor: 'SOP Editor',
    DiscoverImprove: 'Discover & Improve',
    Spaces: 'Spaces',
    SpaceManager: 'Space Manager',
    Latest: 'Latest',
    MostUseful: 'Most useful',
    TailoredForYou: 'Tailored for you',
    Browse: 'Browse',
    Logout: 'Logout',
    MarkAsComplete: 'Mark as Complete',
    COMPLETED: "COMPLETED",
    Yes: "Yes",
    No: "No",
    Next: "Next",
    Back: "Back",
    Folders: 'Folders',
    BackToLogin: "Обратно към Login",
    //FEEDBACK CARD SPECIFIC(FeedbackCard.vue)
    FeedbackTitle: "We'd love your feedback",
    RateTitle: "How would you rate this SOP overall?",
    SaveTimeTitle: "Did this SOP save you time?",
    SaveTimeDescription: "Understanding time saved helps us prioritize improvements.",
    SaveTimeApproxTitle: "Approximately how much time did it save?",
    SaveTimeApproxDescription: "Rough estimate is fine - this helps us understand impact.",
    LessThanAnHour: "Less than 1 hour",
    OneToTwoHours: "1-2 hours",
    TwoToFourHours: "2-4 hours",
    MoreThanFourHours: "More than 4 hours",
    NotSure: 'Not sure',
    AlreadyKnowHowTitle: "Did you already know how to do this?",
    AlreadyKnowHowDescription: "This helps us understand if we're adding value beyond existing knowledge.",
    DocumentationBetterTitle: "Was our documentation better than what you knew?",
    RecommendSOPTitle: "Would you recommend this SOP to others?",
    RecommendSOPDescriptiion: "This helps us understand the overall effectiveness.",
    SOPEasyToFollowTitle: "Was this SOP easy to follow?",
    CommentsTitle: "Comments or suggestions for improvement?",
    CommentsDescription: "Optional: Any additional feedback helps us improve.",
    CommentTextAreaPlaceholder: "Tell us what could be better...",
    SubmitFeedbackButtonText: "Submit Feedback",
    PopupFeedbackCompletionText: "Thank you for your feedback!",

    //FORGOTTEN PASSWORD SPECIFIC (ForgottenPassword.vue)
    RecoverYourPassword: 'Recover your password',
    RecoverYourPasswordInstuctions: 'Please enter your email address and we\'ll send you instructions on how to reset your password.',
    RecoverPasswordMessage: 'If your email is in our system - you will receive a password reset email.',

    //ResetPassword.vue
    ResetPasswordPrompt: "Please enter your new password.",

    // SOPEditorMenu
    File: 'Datei',
    Import: 'Importieren',
    Export: 'Exportieren',
    ExportAs: 'Exportieren als...',
    DownloadAsPPTX: 'Als PPTX herunterladen',
    TCVelikSOPFormat: 'TCVelik SOP Format',
    AddToSpace: 'Zu Space hinzufügen',
    OpenReviewMenu: 'Review-Menü öffnen',
    GeneratePreviewLink: 'Vorschau-Link generieren',
    Delete: 'Löschen',
    Close: 'Schließen',
    Edit: 'Bearbeiten',
    Undo: 'Rückgängig',
    Redo: 'Wiederholen',
    SelectAll: 'Alles auswählen',
    View: 'Ansicht',
    HTMLSource: 'HTML-Quelle',
    Tools: 'Werkzeuge',
    Properties: 'Eigenschaften',
    Assign: 'Zuweisen',
    AssignToRole: 'Rolle zuweisen',
    EditIntent: 'Intent bearbeiten',
    ExitEditor: 'Editor schließen',
    Menu: 'Menü',

    // MainToolbar and Components
    // AlignmentButtons
    AlignLeft: 'Linksbündig',
    AlignCenter: 'Zentriert',
    AlignRight: 'Rechtsbündig',
    // TextFormattingButtons
    Heading: 'Überschrift',
    Paragraph: 'Absatz',
    Bold: 'Fett',
    Italic: 'Kursiv',
    Underline: 'Unterstrichen',
    // ListButtons
    BulletList: 'Aufzählungsliste',
    NumberedList: 'Nummerierte Liste',
    ManualSteps: 'Manuelle Schritte',
    DefaultManual: 'Standard',
    Warning: 'Warnung',
    Success: 'Erfolg',
    Informational: 'Informativ',
    CameraPicture: 'Kamera',
    CodeStep: 'Code',
    ErrorStep: 'Fehler',
    Image: 'Bild',
    Line: 'Linie',
    // ContentButtons
    AddLink: 'Link hinzufügen',
    AddImage: 'Bild hinzufügen',
    // AdvancedButtons
    EditHTML: 'HTML bearbeiten',
    // LineManagementButtons
    AddBlankLineAbove: 'Leere Zeile oberhalb hinzufügen',
    AddBlankLineBelow: 'Leere Zeile unterhalb hinzufügen',
    // FileOperationsButtons
    ShareOnboarding: 'Onboarding teilen',
    AssignOnboarding: 'Onboarding zuweisen',
    AssignToRoleTitle: 'Rolle zuweisen',
    OpenPropertiesMenu: 'Eigenschaften',
    DeleteOnboarding: 'Onboarding löschen',

    // SignalsView.vue
    SignalsManagement: 'Signalverwaltung',
    QuickFilters: 'Schnellfilter',
    System: 'System',
    Action: 'Aktion',
    UserEmail: 'Benutzer-E-Mail',
    ProcessedStatus: 'Verarbeitungsstatus',
    All: 'Alle',
    Processed: 'Verarbeitet',
    Unprocessed: 'Unverarbeitet',
    Refresh: 'Aktualisieren',
    ManageFilters: 'Filter verwalten',
    ManageTags: 'Tags verwalten',
    ApplyTags: 'Tags anwenden',
    CreateTestSignal: 'Testsignal erstellen',
    Context: 'Kontext',
    SOPHint: 'SOP-Hinweis',
    Created: 'Erstellt',
    Tags: 'Tags',
    ViewDetails: 'Details anzeigen',
    EditTags: 'Tags bearbeiten',
    Showing: 'Anzeige',
    to: 'bis',
    of: 'von',
    signals: 'Signale',
    CreateNewFilter: 'Neuen Filter erstellen',
    Name: 'Name',
    Field: 'Feld',
    Operation: 'Operation',
    Value: 'Wert',
    CreateFilter: 'Filter erstellen',
    FilterName: 'Filtername',
    Description: 'Beschreibung',
    SelectField: 'Feld auswählen',
    SelectOperation: 'Operation auswählen',
    SecondValue: 'Zweiter Wert',
    CreateNewTag: 'Neues Tag erstellen',
    Color: 'Farbe',
    CreateTag: 'Tag erstellen',
    TagName: 'Tag-Name',
    ColorHex: 'Farbe (Hex)',
    ApplyTagsToSignals: 'Tags auf Signale anwenden',
    SelectFilters: 'Filter auswählen',
    SelectFiltersToApply: 'Filter zum Anwenden auswählen',
    SelectTags: 'Tags auswählen',
    SelectTagsToApply: 'Tags zum Anwenden auswählen',
    FilterCreatedSuccessfully: 'Filter erfolgreich erstellt',
    FailedToCreateFilter: 'Filter konnte nicht erstellt werden',
    TagCreatedSuccessfully: 'Tag erfolgreich erstellt',
    FailedToCreateTag: 'Tag konnte nicht erstellt werden',
    FailedToLoadSignals: 'Signale konnten nicht geladen werden',
    FailedToApplyTags: 'Tags konnten nicht angewendet werden',
    TestSignalCreatedSuccessfully: 'Testsignal erfolgreich erstellt',
    FailedToCreateTestSignal: 'Testsignal konnte nicht erstellt werden',

    // SuggestionsList.vue
    SuggestedUsers: 'Vorgeschlagene Benutzer',
    SignalCount: 'Signalanzahl',
    LastActivity: 'Letzte Aktivität',
    AlreadyInvited: 'Bereits eingeladen',
    NewLabel: 'Neu',
    InvitationSent: 'Einladung gesendet',
    ReadyToInvite: 'Bereit zum Einladen',
    ForceProcess: 'Verarbeitung erzwingen',
    FailedToLoadSuggestedUsers: 'Vorgeschlagene Benutzer konnten nicht geladen werden',
    ProcessedSignals: '{count} Signale verarbeitet',
    FailedToProcessSignals: 'Signale konnten nicht verarbeitet werden',

    // Profile.vue
    Hey: 'Hallo',
    Stranger: 'Fremder',
    SOPsOpened: 'SOPs geöffnet',
    SOPsCompleted: 'SOPs abgeschlossen',
    StepsCompleted: 'Schritte abgeschlossen',
    RatingsGiven: 'Bewertungen abgegeben',
    CertificatesEarned: 'Zertifikate erhalten',
    Filters: 'Filter',
    Position: 'Position',
    Manager: 'Manager',
    Supervisor: 'Supervisor',
    Status: 'Status',
    Completed: 'Abgeschlossen',
    Pending: 'Ausstehend',
    ManagerPosition: 'Manager-Position',
    SupervisorPosition: 'Supervisor-Position',
    Completion: 'Abschluss',
    OpeningProcedures: 'Öffnungsverfahren',
    ClosingProcedures: 'Schließverfahren',
    SafetyProtocol: 'Sicherheitsprotokoll',
    EmployeeTraining: 'Mitarbeiterschulung',

    // UserJourneyTimeline.vue
    YourJourney: 'Ihre Reise',
    Last7Days: 'Letzte 7 Tage',
    Last30Days: 'Letzte 30 Tage',
    Last90Days: 'Letzte 90 Tage',
    LastYear: 'Letztes Jahr',
    LoadingYourJourney: 'Ihre Reise wird geladen...',
    FailedToLoadJourneyTimeline: 'Fehler beim Laden Ihrer Reise-Timeline. Bitte versuchen Sie es erneut.',
    TryAgain: 'Erneut versuchen',
    NoActivityYet: 'Noch keine Aktivität',
    JourneyTimelineWillAppear: 'Ihre Reise-Timeline wird hier angezeigt, sobald Sie mit SOPs interagieren.',
    Resolved: 'Gelöst',
    PendingResolution: 'Lösung ausstehend',
    Reason: 'Grund',
    Resolution: 'Lösung',
    StepCompletedSuccessfully: 'Schritt {stepId} erfolgreich abgeschlossen',
    Stars: 'Sterne',
    Comment: 'Kommentar',
    Helpful: 'Hilfreich',
    SavedMinutes: '{minutes} Minuten gespart',
    AlreadyKnewThis: 'Das wusste ich bereits',
    ViewSOP: 'SOP anzeigen',
    Today: 'Heute',
    Yesterday: 'Gestern',
    DaysAgo: 'vor {days} Tagen',
    WeekAgo: 'vor {weeks} Woche',
    WeeksAgo: 'vor {weeks} Wochen',
    Times: 'mal',
    Opened: 'Geöffnet',
    EarnedCertificateFor: 'Zertifikat erhalten für',
    FlaggedStepIn: 'Schritt markiert in',
    CompletedStepIn: 'Schritt abgeschlossen in',
    Rated: 'Bewertet',

    // Onboarding.vue
    NothingMatchesThisPage: 'Nichts passt zu dieser Seite.',
    YouCanAddInfo: 'Sie können Informationen hinzufügen und diese Seite einer bestehenden oder neuen Onboarding zuordnen, indem Sie die Schaltfläche unten verwenden.',
    ShareAsEmail: 'Als E-Mail teilen',
    SubjectLabel: 'Betreff:',
    EmailsCommaSeparated: 'E-Mails (durch Komma getrennt)',
    SendEmail: 'E-Mail senden',
    PreviewLink: 'Vorschau-Link',
    PreviewLinkLabel: 'Vorschau-Link:',
    SavePopupTitle: 'Speichern',
    TitleLabel: 'Titel:',
    DescriptionLabel: 'Beschreibung',
    ExternalUrl: 'Externe URL',
    ManageNDomains: '{count} Domains verwalten',
    SpaceLabel: 'Space:',
    OpenPreviewInNewTab: 'Vorschau in neuem Tab öffnen',
    Publish: 'Veröffentlichen',
    SaveChangesToVersion: 'Änderungen speichern zu V. {major}.{minor}',
    SaveChangesToNewDraft: 'Änderungen in neuem Entwurf speichern',
    ManageDomains: 'Domains verwalten',
    OpenOnboarding: 'Onboarding öffnen',
    SearchPlaceholder: 'Tippen und Enter drücken...',
    ArtefactsDiscovered: 'Artefakte gefunden',
    OnboardingsForThisUrl: 'Onboardings für diese URL',
    ViewInNewTab: 'In neuem Tab ansehen',
    GuideMode: 'Guide-Modus',
    AddStep: 'Schritt hinzufügen',
    EditStep: 'Schritt bearbeiten',
    DeleteStep: 'Schritt löschen',
    AddOnboardingToSpaceTitle: 'Onboarding zu Space hinzufügen',
    OnboardingProperties: 'Onboarding-Eigenschaften'
    ,
    // Spaces.vue
    PremiumSpace: 'Premium-Bereich',
    PremiumSpaceDescription: 'Dies ist ein Premium-Bereich, der eine Zahlung für den Zugriff erfordert.',
    ProceedToPayment: 'Zur Zahlung fortfahren',
    PropertiesTitle: 'Eigenschaften',
    ShareSpace: 'Bereich teilen',
    AssignSpace: 'Bereich zuweisen',
    Verification: 'Verifizierung',
    PleaseEnterYourEmail: 'Bitte geben Sie Ihre E-Mail ein.',
    EmailLabel: 'E-Mail:',
    Send: 'Senden',
    PinVerification: 'PIN-Verifizierung',
    CodeSentPrompt: 'Wir haben Ihnen gerade einen Code per E-Mail gesendet. Bitte geben Sie ihn unten ein, um fortzufahren.',
    YourCode: 'Ihr Code',
    DidntReceiveCode: 'Keinen Code erhalten?',
    ClickHereToResend: 'Hier klicken, um erneut zu senden',
    ClickHereToLogin: 'Hier klicken, um sich anzumelden.',
    Validate: 'Bestätigen',
    CreateSubspace: 'Unterbereich erstellen',
    CreateSpace: 'Bereich erstellen',
    NoDescriptionYet: 'Dieser Bereich hat noch keine Beschreibung.',
    NoSubspacesHere: 'Keine Unterbereiche hier',
    NothingHere: 'Nichts hier...',
    SOPs: 'SOPs',
    NoSOPsInThisSpace: 'Keine SOPs in diesem Bereich',
    NoSOPsInThisSpaceDesc: 'Dieser Bereich enthält noch keine Standardarbeitsanweisungen (SOPs). Sie können mit der Erfassung Ihrer Prozesse mit einer der folgenden Methoden beginnen:',
    SaveOnboardingOrder: 'Reihenfolge der Onboardings speichern',
    SaveSubspaceOrder: 'Reihenfolge der Unterbereiche speichern',
    OnboardingsHeader: 'Onboardings',
    SubspacesHeader: 'Unterbereiche',
    GridView: 'Rasteransicht',
    GoBack: 'Zurück',
    PDFLinkedInFormat: 'PDF (LinkedIn-Format)',
    HTMLFull: 'HTML vollständig',
    AssignSpaceToUser: 'Bereich einem Benutzer zuweisen',
    AddSubspace: 'Unterbereich hinzufügen'
    ,
    // SpacesManage.vue (Space Manager)
    Link: 'Link',
    CreateSpaceTitle: 'Bereich erstellen',
    HideSpaceFromSidebar: 'Bereich in der Seitenleiste ausblenden',
    ManageSpaces: 'Bereiche verwalten',
    ManageSpacesDescription: 'Verwenden Sie die folgenden Befehle, um Bereiche zu verwalten, Benutzer zuzuweisen und Onboardings hinzuzufügen.',
    CreateNewSpace: 'Neuen Bereich erstellen',
    NoSpacesYet: 'Noch keine Bereiche',
    NoSpacesYetDescription: 'Erstellen Sie Ihren ersten Bereich, um Ihre Onboardings zu organisieren.',
    CreateYourFirstSpace: 'Erstellen Sie Ihren ersten Bereich',
    OnboardingNoDescriptionYet: 'Dieses Onboarding hat noch keine Beschreibung.',
    // App.vue
    NoPasswordWarning: 'Ihr Konto hat kein Passwort.',
    CreatePasswordCTA: 'Klicken Sie hier, um eines zu erstellen.',
    TCVelikTip: 'TCVelik Tipp',
    RecommendExtensionText: 'Wir empfehlen die Verwendung von Chrome mit installierter Erweiterung für die beste Erfahrung und kontextbezogene Ergebnisse. Hier klicken, um zu installieren.',
    AutoLoginSuccessful: 'Auto-Login erfolgreich',
    AutoLoginSuccessfulText: 'Sie wurden automatisch über die TCVelik-Erweiterung angemeldet.',
    PasswordResetEmailSent: 'Eine E-Mail mit einem Link zum Festlegen eines neuen Passworts wurde gesendet.',
    PleaseCheckInbox: 'Bitte prüfen Sie Ihr Postfach.',
    UserErrorPleaseLogin: 'Es gab einen Fehler mit Ihrem Benutzer. Bitte melden Sie sich erneut an.',
    LicenseWarningTitle: 'Lizenzwarnung:',
    ManageLicenseCTA: 'Klicken Sie hier, um Ihre Lizenz zu verwalten.',
    // Cadence options
    Now: 'Jetzt',
    Daily: 'Täglich',
    Weekly: 'Wöchentlich',
    Monthly: 'Monatlich',
    Quarterly: 'Vierteljährlich',
    Yearly: 'Jährlich',
    SpecificDate: 'Bestimmtes Datum'
    ,
    // OnboardingScheduleComponent
    Reviewer: 'Prüfer',
    Cadence: 'Rhythmus',
    DateDue: 'Fälligkeitsdatum',
    SetReviewCadence: 'Legen Sie den Überprüfungsrhythmus für dieses Onboarding fest'
    ,
    // AssignComponent.vue
    AllUsers: 'Alle Benutzer',
    AssignedUsers: 'Zugewiesene Benutzer',
    SuccessfullyAssignedItem: 'Element erfolgreich zugewiesen.',
    NoSuchUserExists: 'Dieser Benutzer existiert nicht.',
    ProblemSharingOnboarding: 'Es ist ein Problem beim Teilen dieses Onboardings aufgetreten.',
    ErrorFetchingUsers: 'Beim Abrufen der Benutzer sind Fehler aufgetreten',
    SelectedUsers: 'Ausgewählte Benutzer',
    ZeroSelected: '0 ausgewählt'
    ,
    // AssignToRoleComponent.vue
    ErrorFetchingAssignedRoles: 'Beim Abrufen der zugewiesenen Rollen sind Fehler aufgetreten',
    ErrorFetchingRoles: 'Beim Abrufen der Rollen sind Fehler aufgetreten',
    NoSuchRoleExists: 'Diese Rolle existiert nicht.',
    ProblemAssigningItemToRole: 'Es ist ein Problem beim Zuweisen dieses Elements zur Rolle aufgetreten.',
    SuccessfullyUnassignedItem: 'Zuweisung des Elements erfolgreich aufgehoben.'
    ,
    // AssignComponent placeholders
    SearchUserPlaceholder: 'Benutzer suchen ...',
    SortByPlaceholder: 'Sortieren nach...',
    OrderOfSortPlaceholder: 'Sortierreihenfolge',
    FullNameHeader: 'Vollständiger Name',
    ActionsHeader: 'Aktionen'
    ,
    // LicensingCatalog.vue
    TCVelikLicensing: 'Lizenzierung',
    ChoosePerfectPlan: 'Wählen Sie den perfekten Plan für Ihre Organisation.',
    LicensingHelpText: 'Wenn Sie Fragen haben oder Hilfe zu unserer Lizenzierung benötigen - besuchen Sie bitte unsere',
    Website: 'Website',
    Or: 'oder',
    BookMeeting: 'buchen Sie ein Meeting',
    WithUsDirectly: 'direkt mit uns.',
    YourLicenses: 'Ihre Lizenzen',
    LicenseHolder: 'Lizenzinhaber',
    Edition: 'Edition',
    RenewsAt: 'Verlängert am',
    Domain: 'Domain',
    NA: 'N/V',
    AvailableForUse: 'Verfügbar zur Nutzung',
    UseThisLicense: 'Diese Lizenz verwenden',
    PurchaseAdditionalLicenses: 'Zusätzliche Lizenzen kaufen:',
    NoDescriptionAvailable: 'Keine Beschreibung verfügbar',
    Here: 'hier',
    LoadingLicensingOptions: 'Lizenzoptionen werden geladen...',
    NoLicensingOptionsAvailable: 'Keine Lizenzoptionen verfügbar',
    NoLicensingOptionsText: 'Es sind derzeit keine Lizenzoptionen verfügbar. Bitte kontaktieren Sie den Support.',
    ActivateLicense: 'Lizenz aktivieren',
    EnterEmailToActivate: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um diese Lizenz zu aktivieren:',
    EmailPlaceholder: 'ihre.email@beispiel.de',
    EmailAddress: 'E-Mail-Adresse',
    Cancel: 'Abbrechen',
    Processing: 'Wird verarbeitet...',
    OnlyAvailableOnPersonal: 'Nur verfügbar auf personal.tcvelik.com',
    FreeForever: 'Für immer kostenlos',
    ContactSales: 'Vertrieb kontaktieren',
    NoCreditCardRequired: 'Keine Kreditkarte erforderlich',
    Per: 'pro',
    OneTimePayment: 'Einmalige Zahlung',
    PurchaseNow: 'Jetzt kaufen',
    YouAndYourTeamCanDownload: 'Sie und Ihr Team können TCVelik Personal Edition herunterladen und verwenden',
    FailedToLoadProducts: 'Lizenzprodukte konnten nicht geladen werden',
    NoPricingAvailable: 'Keine Preise verfügbar',
    NoPricingOptionsText: 'Dieses Produkt hat keine Preisoptionen',
    SelectionRequired: 'Auswahl erforderlich',
    PleaseSelectPricing: 'Bitte wählen Sie eine Preisoption',
    FailedToCreatePaymentLink: 'Zahlungslink konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    InvalidEmail: 'Ungültige E-Mail',
    PleaseEnterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    LicenseActivated: 'Lizenz aktiviert!',
    LicenseActivatedSuccess: 'Ihre Lizenz wurde erfolgreich aktiviert.',
    ActivationFailed: 'Aktivierung fehlgeschlagen',
    FailedToActivateLicense: 'Lizenz konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.',
    LicenseSwitched: 'Lizenz gewechselt!',
    LicenseSwitchedSuccess: 'Sie verwenden jetzt eine andere Lizenz. Die vorherige Domain wird innerhalb von 2 Stunden nicht mehr funktionieren.',
    SwitchFailed: 'Wechsel fehlgeschlagen',
    FailedToSwitchLicense: 'Lizenz konnte nicht gewechselt werden. Bitte versuchen Sie es erneut.',
    SwitchLicenseConfirmation: 'Sind Sie sicher, dass Sie zur {product}-Lizenz wechseln möchten?\n\n⚠️ Wichtig: Dadurch wird Ihre aktuelle Lizenz auf dieser Domain für bis zu 2 Stunden aufgrund von Caching nicht verfügbar sein. Die andere Domain wird vorübergehend nicht funktionieren.\n\nMöchten Sie fortfahren?',
    Renewed: 'Verlängert',
    RenewsToday: 'Verlängert sich heute',
    RenewsTomorrow: 'Verlängert sich morgen',
    RenewsInDays: 'Verlängert sich in {days} Tagen',
    Expired: 'Abgelaufen',
    ExpiresToday: 'Läuft heute ab',
    ExpiresTomorrow: 'Läuft morgen ab',
    ExpiresInDays: 'Läuft in {days} Tagen ab',

    // Search.vue
    BasicSearch: 'Grundsuche',
    Results: 'Ergebnisse',
    FoundNothing: 'nichts gefunden.',
    NoResults: 'Keine Ergebnisse',
    SearchReturnedNoResults: 'Die Suche ergab keine Ergebnisse.',
    KeepTrying: 'Weiter versuchen...',
    WorkingSearch: 'Arbeite ...',
    ResultsComingShortly: 'Ergebnisse kommen in Kürze ...',
    IntentFilters: 'Intent-Filter:',
    ShowAll: 'Alle anzeigen',
    ClearAll: 'Alle löschen',
    Filter: 'Filter',
    SuccessNotification: 'Erfolg!',
    TextCopiedSuccessfully: 'Text erfolgreich kopiert.',
    Failed: 'Fehlgeschlagen!',
    ErrorInCopyingText: 'Fehler beim Kopieren des Textes.',

    // AccountBranding.vue
    AccountBranding: 'Account-Branding',
    Favicon: 'Favicon',
    ChangedIcon: 'Symbol geändert.',
    ProblemSavingIcon: 'Es gab ein Problem beim Speichern Ihres Symbols.',
    Saved: 'Gespeichert',

    // AdminControlPanel.vue
    CreateWebhook: 'Webhook erstellen',
    Database: 'Datenbank',
    SystemSettings: 'Systemeinstellungen',
    ChangeLanguage: 'Sprache ändern',
    CreateMagicLink: 'Magic Link erstellen',
    Webhooks: 'Webhooks',
    CreateEmbedScript: 'Embed-Script zur Ausführung erstellen',
    EventType: 'Ereignistyp',
    FilterByRoles: 'Nach Rollen filtern',
    MagicLink: 'Magic Link',
    CampaignName: 'Kampagnenname',
    ExistingMagicLinkTokens: 'Vorhandene Magic Link Token',
    LoadTokens: 'Token laden',
    DateCreated: 'Erstellungsdatum',
    TargetURL: 'Ziel-URL',
    RoleToken: 'Rollen-Token',
    CopyLink: 'Link kopieren',
    LoadingMagicLinkTokens: 'Magic Link Token werden geladen...',
    CreateWebhookButton: 'Webhook erstellen',
    FormatDocument: 'Dokument formatieren',
    SuccessfullyUpdatedSettings: 'Einstellungen erfolgreich aktualisiert.',
    ProblemOccurredDownloading: 'Es gab ein Problem beim Herunterladen der Datenbank.',
    ProblemOccurredSaving: 'Es gab ein Problem beim Speichern der Änderungen.',
    ProblemOccurredCreating: 'Es gab ein Problem beim Erstellen des Webhooks.',
    ProblemOccurredFetching: 'Es gab ein Problem beim Abrufen der Webhooks.',
    ProblemOccurredDeleting: 'Es gab ein Problem beim Löschen dieses Webhooks.',
    ProblemOccurredLoading: 'Es gab ein Problem beim Laden des Inject-Script-Codes.',
    SuccessfullyCreatedMagicLink: 'Magic Link erfolgreich erstellt.',
    SuccessfullyCreatedWebhook: 'Webhook erfolgreich erstellt.',
    SuccessfullyDeletedWebhook: 'Webhook erfolgreich gelöscht.',
    FailedToLoadMagicLinkTokens: 'Magic Link Token konnten nicht geladen werden',
    LinkCopiedToClipboard: 'Link in die Zwischenablage kopiert',
    
    // Additional notification messages
    SuccessExclamation: 'Erfolg!',
    SuccessfullyDeletedSubspace: 'Unterbereich erfolgreich gelöscht!',
    ProblemOccurredDeletingSubspace: 'Es gab ein Problem beim Versuch, diesen Unterbereich zu löschen!',
    InvalidPassword: 'Ungültiges Passwort',
    NoAccessToResource: 'Kein Zugriff auf diese Ressource',
    NoAccessToResourceText: 'Es scheint, als würden Sie versuchen, auf diesen Artikel mit einer E-Mail zuzugreifen, die keinen Zugriff hat. Wenn Sie glauben, dass dies ein Fehler ist - wenden Sie sich bitte an die Person, die es geteilt hat.',
    CodeSentToEmail: 'Ein Code wurde an Ihre E-Mail gesendet.',
    CodeAlreadySentToEmail: 'Ein Code wurde bereits an Ihre E-Mail gesendet.',
    SavedOrderOfOnboardings: 'Reihenfolge der Onboardings gespeichert',
    FailedToSaveOrder: 'Fehler beim Speichern der Reihenfolge.',
    SavedOrderOfSubspaces: 'Reihenfolge der Unterbereiche gespeichert',
    LinkSent: 'Link gesendet',
    SomethingWentWrongSendingLink: 'Etwas ist schief gelaufen beim Versuch, den Link zu senden...',
    CouldNotLoadSpaceDetails: 'Raumdetails konnten nicht geladen werden',
    FailedToLoadSpaceInformation: 'Fehler beim Laden der Rauminformationen',
    SavedChanges: 'Änderungen gespeichert',
    ProblemAddingImage: 'Es gab ein Problem beim Hinzufügen Ihres Bildes.',
    TCVelikContentPasted: 'TCVelik-Inhalt eingefügt',
    StepsAddedSuccessfully: '{count} Schritt(e) erfolgreich hinzugefügt',
    CursorNotInsideCustomNode: 'Cursor ist nicht in einem benutzerdefinierten Knoten.',
    SOPFormatExport: 'SOP-Format-Export',
    SOPFormatExportComingSoon: 'SOP-Format-Export-Funktionalität wird bald implementiert!',
    SuccessfullySavedImage: 'Bild erfolgreich gespeichert!',
    DocumentFormatted: 'Dokument formatiert',
    UserHasBeenDeleted: 'Benutzer wurde gelöscht',
    SomethingWentWrongDeletingUser: 'Etwas ist schief gelaufen beim Versuch, diesen Benutzer zu löschen...',
    CannotGeneratePreviewForUnsavedOnboarding: 'Vorschau kann nicht für ungespeichertes Onboarding generiert werden!',
    CameraNotAllowed: 'Kamera nicht erlaubt. Bitte Zugriff gewähren.',
    ErrorAccessingCamera: 'Fehler beim Zugriff auf die Kamera.',
    PleaseOpenAnOnboarding: 'Bitte öffnen Sie ein Onboarding',
    OnboardingNotSavedCannotBeShared: 'Onboarding wurde nicht gespeichert und kann nicht geteilt werden',
    DraftDeleted: 'Entwurf gelöscht',
    ErrorOccurredDeletingDraft: 'Ein Fehler ist aufgetreten beim Versuch, diesen Entwurf zu löschen.',
    OnboardingDeleted: 'Onboarding gelöscht',
    ErrorOccurredDeletingOnboarding: 'Ein Fehler ist aufgetreten beim Versuch, dieses Onboarding zu löschen.',
    InvalidURL: 'Ungültige URL',
    PleaseFillInValidURL: 'Bitte geben Sie eine gültige URL ein',
    OnboardingWasSaved: '{name} wurde gespeichert.',
    SuccessfullyCreatedAndAddedOnboardingToSpace: 'Onboarding erfolgreich erstellt und zum Raum hinzugefügt!',
    DomainLabelsHaveBeenApplied: 'Domain-Labels wurden angewendet.',
    
    // Navbar and Sidebar localization
    SearchWithAI: 'Mit KI suchen',
    SearchPlaceholderNavbar: 'Suchen...',
    ManageUsers: 'Benutzer verwalten',
    Skills: 'Fähigkeiten',
    Focus: 'Fokus',
    AnalysisCompleted: 'Analyse abgeschlossen',
    ProjectWasAnalyzed: 'Projekt {projectName} wurde analysiert.',
    AnalysisStarted: 'Analyse gestartet',
    AnalysisWithTitle: 'Analyse {title}',
    UserDoesNotHaveSlug: 'Dieser Benutzer hat keinen Slug, bitte gehen Sie zu Konto-Admin und aktualisieren Sie den Benutzer-Slug.',
    YearsAgo: '{years} {yearsText} her',
    YearAgo: '{years} Jahr her',
    DaysAgoSidebar: '{days} {daysText} her',
    DayAgo: '{days} Tag her',
    HoursAgo: '{hours} {hoursText} her',
    HourAgo: '{hours} Stunde her',
    MinutesAgo: '{minutes} {minutesText} her',
    MinuteAgo: '{minutes} Min her',
    SecondsAgo: '{seconds} Sek her',
    JustNow: 'Gerade eben',
    Years: 'Jahre',
    Days: 'Tage',
    Hours: 'Std',
    Min: 'Min',
    NoInfo: 'Keine Info',
    UnknownAccount: 'Unbekanntes Konto',
    English: 'Englisch',
    Portuguese: 'Portugiesisch',
    French: 'Französisch',
    German: 'Deutsch',
    DownloadDatabase: 'Datenbank herunterladen',
    DownloadVersionHistoryDatabase: 'Versionsverlauf-Datenbank herunterladen',
    SaveChanges: 'Änderungen speichern',
    NoMagicLinkTokensFound: 'Keine Magic Link Token gefunden.',
    SafelyReloading: 'Sichere Seitenneuladung...',

    // NoItemsCard.vue
    NoSOPsAvailable: 'Keine SOPs verfügbar',
    NoSOPsAvailableDescription: 'Es sieht so aus, als gäbe es noch keine Standardarbeitsanweisungen (SOPs) in Ihrem Konto. Sie können mit der Erfassung Ihrer Prozesse mit einer der folgenden Methoden beginnen:',
    SubspacesDescription: 'TCVelik bietet Ihnen die Möglichkeit, Ihre Elemente weiter zu gruppieren, indem Sie Unterbereiche innerhalb von Bereichen erstellen können.',
    ManualCreation: 'Manuelle Erstellung',
    ManualCreationDescription: 'Erstellen Sie SOPs Schritt für Schritt mit unserem manuellen Editor',
    ChromeExtension: 'Chrome-Erweiterung',
    ChromeExtensionDescription: 'Installieren Sie unsere Browser-Erweiterung für nahtlose Aufzeichnung während der Arbeit',
    DesktopRecorder: 'Desktop-Recorder',
    DesktopRecorderDescription: 'Verwenden Sie unsere Desktop-Anwendung für erweiterte Bildschirmaufzeichnung',
    MobileRecording: 'Mobile Aufzeichnung',
    MobileRecordingDescription: 'Zeichnen Sie physische SOPs mit Ihrem Mobiltelefon auf - keine App erforderlich',
    MoreInformationText: 'Weitere Informationen zur Erfassung Ihrer SOPs finden Sie',

    // Login.vue and Register.vue notifications
    WelcomeAdminCreated: '🎉 Willkommen! Ihr Admin-Konto wurde erfolgreich erstellt.',
    PleaseLoginWithCredentials: 'Bitte melden Sie sich mit Ihren Anmeldedaten an, um auf das System zuzugreifen.',
    LinkedInAuthentication: 'LinkedIn-Authentifizierung',
    ConnectingToLinkedIn: 'Verbindung zu LinkedIn...',
    LoginFailed: 'Anmeldung fehlgeschlagen',
    LinkedInAuthNotConfigured: 'LinkedIn-Authentifizierungsdienst ist nicht ordnungsgemäß konfiguriert.',
    CannotConnectLinkedIn: 'Verbindung zum LinkedIn-Authentifizierungsdienst nicht möglich.',
    LoginAttempt: 'Anmeldeversuch',
    AlreadyLoggedIn: 'Sie sind bereits angemeldet!',
    CreateAccount: 'Konto erstellen',
    WelcomeToTCVelik: '🎉 Willkommen bei TCVelik! Dies ist Ihr erstes Setup.',
    YouWillBeAdmin: 'Sie werden als Administrator dieses Systems erstellt.',
    FillFormToCreateAccount: 'Füllen Sie das unten stehende Formular aus, um ein neues Konto zu erstellen.',
    AcceptTermsConditions: 'Ich akzeptiere die Geschäftsbedingungen.',
    RegistrationInProgress: 'Registrierung läuft!',
    PleaseWait: 'Bitte warten..',
    AdminAccountCreatedSuccessfully: 'Admin-Konto erfolgreich erstellt! Bitte melden Sie sich an, um fortzufahren.',
    AccountCreatedRedirecting: 'Konto erstellt. Sie werden zur Anmeldung weitergeleitet..',
    AccountNotCreated: 'Konto nicht erstellt.',

    // ImageUploadPopup.vue
    UploadImage: 'Bild hochladen',
    DragDropImageOrClick: 'Ziehen Sie ein Bild hierher oder klicken Sie zum Auswählen',
    Preview: 'Vorschau',
    OR: 'ODER',
    EnterImageURL: 'Bild-URL eingeben',
    Submit: 'Absenden',

    // GenericProgressPopup.vue
    YourTypeIsInProgress: 'Ihr {type} ist in Bearbeitung',
    ContinueWorkingFileWillDownload: 'Sie können weiterarbeiten. Sobald fertig - wird die Datei automatisch heruntergeladen.',
    Step: 'Schritt',

    // CameraStepScreen.vue
    Capture: 'Aufnehmen',
    Done: 'Fertig',
    ImagesCaptured: '{count} Bilder aufgenommen',
    SaveSteps: 'Schritte speichern',
    StepImage: 'Schritt-Bild',
    StepTitle: 'Schritt-Titel',
    StepDescription: 'Schritt-Beschreibung',
    BrowserNotSupportCamera: 'Ihr Browser unterstützt keinen Kamerazugriff.',

    // OnboardingAnalytics.vue
    ResolveFlaggedStepTitle: 'Markierten Schritt auflösen',
    CommentLabel: 'Kommentar',
    NotifyReporter: 'Die Person benachrichtigen, die dies gemeldet hat',
    MarkAsResolved: 'Als gelöst markieren',
    SaveSearchQueryTitle: 'Suchanfrage speichern',
    NameLabel: 'Name',
    UrlLabel: 'URL',
    EditSearchQueryTitle: 'Suchanfrage bearbeiten',
    FilterBySpaces: 'Nach Bereichen filtern',
    FilterByOnboardings: 'Nach Onboardings filtern',
    DateRange: 'Datumsbereich',
    SaveThisSearchQuery: 'Diese Suchanfrage speichern',
    SaveFilters: 'Filter speichern',
    Options: 'Optionen',
    DeleteThisSearchQuery: 'Diese Suchanfrage löschen',
    EditNameAndUrl: 'Name und URL bearbeiten',
    EditFilters: 'Filter bearbeiten',
    TotalSOPs: 'Gesamt-SOPs',
    TotalUsers: 'Gesamtbenutzer',
    CompletionRate: 'Abschlussrate',
    InProgressLabel: 'In Bearbeitung',
    NotStarted: 'Nicht begonnen',
    EstimatedHoursSaved: 'Geschätzte eingesparte Stunden',
    DocumentationRequests: 'Dokumentationsanfragen',
    FlaggedSteps: 'Markierte Schritte',
    UsersCompletedMostOnboardings: 'Benutzer mit den meisten abgeschlossenen Onboardings',
    CompletedCountForPeriod: '{count} Onboardings für diesen Zeitraum abgeschlossen',
    NoDataForThisOnboarding: 'Keine Daten für dieses Onboarding',
    SOPStats: 'SOP-Statistiken',
    RatingsCount: '{count} Bewertungen',
    EstimatedHoursSavedShort: '{hours} Stunden gespart',
    NoItemsToShow: 'Keine Elemente zum Anzeigen',
    ErrorFetchingData: 'Fehler beim Abrufen der Daten',
    ResolvedStep: 'Schritt wurde gelöst',
    ProblemResolvingStep: 'Es gab ein Problem beim Auflösen dieses Schritts',
    ErrorFetchingHeatmap: 'Fehler beim Abrufen der Heatmap-Daten',
    SavedQuery: 'Suchanfrage erfolgreich gespeichert',
    ProblemSavingQuery: 'Es gab ein Problem beim Speichern der Anfrage',
    DeletedQuery: 'Suchanfrage erfolgreich gelöscht',
    SavedChangesGeneric: 'Änderungen erfolgreich gespeichert',
    ProblemSavingFilters: 'Es gab ein Problem beim Speichern der Filter',

    // Users.vue
    UsersTitle: 'Benutzer',
    InviteUser: 'Benutzer einladen',
    Invitations: 'Einladungen',
    Suggestions: 'Vorschläge',

    // InviteUserModal.vue
    InviteUserTitle: 'Benutzer einladen',
    EmailAddressLabel: 'E-Mail-Adresse',
    EmailPlaceholderUser: 'benutzer@beispiel.de',
    SelectRoles: 'Rollen auswählen',
    CustomMessagePlaceholder: 'Optional: Fügen Sie eine persönliche Nachricht hinzu...',
    CustomMessageLabel: 'Benutzerdefinierte Nachricht (Optional)',
    LinkExpirationLabel: 'Link-Ablauf (Stunden)',
    ExpirationPlaceholder: '120',
    AllowUserRegistration: 'Benutzer darf sich registrieren, wenn er nicht existiert',
    Sending: 'Wird gesendet...',
    SendInvitation: 'Einladung senden',
    FailedToLoadRoles: 'Rollen konnten nicht geladen werden',
    RoleCreatedSuccessfully: 'Rolle erfolgreich erstellt',
    RoleAlreadyExists: 'Eine Rolle mit diesem Namen existiert bereits',
    FailedToCreateRole: 'Rolle konnte nicht erstellt werden',
    InvitationSentSuccessfully: 'Einladung erfolgreich für {count} Rolle(n) gesendet.',
    FailedToSendInvitation: 'Einladung konnte nicht gesendet werden',

    // InvitationList.vue
    InvitationLinkTitle: 'Einladungslink',
    UseThisLinkToInvite: 'Verwenden Sie diesen Link, um den Benutzer einzuladen.',
    EmailHeader: 'E-Mail',
    RolesHeader: 'Rollen',
    CreatedHeader: 'Erstellt',
    ExpiresHeader: 'Läuft ab',
    StatusHeader: 'Status',
    VisitsHeader: 'Besuche',
    InvitedByHeader: 'Eingeladen von',
    ExpiredStatus: 'Abgelaufen',
    ActiveStatus: 'Aktiv',
    LastVisit: 'Zuletzt:',
    InvitationGroup: 'Einladung',
    CopyLinkAction: 'Link kopieren',
    ResendEmailAction: 'E-Mail erneut senden',
    ErrorLoadingInvitations: 'Fehler beim Laden der Einladungen',
    InvitationLinkCopied: 'Einladungslink erfolgreich kopiert.',
    ResendInvitationConfirm: 'Einladungs-E-Mail erneut an {email} senden?',
    InvitationResent: 'Einladung erneut gesendet',
    ErrorResendingInvitation: 'Fehler beim erneuten Senden der Einladung',

    // UserList.vue
    LoginLinkTitle: 'Anmeldelink',
    UseThisLinkToSignIn: 'Verwenden Sie den Link, um sich als dieser Benutzer anzumelden.',
    LastLoginHeader: 'Letzte Anmeldung',
    RoleHeader: 'Rolle',
    SourceHeader: 'Quelle',
    NotAvailable: 'N/V',
    EditGroup: 'Bearbeiten',
    EditAction: 'Bearbeiten',
    DeleteAction: 'Löschen',
    SendLoginLinkAction: 'Anmeldelink senden',
    ResetPasswordAction: 'Passwort zurücksetzen',
    AscendingSort: 'Aufsteigend',
    DescendingSort: 'Absteigend',
    LastLoginDateSort: 'Letztes Anmeldedatum',
    CreatedSort: 'Erstellt',
    ProblemsSavingChanges: 'Beim Speichern der Änderungen sind Probleme aufgetreten.',
    ResetPasswordConfirm: 'Passwort dieses Benutzers zurücksetzen?',
    ResetPasswordError: 'Passwort zurücksetzen',
    SendLoginLinkConfirm: 'Einen Anmeldelink senden?',
    DeleteUserConfirm: 'Sind Sie sich ABSOLUT SICHER, diese Aktion kann nicht rückgängig gemacht werden!',

    // UserEditorScreen.vue
    EditUserTitle: 'Benutzer bearbeiten',
    AddNewUserTitle: 'Neuen Benutzer hinzufügen',
    UploadImageTitle: 'Bild hochladen',
    CreateUserTab: 'Benutzer erstellen',
    AddUserToRoleTab: 'Benutzer zu Rolle hinzufügen',
    ChangePasswordTab: 'Passwort ändern',
    APIAccessTab: 'API-Zugriff',
    InviteUserTab: 'Benutzer einladen',
    FirstNameLabel: 'Vorname',
    LastNameLabel: 'Nachname',
    NewPasswordLabel: 'Neues Passwort',
    ConfirmPasswordLabel: 'Passwort bestätigen',
    APIKeyLabel: 'API-Schlüssel',
    ManageRoles: 'Rollen verwalten',
    SaveButton: 'Speichern',
    CreateUserButton: 'Benutzer erstellen',
    ChangeButton: 'Ändern',
    ResetAPIKeyButton: 'API-Schlüssel zurücksetzen',
    GenerateNewButton: 'Neu generieren',
    InviteButton: 'Einladen',
    AddedRole: 'Rolle hinzugefügt.',
    RoleNameAlreadyExists: 'Eine Rolle mit diesem Namen existiert bereits.',
    ChangedAvatar: 'Avatar geändert.',
    ProblemSavingAvatar: 'Beim Speichern des Avatars ist ein Problem aufgetreten.',
    UserInvited: '{email} wurde eingeladen. Fügen Sie weitere hinzu.',
    SuccessfullyCreatedUser: 'Benutzer erfolgreich erstellt!',
    ProblemCreatingUser: 'Beim Erstellen des Benutzers ist ein Problem aufgetreten.',
    GeneratedAPIKey: 'API-Schlüssel generiert.',
    ProblemGeneratingAPIKey: 'Beim Generieren des API-Schlüssels ist etwas schiefgelaufen...',
    ResetAPIKey: 'API-Schlüssel zurückgesetzt.',
    ProblemResettingAPIKey: 'Beim Zurücksetzen des API-Schlüssels ist etwas schiefgelaufen...',
    PasswordResetEmailSentUserEditor: 'Wenn Ihre E-Mail in unserem System ist - erhalten Sie eine E-Mail zum Zurücksetzen des Passworts.',
    GenerateAPIKeyConfirm: 'Einen API-Schlüssel für diesen Benutzer generieren?',
    ResetAPIKeyConfirm: 'Den API-Schlüssel für diesen Benutzer zurücksetzen?'
  },
  fr: {
    Dashboard: 'Tableau de bord',
    eCommerce: 'commerce électronique',
    Apps: 'APPLICATIONS',
    Todo: 'Faire',
    Chat: 'Bavarder',
    Email: 'Email',
    Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
    Shop: 'Boutique',
    Cart: 'Chariot',
    WishList: 'Liste de souhaits',
    Checkout: 'Check-out',
    UIElements: 'ELEMENTS D\'UI',
    DataList: 'Liste de données',
    ListView: 'Voir la liste',
    ThumbView: 'Thumb View',
    Grid: 'la grille',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Couleurs',
    Card: 'Carte',
    Basic: 'De base',
    Statistics: 'Statistiques',
    Analytics: 'Analytique',
    CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
    Table: 'Table',
    agGridTable: 'tableau agGrid',
    Components: 'Composants',
    Alert: 'Alerte',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
    Chip: 'Puce',
    Collapse: 'Effondrer',
    Dialogs: 'Dialogues',
    Divider: 'Diviseur',
    DropDown: 'Menu déroulant',
    List: 'liste',
    Loading: 'Chargement',
    Navbar: 'Barre de navigation',
    Notifications: 'Les notifications',
    Pagination: 'Pagination',
    Popup: 'Apparaitre',
    Progress: 'Le progrès',
    Sidebar: 'Barre latérale',
    Slider: 'Curseur',
    Tabs: 'Onglets',
    Tooltip: 'Info-bulle',
    Upload: 'Télécharger',
    FormsAndTable: 'Formulaires et tableau',
    FormElements: 'Éléments de formulaire',
    Select: 'Sélectionner',
    Switch: 'Commutateur',
    Checkbox: 'Case à cocher',
    Radio: 'Radio',
    Input: 'Contribution',
    NumberInput: 'Nombre d\'entrée',
    Textarea: 'Textarea',
    FormLayouts: 'Dispositions de formulaire',
    FormWizard: 'Assistant de formulaire',
    FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
    Pages: 'Pages',
    Authentication: 'Authentification',
    Login: 'S\'identifier',
    Register: 'registre',
    Password: 'Password',
    ForgotPassword: 'Mot de passe oublié',
    ResetPassword: 'réinitialiser le mot de passe',
    Reset: 'Réinitialiser',
    RecoverPassword: 'Recover Password',
    ConfirmPassword: 'Confirmer le mot de passe',
    RememberMe: "Remember me",
    LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
    ComingSoon: 'Arrive bientôt',
    Error: 'Erreur',
    404: '404',
    500: '500',
    NotAuthorized: 'Pas autorisé',
    ToggleFullscreen: 'Basculer en plein écran',
    SomethingIsntQuiteRight: 'Quelque chose ne va pas tout à fait',
    // OnboardingPDF Tour
    SopTitleTour: "Ceci est le titre de votre SOP. Vous pouvez voir le nom et la description ici.",
    StepsTour: "Voici vos étapes. Cliquez sur l'en-tête pour développer/réduire le contenu.",
    ToolsTour: "Utilisez ces contrôles pour marquer les étapes comme terminées ou les signaler pour examen.",
    MenuTour: "Enfin, les actions pour l'onboarding se trouvent également ici, ainsi que d'autres options avancées.",
    // OnboardingPDF.vue additions (fr)
    VerifyYourEmail: 'Vérifiez votre e-mail',
    VerificationCode: 'Code de vérification',
    PleaseEnterYourEmailVerification: 'Veuillez saisir votre e-mail pour continuer.',
    WeHaveJustSentEmailWithPin: "Nous venons d'envoyer un e-mail avec un code PIN. Veuillez le saisir ci-dessous pour continuer.",
    Code: 'Code',
    ViewAsSlideshow: 'Voir en diaporama',
    RecordedWith: 'Enregistré avec',
    ClickLinkBetterExperience: "Cliquez sur le lien pour une meilleure expérience",
    ExternalContentMessage: "Cette étape renvoie vers un contenu externe. Vous serez redirigé vers une page externe.",
    IUnderstandProceed: 'Je comprends, continuer',
    ImageView: "Vue de l'image",
    GuestUsersViewOnly: 'Les invités peuvent uniquement consulter le contenu.',
    ProblemCompletingStep: "Un problème est survenu lors de l'achèvement de cette étape.",
    OnboardingSharedSuccessfully: "L'onboarding a été partagé avec succès.",
    ErrorsSharingOnboarding: "Des erreurs sont survenues lors du partage de cet onboarding.",
    FieldCannotBeEmpty: 'Ce champ ne peut pas être vide',
    SuccessfullyAddedToSpace: "Ajouté à l'espace avec succès.",
    ProblemAddingToSpace: "Un problème est survenu lors de l'ajout à l'espace.",
    SuccessfullyRemovedFromSpace: "Supprimé de l'espace avec succès.",
    ProblemRemovingFromSpace: "Un problème est survenu lors de la suppression de l'espace.",
    SendLoginLink: 'Envoyer un lien de connexion ?',
    ProblemSendingLink: "Un problème est survenu lors de l'envoi du lien.",
    PageBeingConverted: 'La page est en cours de conversion...',
    ProblemConvertingToPDF: 'Un problème est survenu lors de la conversion en PDF.',
    PageCannotBeAccessed: "Cette page n'est pas accessible.",
    InvalidLink: 'Lien invalide.',
    NoAccessEmailMessage: "Accès refusé pour cet e-mail. Veuillez contacter la personne qui l'a partagé.",
    EditorNotFound: 'Éditeur introuvable',
    CopyToClipboard: 'Copier dans le presse-papiers',
    ExpandStepContents: "Développer le contenu de l'étape",
    CollapseStepContent: "Réduire le contenu de l'étape",
    MarkStepCompleted: "Marquer l'étape comme terminée",
    Fullscreen: 'Plein écran',
    FlagThisStep: 'Signaler cette étape',
    AddCommentToStep: 'Signaler cette étape',
    ContentMissingOrNoPermissions: 'Le contenu que vous recherchez est manquant ou vous n\'avez pas les permissions pour y accéder.',
    SubmitFeedbackIfError: 'Si vous pensez qu\'il s\'agit d\'une erreur - soumettez un commentaire.',
    BackToHome: 'Retour à l\'accueil',
    LoginAndRetry: 'Se connecter et réessayer',
    Maintenance: 'Entretien',
    Profile: 'Profil',
    Invoice: 'Facture d\'achat',
    FAQ: 'FAQ',
    Search: 'Chercher',
    KnowledgeBase: 'Base de connaissances',
    ChartsAndMaps: 'Graphiques Et Cartes',
    Charts: 'Graphiques',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Carte',
    Extensions: 'Extensions',
    QuillEditor: 'Éditeur de piquants',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
    AccessControl: `Contrôle d'accès`,
    EditorView: `Vue de l'éditeur`,
    AdminView: 'Vue administrateur',
    I18n: 'I18n',
    Carousel: 'Carrousel',
    Clipboard: 'Presse-papiers',
    ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    Others: 'Autre',
    MenuLevels: 'Niveaux de menu',
    MenuLevel2p1: 'Niveau de menu 2.1',
    MenuLevel2p2: 'Niveau de menu 2.2',
    MenuLevel3p1: 'Niveau de menu 3.1',
    MenuLevel3p2: 'Niveau de menu 3.2',
    DisabledMenu: 'Menu désactivé',
    Support: 'Soutien',
    Documentation: 'Documentation',
    RaiseSupport: 'Augmenter le soutien',
    demoTitle: 'Titre de la carte',
    demoText: `Le gâteau au sésame s'enclenche au petit pain au pain d'épices danois J'adore le pain d'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.`,
    SOPEditor: 'SOP Editor',
    Record: 'Record',
    Open: 'Open',
    Save: 'Save',
    Share: 'Сподели',
    DiscoverImprove: 'Discover & Improve',
    Spaces: 'Spaces',
    SpaceManager: 'Space Manager',
    Latest: 'Latest',
    MostUseful: 'Most useful',
    TailoredForYou: 'Tailored for you',
    Browse: 'Browse',
    Logout: 'Logout',
    MarkAsComplete: 'Mark as Complete',
    COMPLETED: "COMPLETED",
    Yes: "Yes",
    No: "No",
    Next: "Next",
    Back: "Back",
    Folders: 'Folders',
    BackToLogin: "Обратно към Login",
    //FEEDBACK CARD SPECIFIC(FeedbackCard.vue)
    FeedbackTitle: "We'd love your feedback",
    RateTitle: "How would you rate this SOP overall?",
    SaveTimeTitle: "Did this SOP save you time?",
    SaveTimeDescription: "Understanding time saved helps us prioritize improvements.",
    SaveTimeApproxTitle: "Approximately how much time did it save?",
    SaveTimeApproxDescription: "Rough estimate is fine - this helps us understand impact.",
    LessThanAnHour: "Less than 1 hour",
    OneToTwoHours: "1-2 hours",
    TwoToFourHours: "2-4 hours",
    MoreThanFourHours: "More than 4 hours",
    NotSure: 'Not sure',
    AlreadyKnowHowTitle: "Did you already know how to do this?",
    AlreadyKnowHowDescription: "This helps us understand if we're adding value beyond existing knowledge.",
    DocumentationBetterTitle: "Was our documentation better than what you knew?",
    RecommendSOPTitle: "Would you recommend this SOP to others?",
    RecommendSOPDescriptiion: "This helps us understand the overall effectiveness.",
    SOPEasyToFollowTitle: "Was this SOP easy to follow?",
    CommentsTitle: "Comments or suggestions for improvement?",
    CommentsDescription: "Optional: Any additional feedback helps us improve.",
    CommentTextAreaPlaceholder: "Tell us what could be better...",
    SubmitFeedbackButtonText: "Submit Feedback",
    PopupFeedbackCompletionText: "Thank you for your feedback!",

     //FORGOTTEN PASSWORD SPECIFIC (ForgottenPassword.vue)
    RecoverYourPassword: 'Recover your password',
    RecoverYourPasswordInstuctions: 'Please enter your email address and we\'ll send you instructions on how to reset your password.',
    RecoverPasswordMessage: 'If your email is in our system - you will receive a password reset email.',

    //ResetPassword.vue
    ResetPasswordPrompt: "Please enter your new password.",

    // SOPEditorMenu
    File: 'Fichier',
    Import: 'Importer',
    Export: 'Exporter',
    ExportAs: 'Exporter sous...',
    DownloadAsPPTX: 'Télécharger en PPTX',
    TCVelikSOPFormat: 'Format SOP TCVelik',
    AddToSpace: 'Ajouter à l\'espace',
    OpenReviewMenu: "Ouvrir le menu d'examen",
    GeneratePreviewLink: 'Générer un lien de prévisualisation',
    Delete: 'Supprimer',
    Close: 'Fermer',
    Edit: 'Éditer',
    Undo: 'Annuler',
    Redo: 'Rétablir',
    SelectAll: 'Tout sélectionner',
    View: 'Affichage',
    HTMLSource: 'Source HTML',
    Tools: 'Outils',
    Properties: 'Propriétés',
    Assign: 'Assigner',
    AssignToRole: 'Assigner à un rôle',
    EditIntent: "Modifier l'intention",
    ExitEditor: "Quitter l'éditeur",
    Menu: 'Menu',

    // MainToolbar and Components
    // AlignmentButtons
    AlignLeft: 'Aligner à gauche',
    AlignCenter: 'Centrer',
    AlignRight: 'Aligner à droite',
    // TextFormattingButtons
    Heading: 'Titre',
    Paragraph: 'Paragraphe',
    Bold: 'Gras',
    Italic: 'Italique',
    Underline: 'Souligné',
    // ListButtons
    BulletList: 'Liste à puces',
    NumberedList: 'Liste numérotée',
    ManualSteps: 'Étapes manuelles',
    DefaultManual: 'Par défaut',
    Warning: 'Avertissement',
    Success: 'Succès',
    Informational: 'Informatif',
    CameraPicture: 'Caméra',
    CodeStep: 'Code',
    ErrorStep: 'Erreur',
    Image: 'Image',
    Line: 'Ligne',
    // ContentButtons
    AddLink: 'Ajouter un lien',
    AddImage: 'Ajouter une image',
    // AdvancedButtons
    EditHTML: 'Modifier le HTML',
    // LineManagementButtons
    AddBlankLineAbove: 'Ajouter une ligne vide au-dessus',
    AddBlankLineBelow: 'Ajouter une ligne vide en-dessous',
    // FileOperationsButtons
    ShareOnboarding: 'Partager l\'onboarding',
    AssignOnboarding: 'Attribuer l\'onboarding',
    AssignToRoleTitle: 'Attribuer un rôle',
    OpenPropertiesMenu: 'Propriétés',
    DeleteOnboarding: 'Supprimer l\'onboarding',

    // SignalsView.vue
    SignalsManagement: 'Gestion des signaux',
    QuickFilters: 'Filtres rapides',
    System: 'Système',
    Action: 'Action',
    UserEmail: 'E-mail utilisateur',
    ProcessedStatus: 'Statut de traitement',
    All: 'Tous',
    Processed: 'Traité',
    Unprocessed: 'Non traité',
    Refresh: 'Actualiser',
    ManageFilters: 'Gérer les filtres',
    ManageTags: 'Gérer les tags',
    ApplyTags: 'Appliquer les tags',
    CreateTestSignal: 'Créer un signal de test',
    Context: 'Contexte',
    SOPHint: 'Indice SOP',
    Created: 'Créé',
    Tags: 'Tags',
    ViewDetails: 'Voir les détails',
    EditTags: 'Modifier les tags',
    Showing: 'Affichage',
    to: 'à',
    of: 'sur',
    signals: 'signaux',
    CreateNewFilter: 'Créer un nouveau filtre',
    Name: 'Nom',
    Field: 'Champ',
    Operation: 'Opération',
    Value: 'Valeur',
    CreateFilter: 'Créer un filtre',
    FilterName: 'Nom du filtre',
    Description: 'Description',
    SelectField: 'Sélectionner un champ',
    SelectOperation: 'Sélectionner une opération',
    SecondValue: 'Deuxième valeur',
    CreateNewTag: 'Créer un nouveau tag',
    Color: 'Couleur',
    CreateTag: 'Créer un tag',
    TagName: 'Nom du tag',
    ColorHex: 'Couleur (Hex)',
    ApplyTagsToSignals: 'Appliquer les tags aux signaux',
    SelectFilters: 'Sélectionner les filtres',
    SelectFiltersToApply: 'Sélectionner les filtres à appliquer',
    SelectTags: 'Sélectionner les tags',
    SelectTagsToApply: 'Sélectionner les tags à appliquer',
    FilterCreatedSuccessfully: 'Filtre créé avec succès',
    FailedToCreateFilter: 'Échec de la création du filtre',
    TagCreatedSuccessfully: 'Tag créé avec succès',
    FailedToCreateTag: 'Échec de la création du tag',
    FailedToLoadSignals: 'Échec du chargement des signaux',
    FailedToApplyTags: 'Échec de l\'application des tags',
    TestSignalCreatedSuccessfully: 'Signal de test créé avec succès',
    FailedToCreateTestSignal: 'Échec de la création du signal de test',

    // SuggestionsList.vue
    SuggestedUsers: 'Utilisateurs suggérés',
    SignalCount: 'Nombre de signaux',
    LastActivity: 'Dernière activité',
    AlreadyInvited: 'Déjà invité',
    NewLabel: 'Nouveau',
    InvitationSent: 'Invitation envoyée',
    ReadyToInvite: 'Prêt à inviter',
    ForceProcess: 'Forcer le traitement',
    FailedToLoadSuggestedUsers: "Échec du chargement des utilisateurs suggérés",
    ProcessedSignals: '{count} signaux traités',
    FailedToProcessSignals: 'Échec du traitement des signaux',

    // Profile.vue
    Hey: 'Salut',
    Stranger: 'Étranger',
    SOPsOpened: 'SOPs ouverts',
    SOPsCompleted: 'SOPs terminés',
    StepsCompleted: 'Étapes terminées',
    RatingsGiven: 'Évaluations données',
    CertificatesEarned: 'Certificats obtenus',
    Filters: 'Filtres',
    Position: 'Position',
    Manager: 'Gestionnaire',
    Supervisor: 'Superviseur',
    Status: 'Statut',
    Completed: 'Terminé',
    Pending: 'En attente',
    ManagerPosition: 'Position de gestionnaire',
    SupervisorPosition: 'Position de superviseur',
    Completion: 'Achèvement',
    OpeningProcedures: 'Procédures d\'ouverture',
    ClosingProcedures: 'Procédures de fermeture',
    SafetyProtocol: 'Protocole de sécurité',
    EmployeeTraining: 'Formation des employés',

    // UserJourneyTimeline.vue
    YourJourney: 'Votre parcours',
    Last7Days: '7 derniers jours',
    Last30Days: '30 derniers jours',
    Last90Days: '90 derniers jours',
    LastYear: 'Dernière année',
    LoadingYourJourney: 'Chargement de votre parcours...',
    FailedToLoadJourneyTimeline: 'Échec du chargement de votre chronologie de parcours. Veuillez réessayer.',
    TryAgain: 'Réessayer',
    NoActivityYet: 'Aucune activité pour le moment',
    JourneyTimelineWillAppear: 'Votre chronologie de parcours apparaîtra ici une fois que vous commencerez à interagir avec les SOP.',
    Resolved: 'Résolu',
    PendingResolution: 'Résolution en attente',
    Reason: 'Raison',
    Resolution: 'Résolution',
    StepCompletedSuccessfully: 'Étape {stepId} terminée avec succès',
    Stars: 'étoiles',
    Comment: 'Commentaire',
    Helpful: 'Utile',
    SavedMinutes: '{minutes} minutes économisées',
    AlreadyKnewThis: 'Je le savais déjà',
    ViewSOP: 'Voir SOP',
    Today: 'Aujourd\'hui',
    Yesterday: 'Hier',
    DaysAgo: 'il y a {days} jours',
    WeekAgo: 'il y a {weeks} semaine',
    WeeksAgo: 'il y a {weeks} semaines',
    Times: 'fois',
    Opened: 'Ouvert',
    EarnedCertificateFor: 'Certificat obtenu pour',
    FlaggedStepIn: 'Étape signalée dans',
    CompletedStepIn: 'Étape terminée dans',
    Rated: 'Évalué',

    // Onboarding.vue
    NothingMatchesThisPage: 'Rien ne correspond à cette page.',
    YouCanAddInfo: 'Vous pouvez ajouter des informations et inclure cette page dans un onboarding existant ou nouveau en utilisant le bouton ci-dessous.',
    ShareAsEmail: 'Partager par e-mail',
    SubjectLabel: 'Objet :',
    EmailsCommaSeparated: 'E-mails (séparés par des virgules)',
    SendEmail: 'Envoyer l’e-mail',
    PreviewLink: 'Lien de prévisualisation',
    PreviewLinkLabel: 'Lien de prévisualisation :',
    SavePopupTitle: 'Enregistrer',
    TitleLabel: 'Titre :',
    DescriptionLabel: 'Description',
    ExternalUrl: 'URL externe',
    ManageNDomains: 'Gérer {count} domaines',
    SpaceLabel: 'Espace :',
    OpenPreviewInNewTab: 'Ouvrir la prévisualisation dans un nouvel onglet',
    Publish: 'Publier',
    SaveChangesToVersion: 'Enregistrer les changements vers v. {major}.{minor}',
    SaveChangesToNewDraft: 'Enregistrer les changements dans un nouveau brouillon',
    ManageDomains: 'Gérer les domaines',
    OpenOnboarding: 'Ouvrir l\'onboarding',
    SearchPlaceholder: 'Saisissez du texte et appuyez sur Entrée…',
    ArtefactsDiscovered: 'Artefacts découverts',
    OnboardingsForThisUrl: 'Onboardings pour cette URL',
    ViewInNewTab: 'Voir dans un nouvel onglet',
    GuideMode: 'Mode guide',
    AddStep: 'Ajouter une étape',
    EditStep: 'Modifier l\'étape',
    DeleteStep: 'Supprimer l\'étape',
    AddOnboardingToSpaceTitle: 'Ajouter l\'onboarding à l\'espace',
    OnboardingProperties: 'Propriétés de l\'onboarding'
    ,
    // Spaces.vue
    PremiumSpace: 'Espace Premium',
    PremiumSpaceDescription: 'Ceci est un espace premium nécessitant un paiement pour y accéder.',
    ProceedToPayment: 'Procéder au paiement',
    PropertiesTitle: 'Propriétés',
    ShareSpace: "Partager l'espace",
    AssignSpace: "Affecter l'espace",
    Verification: 'Vérification',
    PleaseEnterYourEmail: 'Veuillez saisir votre e-mail.',
    EmailLabel: 'E-mail :',
    Send: 'Envoyer',
    PinVerification: 'Vérification du code PIN',
    CodeSentPrompt: "Nous venons d'envoyer un e-mail avec un code. Veuillez le saisir ci-dessous pour continuer.",
    YourCode: 'Votre code',
    DidntReceiveCode: 'Vous n’avez pas reçu de code ?',
    ClickHereToResend: 'Cliquez ici pour renvoyer',
    ClickHereToLogin: 'Cliquez ici pour vous connecter.',
    Validate: 'Valider',
    CreateSubspace: 'Créer un sous-espace',
    CreateSpace: 'Créer un espace',
    NoDescriptionYet: "Cet espace n'a pas encore de description.",
    NoSubspacesHere: 'Aucun sous-espace ici',
    NothingHere: 'Rien ici...',
    SOPs: 'SOPs',
    NoSOPsInThisSpace: 'Aucune SOP dans cet espace',
    NoSOPsInThisSpaceDesc: "Cet espace n'a pas encore de procédures opératoires standard (SOP). Vous pouvez commencer à capturer vos processus en utilisant l'une de ces méthodes :",
    SaveOnboardingOrder: 'Enregistrer l’ordre des onboardings',
    SaveSubspaceOrder: 'Enregistrer l’ordre des sous-espaces',
    OnboardingsHeader: 'Onboardings',
    SubspacesHeader: 'Sous-espaces',
    GridView: 'Vue en grille',
    GoBack: 'Retour',
    PDFLinkedInFormat: 'PDF (format LinkedIn)',
    HTMLFull: 'HTML complet',
    AssignSpaceToUser: "Affecter l'espace à un utilisateur",
    AddSubspace: 'Ajouter un sous-espace'
    ,
    // SpacesManage.vue (Space Manager)
    Link: 'Lien',
    CreateSpaceTitle: 'Créer un espace',
    HideSpaceFromSidebar: "Masquer l'espace dans la barre latérale",
    ManageSpaces: 'Gérer les espaces',
    ManageSpacesDescription: 'Utilisez les commandes ci-dessous pour gérer les espaces, affecter des utilisateurs et y ajouter des onboardings.',
    CreateNewSpace: 'Créer un nouvel espace',
    NoSpacesYet: 'Aucun espace pour le moment',
    NoSpacesYetDescription: 'Commencez par créer votre premier espace pour organiser vos onboardings.',
    CreateYourFirstSpace: 'Créez votre premier espace',
    OnboardingNoDescriptionYet: "Cet onboarding n'a pas encore de description.",
    // App.vue
    NoPasswordWarning: "Votre compte n'a pas de mot de passe.",
    CreatePasswordCTA: 'Cliquez ici pour en créer un.',
    TCVelikTip: 'Astuce TCVelik',
    RecommendExtensionText: "Nous recommandons d'utiliser Chrome avec l'extension installée pour une meilleure expérience et des résultats contextuels. Cliquez ici pour l'installer.",
    AutoLoginSuccessful: 'Connexion automatique réussie',
    AutoLoginSuccessfulText: 'Vous avez été connecté automatiquement via l’extension TCVelik.',
    PasswordResetEmailSent: 'Un e-mail contenant un lien pour définir un nouveau mot de passe a été envoyé.',
    PleaseCheckInbox: 'Veuillez vérifier votre boîte de réception.',
    UserErrorPleaseLogin: "Une erreur s'est produite avec votre utilisateur. Veuillez vous reconnecter.",
    LicenseWarningTitle: 'Alerte de licence :',
    ManageLicenseCTA: 'Cliquez ici pour gérer votre licence.',
    // Cadence options
    Now: 'Maintenant',
    Daily: 'Quotidien',
    Weekly: 'Hebdomadaire',
    Monthly: 'Mensuel',
    Quarterly: 'Trimestriel',
    Yearly: 'Annuel',
    SpecificDate: 'Date spécifique'
    ,
    // OnboardingScheduleComponent
    Reviewer: 'Examinateur',
    Cadence: 'Cadence',
    DateDue: 'Date d\'échéance',
    SetReviewCadence: 'Définir la cadence de révision de cet onboarding'
    ,
    // AssignComponent.vue
    AllUsers: 'Tous les utilisateurs',
    AssignedUsers: 'Utilisateurs affectés',
    SuccessfullyAssignedItem: 'Élément affecté avec succès.',
    NoSuchUserExists: 'Cet utilisateur n\'existe pas.',
    ProblemSharingOnboarding: 'Un problème est survenu lors du partage de cet onboarding.',
    ErrorFetchingUsers: 'Des erreurs se sont produites lors de la récupération des utilisateurs',
    SelectedUsers: 'Utilisateurs sélectionnés',
    ZeroSelected: '0 sélectionné'
    ,
    // AssignToRoleComponent.vue
    ErrorFetchingAssignedRoles: 'Des erreurs se sont produites lors de la récupération des rôles affectés',
    ErrorFetchingRoles: 'Des erreurs se sont produites lors de la récupération des rôles',
    NoSuchRoleExists: 'Ce rôle n\'existe pas.',
    ProblemAssigningItemToRole: 'Un problème est survenu lors de l\'affectation de cet élément au rôle.',
    SuccessfullyUnassignedItem: 'Élément désaffecté avec succès.'
    ,
    // AssignComponent placeholders
    SearchUserPlaceholder: 'Rechercher un utilisateur ...',
    SortByPlaceholder: 'Trier par...',
    OrderOfSortPlaceholder: 'Ordre de tri',
    FullNameHeader: 'Nom complet',
    ActionsHeader: 'Actions'
    ,
    // LicensingCatalog.vue
    TCVelikLicensing: 'Licences',
    ChoosePerfectPlan: 'Choisissez le plan parfait pour votre organisation.',
    LicensingHelpText: 'Si vous avez des questions ou besoin de conseils sur le fonctionnement de nos licences - veuillez visiter notre',
    Website: 'site web',
    Or: 'ou',
    BookMeeting: 'réserver une réunion',
    WithUsDirectly: 'directement avec nous.',
    YourLicenses: 'Vos licences',
    LicenseHolder: 'Titulaire de la licence',
    Edition: 'Édition',
    RenewsAt: 'Se renouvelle le',
    Domain: 'Domaine',
    NA: 'N/D',
    AvailableForUse: 'Disponible pour utilisation',
    UseThisLicense: 'Utiliser cette licence',
    PurchaseAdditionalLicenses: 'Acheter des licences supplémentaires :',
    NoDescriptionAvailable: 'Aucune description disponible',
    Here: 'ici',
    LoadingLicensingOptions: 'Chargement des options de licence...',
    NoLicensingOptionsAvailable: 'Aucune option de licence disponible',
    NoLicensingOptionsText: 'Il n\'y a actuellement aucune option de licence disponible. Veuillez contacter le support.',
    ActivateLicense: 'Activer la licence',
    EnterEmailToActivate: 'Veuillez saisir votre adresse e-mail pour activer cette licence :',
    EmailPlaceholder: 'votre.email@exemple.fr',
    EmailAddress: 'Adresse e-mail',
    Cancel: 'Annuler',
    Processing: 'En cours...',
    OnlyAvailableOnPersonal: 'Disponible uniquement sur personal.tcvelik.com',
    FreeForever: 'Gratuit pour toujours',
    ContactSales: 'Contacter les ventes',
    NoCreditCardRequired: 'Aucune carte de crédit requise',
    Per: 'par',
    OneTimePayment: 'Paiement unique',
    PurchaseNow: 'Acheter maintenant',
    YouAndYourTeamCanDownload: 'Vous et votre équipe pouvez télécharger et utiliser TCVelik Personal Edition',
    FailedToLoadProducts: 'Échec du chargement des produits de licence',
    NoPricingAvailable: 'Aucun tarif disponible',
    NoPricingOptionsText: 'Ce produit n\'a pas d\'options de tarification',
    SelectionRequired: 'Sélection requise',
    PleaseSelectPricing: 'Veuillez sélectionner une option de tarification',
    FailedToCreatePaymentLink: 'Échec de la création du lien de paiement. Veuillez réessayer.',
    InvalidEmail: 'E-mail invalide',
    PleaseEnterValidEmail: 'Veuillez saisir une adresse e-mail valide',
    LicenseActivated: 'Licence activée !',
    LicenseActivatedSuccess: 'Votre licence a été activée avec succès.',
    ActivationFailed: 'Échec de l\'activation',
    FailedToActivateLicense: 'Échec de l\'activation de la licence. Veuillez réessayer.',
    LicenseSwitched: 'Licence changée !',
    LicenseSwitchedSuccess: 'Vous utilisez maintenant une licence différente. Le domaine précédent cessera de fonctionner dans les 2 heures.',
    SwitchFailed: 'Échec du changement',
    FailedToSwitchLicense: 'Échec du changement de licence. Veuillez réessayer.',
    SwitchLicenseConfirmation: 'Êtes-vous sûr de vouloir basculer vers la licence {product} ?\n\n⚠️ Important : Cela rendra votre licence actuelle indisponible sur ce domaine pendant jusqu\'à 2 heures en raison de la mise en cache. L\'autre domaine cessera temporairement de fonctionner.\n\nVoulez-vous continuer ?',
    Renewed: 'Renouvelé',
    RenewsToday: 'Se renouvelle aujourd\'hui',
    RenewsTomorrow: 'Se renouvelle demain',
    RenewsInDays: 'Se renouvelle dans {days} jours',
    Expired: 'Expiré',
    ExpiresToday: 'Expire aujourd\'hui',
    ExpiresTomorrow: 'Expire demain',
    ExpiresInDays: 'Expire dans {days} jours',

    // Search.vue
    BasicSearch: 'Recherche de base',
    Results: 'résultats',
    FoundNothing: 'rien trouvé.',
    NoResults: 'Aucun résultat',
    SearchReturnedNoResults: 'La recherche n\'a retourné aucun résultat.',
    KeepTrying: 'Continuez d\'essayer...',
    WorkingSearch: 'Travail en cours ...',
    ResultsComingShortly: 'Résultats à venir bientôt ...',
    IntentFilters: 'Filtres d\'intention:',
    ShowAll: 'Afficher tout',
    ClearAll: 'Tout effacer',
    Filter: 'Filtrer',
    SuccessNotification: 'Succès !',
    TextCopiedSuccessfully: 'Texte copié avec succès.',
    Failed: 'Échec !',
    ErrorInCopyingText: 'Erreur lors de la copie du texte.',

    // AccountBranding.vue
    AccountBranding: 'Image de marque du compte',
    Favicon: 'Favicon',
    ChangedIcon: 'Icône modifiée.',
    ProblemSavingIcon: 'Il y a eu un problème lors de la sauvegarde de votre icône.',
    Saved: 'Enregistré',

    // AdminControlPanel.vue
    CreateWebhook: 'Créer un webhook',
    Database: 'Base de données',
    SystemSettings: 'Paramètres système',
    ChangeLanguage: 'Changer de langue',
    CreateMagicLink: 'Créer un lien magique',
    Webhooks: 'Webhooks',
    CreateEmbedScript: 'Créer un script d\'intégration pour l\'exécution',
    EventType: 'Type d\'événement',
    FilterByRoles: 'Filtrer par rôles',
    MagicLink: 'Lien magique',
    CampaignName: 'Nom de la campagne',
    ExistingMagicLinkTokens: 'Jetons de lien magique existants',
    LoadTokens: 'Charger les jetons',
    DateCreated: 'Date de création',
    TargetURL: 'URL cible',
    RoleToken: 'Jeton de rôle',
    CopyLink: 'Copier le lien',
    LoadingMagicLinkTokens: 'Chargement des jetons de lien magique...',
    CreateWebhookButton: 'Créer un webhook',
    FormatDocument: 'Formater le document',
    SuccessfullyUpdatedSettings: 'Paramètres mis à jour avec succès.',
    ProblemOccurredDownloading: 'Un problème s\'est produit lors du téléchargement de la base de données.',
    ProblemOccurredSaving: 'Un problème s\'est produit lors de la tentative de sauvegarde des modifications.',
    ProblemOccurredCreating: 'Un problème s\'est produit lors de la tentative de création d\'un webhook.',
    ProblemOccurredFetching: 'Un problème s\'est produit lors de la tentative de récupération des webhooks.',
    ProblemOccurredDeleting: 'Un problème s\'est produit lors de la tentative de suppression de ce webhook.',
    ProblemOccurredLoading: 'Un problème s\'est produit lors de la tentative de chargement du code du script d\'injection.',
    SuccessfullyCreatedMagicLink: 'Lien magique créé avec succès.',
    SuccessfullyCreatedWebhook: 'Webhook créé avec succès.',
    SuccessfullyDeletedWebhook: 'Webhook supprimé avec succès.',
    FailedToLoadMagicLinkTokens: 'Échec du chargement des jetons de lien magique',
    LinkCopiedToClipboard: 'Lien copié dans le presse-papiers',
    
    // Additional notification messages
    SuccessExclamation: 'Succès !',
    SuccessfullyDeletedSubspace: 'Sous-espace supprimé avec succès !',
    ProblemOccurredDeletingSubspace: 'Un problème s\'est produit lors de la tentative de suppression de ce sous-espace !',
    InvalidPassword: 'Mot de passe invalide',
    NoAccessToResource: 'Aucun accès à cette ressource',
    NoAccessToResourceText: 'Il semble que vous essayez d\'accéder à cet article avec un e-mail qui n\'a pas accès. Si vous pensez que c\'est une erreur - veuillez contacter la personne qui l\'a partagé.',
    CodeSentToEmail: 'Un code a été envoyé à votre e-mail.',
    CodeAlreadySentToEmail: 'Un code a déjà été envoyé à votre e-mail.',
    SavedOrderOfOnboardings: 'Ordre des intégrations sauvegardé',
    FailedToSaveOrder: 'Échec de la sauvegarde de l\'ordre.',
    SavedOrderOfSubspaces: 'Ordre des sous-espaces sauvegardé',
    LinkSent: 'Lien envoyé',
    SomethingWentWrongSendingLink: 'Quelque chose s\'est mal passé lors de la tentative d\'envoi du lien...',
    CouldNotLoadSpaceDetails: 'Impossible de charger les détails de l\'espace',
    FailedToLoadSpaceInformation: 'Échec du chargement des informations de l\'espace',
    SavedChanges: 'Modifications sauvegardées',
    ProblemAddingImage: 'Il y a eu un problème lors de l\'ajout de votre image.',
    TCVelikContentPasted: 'Contenu TCVelik collé',
    StepsAddedSuccessfully: '{count} étape(s) ajoutée(s) avec succès',
    CursorNotInsideCustomNode: 'Le curseur n\'est pas dans un nœud personnalisé.',
    SOPFormatExport: 'Export au format SOP',
    SOPFormatExportComingSoon: 'La fonctionnalité d\'export au format SOP sera bientôt implémentée !',
    SuccessfullySavedImage: 'Image sauvegardée avec succès !',
    DocumentFormatted: 'Document formaté',
    UserHasBeenDeleted: 'L\'utilisateur a été supprimé',
    SomethingWentWrongDeletingUser: 'Quelque chose s\'est mal passé lors de la tentative de suppression de cet utilisateur...',
    CannotGeneratePreviewForUnsavedOnboarding: 'Impossible de générer un aperçu pour un onboarding non sauvegardé !',
    CameraNotAllowed: 'Caméra non autorisée. Veuillez autoriser l\'accès.',
    ErrorAccessingCamera: 'Erreur lors de l\'accès à la caméra.',
    PleaseOpenAnOnboarding: 'Veuillez ouvrir un onboarding',
    OnboardingNotSavedCannotBeShared: 'L\'onboarding n\'a pas été sauvegardé et ne peut pas être partagé',
    DraftDeleted: 'Brouillon supprimé',
    ErrorOccurredDeletingDraft: 'Une erreur s\'est produite lors de la tentative de suppression de ce brouillon.',
    OnboardingDeleted: 'Onboarding supprimé',
    ErrorOccurredDeletingOnboarding: 'Une erreur s\'est produite lors de la tentative de suppression de cet onboarding.',
    InvalidURL: 'URL invalide',
    PleaseFillInValidURL: 'Veuillez remplir une URL valide',
    OnboardingWasSaved: '{name} a été sauvegardé.',
    SuccessfullyCreatedAndAddedOnboardingToSpace: 'Onboarding créé et ajouté à l\'espace avec succès !',
    DomainLabelsHaveBeenApplied: 'Les étiquettes de domaine ont été appliquées.',
    
    // Navbar and Sidebar localization
    SearchWithAI: 'Rechercher avec IA',
    SearchPlaceholderNavbar: 'Rechercher...',
    ManageUsers: 'Gérer les utilisateurs',
    Skills: 'Compétences',
    Focus: 'Focus',
    AnalysisCompleted: 'Analyse terminée',
    ProjectWasAnalyzed: 'Le projet {projectName} a été analysé.',
    AnalysisStarted: 'Analyse démarrée',
    AnalysisWithTitle: 'Analyse {title}',
    UserDoesNotHaveSlug: 'Cet utilisateur n\'a pas de slug, veuillez aller à Admin du compte et mettre à jour le slug utilisateur.',
    YearsAgo: 'il y a {years} {yearsText}',
    YearAgo: 'il y a {years} An',
    DaysAgoSidebar: 'il y a {days} {daysText}',
    DayAgo: 'il y a {days} Jour',
    HoursAgo: 'il y a {hours} {hoursText}',
    HourAgo: 'il y a {hours} Heure',
    MinutesAgo: 'il y a {minutes} {minutesText}',
    MinuteAgo: 'il y a {minutes} Min',
    SecondsAgo: 'il y a {seconds} sec',
    JustNow: 'À l\'instant',
    Years: 'Ans',
    Days: 'Jours',
    Hours: 'H',
    Min: 'Min',
    NoInfo: 'Aucune info',
    UnknownAccount: 'Compte inconnu',
    English: 'Anglais',
    Portuguese: 'Portugais',
    French: 'Français',
    German: 'Allemand',
    DownloadDatabase: 'Télécharger la base de données',
    DownloadVersionHistoryDatabase: 'Télécharger la base de données d\'historique des versions',
    SaveChanges: 'Enregistrer les modifications',
    NoMagicLinkTokensFound: 'Aucun jeton de lien magique trouvé.',
    SafelyReloading: 'Rechargement sécurisé de la page...',

    // NoItemsCard.vue
    NoSOPsAvailable: 'Aucune SOP disponible',
    NoSOPsAvailableDescription: 'Il semble qu\'il n\'y ait pas encore de procédures opératoires standard (SOP) dans votre compte. Vous pouvez commencer à capturer vos processus en utilisant l\'une de ces méthodes :',
    SubspacesDescription: 'TCVelik vous permet de regrouper davantage vos éléments en créant des sous-espaces dans les espaces.',
    ManualCreation: 'Création manuelle',
    ManualCreationDescription: 'Créez des SOP étape par étape avec notre éditeur manuel',
    ChromeExtension: 'Extension Chrome',
    ChromeExtensionDescription: 'Installez notre extension de navigateur pour un enregistrement transparent pendant que vous travaillez',
    DesktopRecorder: 'Enregistreur de bureau',
    DesktopRecorderDescription: 'Utilisez notre application de bureau pour l\'enregistrement d\'écran avancé',
    MobileRecording: 'Enregistrement mobile',
    MobileRecordingDescription: 'Enregistrez des SOP du monde physique avec votre téléphone mobile - aucune application requise',
    MoreInformationText: 'Plus d\'informations sur la capture de vos SOP peuvent être trouvées',

    // Login.vue and Register.vue notifications
    WelcomeAdminCreated: '🎉 Bienvenue ! Votre compte administrateur a été créé avec succès.',
    PleaseLoginWithCredentials: 'Veuillez vous connecter avec vos identifiants pour accéder au système.',
    LinkedInAuthentication: 'Authentification LinkedIn',
    ConnectingToLinkedIn: 'Connexion à LinkedIn...',
    LoginFailed: 'Échec de la connexion',
    LinkedInAuthNotConfigured: 'Le service d\'authentification LinkedIn n\'est pas correctement configuré.',
    CannotConnectLinkedIn: 'Impossible de se connecter au service d\'authentification LinkedIn.',
    LoginAttempt: 'Tentative de connexion',
    AlreadyLoggedIn: 'Vous êtes déjà connecté !',
    CreateAccount: 'Créer un compte',
    WelcomeToTCVelik: '🎉 Bienvenue sur TCVelik ! C\'est votre première configuration.',
    YouWillBeAdmin: 'Vous serez créé en tant qu\'Administrateur de ce système.',
    FillFormToCreateAccount: 'Remplissez le formulaire ci-dessous pour créer un nouveau compte.',
    AcceptTermsConditions: 'J\'accepte les termes et conditions.',
    RegistrationInProgress: 'Inscription en cours !',
    PleaseWait: 'Veuillez patienter..',
    AdminAccountCreatedSuccessfully: 'Compte administrateur créé avec succès ! Veuillez vous connecter pour continuer.',
    AccountCreatedRedirecting: 'Compte créé. Redirection vers la connexion..',
    AccountNotCreated: 'Compte non créé.',

    // ImageUploadPopup.vue
    UploadImage: 'Télécharger une image',
    DragDropImageOrClick: 'Glissez-déposez une image ici ou cliquez pour sélectionner',
    Preview: 'Aperçu',
    OR: 'OU',
    EnterImageURL: 'Entrez l\'URL de l\'image',
    Submit: 'Soumettre',

    // GenericProgressPopup.vue
    YourTypeIsInProgress: 'Votre {type} est en cours',
    ContinueWorkingFileWillDownload: 'Vous pouvez continuer à travailler. Une fois prêt - le fichier sera automatiquement téléchargé.',
    Step: 'Étape',

    // CameraStepScreen.vue
    Capture: 'Capturer',
    Done: 'Terminé',
    ImagesCaptured: '{count} images capturées',
    SaveSteps: 'Enregistrer les étapes',
    StepImage: 'Image de l\'étape',
    StepTitle: 'Titre de l\'étape',
    StepDescription: 'Description de l\'étape',
    BrowserNotSupportCamera: 'Votre navigateur ne prend pas en charge l\'accès à la caméra.',

    // OnboardingAnalytics.vue
    ResolveFlaggedStepTitle: 'Résoudre l\'étape signalée',
    CommentLabel: 'Commentaire',
    NotifyReporter: 'Notifier la personne qui a signalé cela',
    MarkAsResolved: 'Marquer comme résolu',
    SaveSearchQueryTitle: 'Enregistrer la requête de recherche',
    NameLabel: 'Nom',
    UrlLabel: 'URL',
    EditSearchQueryTitle: 'Modifier la requête de recherche',
    FilterBySpaces: 'Filtrer par espaces',
    FilterByOnboardings: 'Filtrer par onboardings',
    DateRange: 'Plage de dates',
    SaveThisSearchQuery: 'Enregistrer cette requête de recherche',
    SaveFilters: 'Enregistrer les filtres',
    Options: 'Options',
    DeleteThisSearchQuery: 'Supprimer cette requête de recherche',
    EditNameAndUrl: 'Modifier le nom et l\'URL',
    EditFilters: 'Modifier les filtres',
    TotalSOPs: 'Total des SOPs',
    TotalUsers: 'Total des utilisateurs',
    CompletionRate: 'Taux d\'achèvement',
    InProgressLabel: 'En cours',
    NotStarted: 'Non démarré',
    EstimatedHoursSaved: 'Heures économisées estimées',
    DocumentationRequests: 'Demandes de documentation',
    FlaggedSteps: 'Étapes signalées',
    UsersCompletedMostOnboardings: 'Utilisateurs ayant terminé le plus d\'onboardings',
    CompletedCountForPeriod: '{count} onboardings terminés pour cette période',
    NoDataForThisOnboarding: 'Aucune donnée pour cet onboarding',
    SOPStats: 'Statistiques SOP',
    RatingsCount: '{count} évaluations',
    EstimatedHoursSavedShort: '{hours} heures économisées',
    NoItemsToShow: 'Aucun élément à afficher',
    ErrorFetchingData: 'Une erreur s\'est produite lors de la récupération des données',
    ResolvedStep: 'L\'étape a été résolue',
    ProblemResolvingStep: 'Un problème est survenu lors de la résolution de cette étape',
    ErrorFetchingHeatmap: 'Une erreur s\'est produite lors de la récupération des données de la carte thermique',
    SavedQuery: 'Requête de recherche enregistrée avec succès',
    ProblemSavingQuery: 'Un problème est survenu lors de l\'enregistrement de la requête',
    DeletedQuery: 'Requête de recherche supprimée avec succès',
    SavedChangesGeneric: 'Modifications enregistrées avec succès',
    ProblemSavingFilters: 'Un problème est survenu lors de l\'enregistrement des filtres',

    // Users.vue
    UsersTitle: 'Utilisateurs',
    InviteUser: 'Inviter un utilisateur',
    Invitations: 'Invitations',
    Suggestions: 'Suggestions',

    // InviteUserModal.vue
    InviteUserTitle: 'Inviter un utilisateur',
    EmailAddressLabel: 'Adresse e-mail',
    EmailPlaceholderUser: 'utilisateur@exemple.fr',
    SelectRoles: 'Sélectionner les rôles',
    CustomMessagePlaceholder: 'Optionnel : Ajoutez un message personnel...',
    CustomMessageLabel: 'Message personnalisé (Optionnel)',
    LinkExpirationLabel: 'Expiration du lien (heures)',
    ExpirationPlaceholder: '120',
    AllowUserRegistration: 'Autoriser l\'utilisateur à s\'inscrire s\'il n\'existe pas',
    Sending: 'Envoi en cours...',
    SendInvitation: 'Envoyer l\'invitation',
    FailedToLoadRoles: 'Échec du chargement des rôles',
    RoleCreatedSuccessfully: 'Rôle créé avec succès',
    RoleAlreadyExists: 'Un rôle avec ce nom existe déjà',
    FailedToCreateRole: 'Échec de la création du rôle',
    InvitationSentSuccessfully: 'Invitation envoyée avec succès pour {count} rôle(s).',
    FailedToSendInvitation: 'Échec de l\'envoi de l\'invitation',

    // InvitationList.vue
    InvitationLinkTitle: 'Lien d\'invitation',
    UseThisLinkToInvite: 'Utilisez ce lien pour inviter l\'utilisateur.',
    EmailHeader: 'E-mail',
    RolesHeader: 'Rôles',
    CreatedHeader: 'Créé',
    ExpiresHeader: 'Expire',
    StatusHeader: 'Statut',
    VisitsHeader: 'Visites',
    InvitedByHeader: 'Invité par',
    ExpiredStatus: 'Expiré',
    ActiveStatus: 'Actif',
    LastVisit: 'Dernier :',
    InvitationGroup: 'Invitation',
    CopyLinkAction: 'Copier le lien',
    ResendEmailAction: 'Renvoyer l\'e-mail',
    ErrorLoadingInvitations: 'Erreur lors du chargement des invitations',
    InvitationLinkCopied: 'Lien d\'invitation copié avec succès.',
    ResendInvitationConfirm: 'Renvoyer l\'e-mail d\'invitation à {email} ?',
    InvitationResent: 'Invitation renvoyée',
    ErrorResendingInvitation: 'Erreur lors du renvoi de l\'invitation',

    // UserList.vue
    LoginLinkTitle: 'Lien de connexion',
    UseThisLinkToSignIn: 'Utilisez le lien pour vous connecter en tant que cet utilisateur.',
    LastLoginHeader: 'Dernière connexion',
    RoleHeader: 'Rôle',
    SourceHeader: 'Source',
    NotAvailable: 'N/D',
    EditGroup: 'Modifier',
    EditAction: 'Modifier',
    DeleteAction: 'Supprimer',
    SendLoginLinkAction: 'Envoyer le lien de connexion',
    ResetPasswordAction: 'Réinitialiser le mot de passe',
    AscendingSort: 'Croissant',
    DescendingSort: 'Décroissant',
    LastLoginDateSort: 'Date de dernière connexion',
    CreatedSort: 'Créé',
    ProblemsSavingChanges: 'Des problèmes sont survenus lors de l\'enregistrement de vos modifications.',
    ResetPasswordConfirm: 'Réinitialiser le mot de passe de cet utilisateur ?',
    ResetPasswordError: 'Réinitialiser le mot de passe',
    SendLoginLinkConfirm: 'Envoyer un lien de connexion ?',
    DeleteUserConfirm: 'Êtes-vous ABSOLUMENT SÛR, cette action ne peut pas être annulée !',

    // UserEditorScreen.vue
    EditUserTitle: 'Modifier l\'utilisateur',
    AddNewUserTitle: 'Ajouter un nouvel utilisateur',
    UploadImageTitle: 'Télécharger une image',
    CreateUserTab: 'Créer un utilisateur',
    AddUserToRoleTab: 'Ajouter un utilisateur au rôle',
    ChangePasswordTab: 'Changer le mot de passe',
    APIAccessTab: 'Accès API',
    InviteUserTab: 'Inviter un utilisateur',
    FirstNameLabel: 'Prénom',
    LastNameLabel: 'Nom',
    NewPasswordLabel: 'Nouveau mot de passe',
    ConfirmPasswordLabel: 'Confirmer le mot de passe',
    APIKeyLabel: 'Clé API',
    ManageRoles: 'Gérer les rôles',
    SaveButton: 'Enregistrer',
    CreateUserButton: 'Créer un utilisateur',
    ChangeButton: 'Modifier',
    ResetAPIKeyButton: 'Réinitialiser la clé API',
    GenerateNewButton: 'Générer nouveau',
    InviteButton: 'Inviter',
    AddedRole: 'Rôle ajouté.',
    RoleNameAlreadyExists: 'Un rôle avec ce nom existe déjà.',
    ChangedAvatar: 'Avatar modifié.',
    ProblemSavingAvatar: 'Un problème est survenu lors de l\'enregistrement de votre avatar.',
    UserInvited: '{email} a été invité. Continuez à ajouter.',
    SuccessfullyCreatedUser: 'Utilisateur créé avec succès !',
    ProblemCreatingUser: 'Un problème est survenu lors de la création de l\'utilisateur.',
    GeneratedAPIKey: 'Clé API générée.',
    ProblemGeneratingAPIKey: 'Un problème est survenu lors de la génération de la clé API...',
    ResetAPIKey: 'Clé API réinitialisée.',
    ProblemResettingAPIKey: 'Un problème est survenu lors de la réinitialisation de la clé API...',
    PasswordResetEmailSentUserEditor: 'Si votre e-mail est dans notre système - vous recevrez un e-mail de réinitialisation de mot de passe.',
    GenerateAPIKeyConfirm: 'Générer une clé API pour cet utilisateur ?',
    ResetAPIKeyConfirm: 'Réinitialiser la clé API pour cet utilisateur ?'
  },
  pt: {
    Dashboard: 'painel de controle',
    eCommerce: 'comércio eletrônico',
    Apps: 'APPS',
    Todo: 'Façam',
    Chat: 'Bate-papo',
    Email: 'O email',
    Calendar: 'Calendário',
    FullCalendar: 'Calendário Completo',
    SimpleCalendar: 'Calendário Simples',
    Shop: 'fazer compras',
    Cart: 'Carrinho',
    WishList: 'Lista de Desejos',
    Checkout: 'Confira',
    UIElements: 'UI Elementos',
    DataList: 'Lista de dados',
    ListView: 'Exibição de lista',
    ThumbView: 'Thumb View',
    Grid: 'Grade',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Cores',
    Card: 'Cartão',
    Basic: 'Basic',
    Statistics: 'Estatisticas',
    Analytics: 'Analytics',
    CardActions: 'Ações do Cartão',
    CardColors: 'Cores do cartão',
    Table: 'Mesa',
    agGridTable: 'Tabela AgGrid',
    Components: 'Componentes',
    Alert: 'Alerta',
    Avatar: 'Avatar',
    Badge: 'Crachá',
    Breadcrumb: 'Breadcrumb',
    Button: 'Botão',
    ButtonGroup: 'Grupo de botões',
    Chip: 'Lasca',
    Collapse: 'Colapso',
    Dialogs: 'Diálogos',
    Divider: 'Divisor',
    DropDown: 'Suspenso',
    List: 'Lista',
    Loading: 'Carregando',
    Navbar: 'Navbar',
    Notifications: 'Notificações',
    Pagination: 'Paginação',
    Popup: 'Aparecer',
    Progress: 'Progresso',
    Sidebar: 'Barra Lateral',
    Slider: 'Controle Deslizante',
    Tabs: 'Guias',
    Tooltip: 'dica de ferramenta',
    Upload: 'Envio',
    FormsAndTable: 'Formulários e tabela',
    FormElements: 'Elementos do formulário',
    Select: 'Selecione',
    Switch: 'Interruptor',
    Checkbox: 'Caixa de seleção',
    Radio: 'Rádio',
    Input: 'Entrada',
    NumberInput: 'Entrada numérica',
    Textarea: 'Textarea',
    FormLayouts: 'Layouts de formulário',
    FormWizard: 'Assistente de Formulário',
    FormValidation: 'Validação de Formulário',
    FormInputGroup: 'Grupo de entrada de formulário',
    Pages: 'PÁGINAS',
    Authentication: 'Autenticação',
    Login: 'Entrar',
    Register: 'Registo',
    Password: 'Password',
    ForgotPassword: 'Esqueceu A Senha',
    ResetPassword: 'Redefinir Senha',
    Reset: 'Redefinir',
    RecoverPassword: 'Recover Password',
    ConfirmPassword: 'Confirmar Senha',
    RememberMe: "Remember me",
    LockScreen: 'Tela de bloqueio',
    Miscellaneous: 'Diversos',
    ComingSoon: 'Em breve',
    Error: 'Erro',
    404: '404',
    500: '500',
    NotAuthorized: 'Não autorizado',
    ToggleFullscreen: 'Alternar tela cheia',
    SomethingIsntQuiteRight: 'Algo não está certo',
    // OnboardingPDF Tour
    SopTitleTour: 'Este é o título do seu SOP. Você pode ver o nome e a descrição aqui.',
    StepsTour: 'Estes são seus passos. Clique no cabeçalho para expandir/recolher o conteúdo.',
    ToolsTour: 'Use estes controles para marcar etapas como concluídas ou sinalizá-las para revisão.',
    MenuTour: 'Por fim, as ações do onboarding também podem ser encontradas aqui, além de opções avançadas.',
    // OnboardingPDF.vue additions (pt)
    VerifyYourEmail: 'Verifique seu e-mail',
    VerificationCode: 'Código de verificação',
    PleaseEnterYourEmailVerification: 'Por favor, insira seu e-mail para continuar.',
    WeHaveJustSentEmailWithPin: 'Acabamos de enviar um e-mail com um PIN. Insira-o abaixo para prosseguir.',
    Code: 'Código',
    ViewAsSlideshow: 'Ver como apresentação de slides',
    RecordedWith: 'Gravado com',
    ClickLinkBetterExperience: 'Clique no link para uma melhor experiência',
    ExternalContentMessage: 'Este passo aponta para conteúdo externo. Você será redirecionado para uma página externa.',
    IUnderstandProceed: 'Entendo, prosseguir',
    ImageView: 'Visualização da imagem',
    GuestUsersViewOnly: 'Usuários convidados podem apenas visualizar conteúdo.',
    ProblemCompletingStep: 'Ocorreu um problema ao concluir esta etapa.',
    OnboardingSharedSuccessfully: 'Onboarding compartilhado com sucesso.',
    ErrorsSharingOnboarding: 'Ocorreram erros ao compartilhar este onboarding.',
    FieldCannotBeEmpty: 'Este campo não pode estar vazio',
    SuccessfullyAddedToSpace: 'Adicionado ao espaço com sucesso.',
    ProblemAddingToSpace: 'Problema ao adicionar ao espaço.',
    SuccessfullyRemovedFromSpace: 'Removido do espaço com sucesso.',
    ProblemRemovingFromSpace: 'Problema ao remover do espaço.',
    SendLoginLink: 'Enviar link de login?',
    ProblemSendingLink: 'Ocorreu um problema ao enviar o link.',
    PageBeingConverted: 'Página sendo convertida...',
    ProblemConvertingToPDF: 'Ocorreu um problema ao converter para PDF.',
    PageCannotBeAccessed: 'Esta página não pode ser acessada.',
    InvalidLink: 'Link inválido.',
    NoAccessEmailMessage: 'Acesso negado para este e-mail. Entre em contato com quem compartilhou.',
    EditorNotFound: 'Editor não encontrado',
    CopyToClipboard: 'Copiar para a área de transferência',
    ExpandStepContents: 'Expandir conteúdo da etapa',
    CollapseStepContent: 'Recolher conteúdo da etapa',
    MarkStepCompleted: 'Marcar etapa concluída',
    Fullscreen: 'Tela cheia',
    FlagThisStep: 'Sinalizar esta etapa',
    AddCommentToStep: 'Sinalizar esta etapa',
    ContentMissingOrNoPermissions: 'O conteúdo que você procura está faltando ou você não tem permissões para acessá-lo.',
    SubmitFeedbackIfError: 'Se você acredita que isso é um erro - envie um feedback.',
    BackToHome: 'Voltar para Início',
    LoginAndRetry: 'Fazer login e tentar novamente',
    Maintenance: 'Manutenção',
    Profile: 'Perfil',
    Invoice: 'Fatura',
    FAQ: 'Perguntas frequentes',
    Search: 'Procurar',
    KnowledgeBase: 'Base de Conhecimento',
    ChartsAndMaps: 'Gráficos E Mapas',
    Charts: 'Gráficos',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Mapa',
    Extensions: 'Extensão',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Arraste e solte',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Seletor de data e hora',
    AccessControl: 'Controle de acesso',
    EditorView: 'Editor View',
    AdminView: 'Vista de administração',
    I18n: 'I18n',
    Carousel: 'Carrossel',
    Clipboard: 'Prancheta',
    ContextMenu: 'Menu contextual',
    StarRatings: 'Classificações por estrelas',
    Autocomplete: 'autocompletar',
    Tree: 'Árvore',
    Others: 'Outras',
    MenuLevels: 'Níveis de Menu',
    MenuLevel2p1: 'Nível de menu 2.1',
    MenuLevel2p2: 'Nível de menu 2.2',
    MenuLevel3p1: 'Nível de menu 3.1',
    MenuLevel3p2: 'Nível de menu 3.2',
    DisabledMenu: 'Menu desativado',
    Support: 'Apoio, suporte',
    Documentation: 'Documentação',
    RaiseSupport: 'Levantar Suporte',
    demoTitle: 'Título do cartão',
    demoText: `O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.`,
    Record: 'Record',
    Open: 'Open',
    Save: 'Save',
    Share: 'Сподели',
    SOPEditor: 'SOP Editor',
    DiscoverImprove: 'Discover & Improve',
    Spaces: 'Spaces',
    SpaceManager: 'Space Manager',
    Latest: 'Latest',
    MostUseful: 'Most useful',
    TailoredForYou: 'Tailored for you',
    Browse: 'Browse',
    Logout: 'Logout',
    MarkAsComplete: 'Mark as Complete',
    COMPLETED: "COMPLETED",
    Yes: "Yes",
    No: "No",
    Next: "Next",
    Back: "Back",
    Folders: 'Folders',
    BackToLogin: "Обратно към Login",
    //FEEDBACK CARD SPECIFIC(FeedbackCard.vue)
    FeedbackTitle: "We'd love your feedback",
    RateTitle: "How would you rate this SOP overall?",
    SaveTimeTitle: "Did this SOP save you time?",
    SaveTimeDescription: "Understanding time saved helps us prioritize improvements.",
    SaveTimeApproxTitle: "Approximately how much time did it save?",
    SaveTimeApproxDescription: "Rough estimate is fine - this helps us understand impact.",
    LessThanAnHour: "Less than 1 hour",
    OneToTwoHours: "1-2 hours",
    TwoToFourHours: "2-4 hours",
    MoreThanFourHours: "More than 4 hours",
    NotSure: 'Not sure',
    AlreadyKnowHowTitle: "Did you already know how to do this?",
    AlreadyKnowHowDescription: "This helps us understand if we're adding value beyond existing knowledge.",
    DocumentationBetterTitle: "Was our documentation better than what you knew?",
    RecommendSOPTitle: "Would you recommend this SOP to others?",
    RecommendSOPDescriptiion: "This helps us understand the overall effectiveness.",
    SOPEasyToFollowTitle: "Was this SOP easy to follow?",
    CommentsTitle: "Comments or suggestions for improvement?",
    CommentsDescription: "Optional: Any additional feedback helps us improve.",
    CommentTextAreaPlaceholder: "Tell us what could be better...",
    SubmitFeedbackButtonText: "Submit Feedback",
    PopupFeedbackCompletionText: "Thank you for your feedback!",

     //FORGOTTEN PASSWORD SPECIFIC (ForgottenPassword.vue)
    RecoverYourPassword: 'Recover your password',
    RecoverYourPasswordInstuctions: 'Please enter your email address and we\'ll send you instructions on how to reset your password.',
    RecoverPasswordMessage: 'If your email is in our system - you will receive a password reset email.',

    //ResetPassword.vue
    ResetPasswordPrompt: "Please enter your new password.",

    // SOPEditorMenu
    File: 'Arquivo',
    Import: 'Importar',
    Export: 'Exportar',
    ExportAs: 'Exportar como...',
    DownloadAsPPTX: 'Baixar como PPTX',
    TCVelikSOPFormat: 'Formato SOP TCVelik',
    AddToSpace: 'Adicionar ao Space',
    OpenReviewMenu: 'Abrir menu de revisão',
    GeneratePreviewLink: 'Gerar link de prévia',
    Delete: 'Excluir',
    Close: 'Fechar',
    Edit: 'Editar',
    Undo: 'Desfazer',
    Redo: 'Refazer',
    SelectAll: 'Selecionar tudo',
    View: 'Visualizar',
    HTMLSource: 'Código-fonte HTML',
    Tools: 'Ferramentas',
    Properties: 'Propriedades',
    Assign: 'Atribuir',
    AssignToRole: 'Atribuir a função',
    EditIntent: 'Editar intenção',
    ExitEditor: 'Sair do editor',
    Menu: 'Menu',

    // MainToolbar and Components
    // AlignmentButtons
    AlignLeft: 'Alinhar à esquerda',
    AlignCenter: 'Centralizar',
    AlignRight: 'Alinhar à direita',
    // TextFormattingButtons
    Heading: 'Título',
    Paragraph: 'Parágrafo',
    Bold: 'Negrito',
    Italic: 'Itálico',
    Underline: 'Sublinhado',
    // ListButtons
    BulletList: 'Lista com marcadores',
    NumberedList: 'Lista numerada',
    ManualSteps: 'Passos manuais',
    DefaultManual: 'Padrão',
    Warning: 'Aviso',
    Success: 'Sucesso',
    Informational: 'Informativo',
    CameraPicture: 'Câmera',
    CodeStep: 'Código',
    ErrorStep: 'Erro',
    Image: 'Imagem',
    Line: 'Linha',
    // ContentButtons
    AddLink: 'Adicionar link',
    AddImage: 'Adicionar imagem',
    // AdvancedButtons
    EditHTML: 'Editar HTML',
    // LineManagementButtons
    AddBlankLineAbove: 'Adicionar linha em branco acima',
    AddBlankLineBelow: 'Adicionar linha em branco abaixo',
    // FileOperationsButtons
    ShareOnboarding: 'Compartilhar onboarding',
    AssignOnboarding: 'Atribuir onboarding',
    AssignToRoleTitle: 'Atribuir a função',
    OpenPropertiesMenu: 'Propriedades',
    DeleteOnboarding: 'Excluir onboarding',

    // SignalsView.vue
    SignalsManagement: 'Gerenciamento de sinais',
    QuickFilters: 'Filtros rápidos',
    System: 'Sistema',
    Action: 'Ação',
    UserEmail: 'E-mail do usuário',
    ProcessedStatus: 'Status de processamento',
    All: 'Todos',
    Processed: 'Processado',
    Unprocessed: 'Não processado',
    Refresh: 'Atualizar',
    ManageFilters: 'Gerenciar filtros',
    ManageTags: 'Gerenciar tags',
    ApplyTags: 'Aplicar tags',
    CreateTestSignal: 'Criar sinal de teste',
    Context: 'Contexto',
    SOPHint: 'Dica de SOP',
    Created: 'Criado',
    Tags: 'Tags',
    ViewDetails: 'Ver detalhes',
    EditTags: 'Editar tags',
    Showing: 'Mostrando',
    to: 'a',
    of: 'de',
    signals: 'sinais',
    CreateNewFilter: 'Criar novo filtro',
    Name: 'Nome',
    Field: 'Campo',
    Operation: 'Operação',
    Value: 'Valor',
    CreateFilter: 'Criar filtro',
    FilterName: 'Nome do filtro',
    Description: 'Descrição',
    SelectField: 'Selecionar campo',
    SelectOperation: 'Selecionar operação',
    SecondValue: 'Segundo valor',
    CreateNewTag: 'Criar nova tag',
    Color: 'Cor',
    CreateTag: 'Criar tag',
    TagName: 'Nome da tag',
    ColorHex: 'Cor (Hex)',
    ApplyTagsToSignals: 'Aplicar tags aos sinais',
    SelectFilters: 'Selecionar filtros',
    SelectFiltersToApply: 'Selecionar filtros para aplicar',
    SelectTags: 'Selecionar tags',
    SelectTagsToApply: 'Selecionar tags para aplicar',
    FilterCreatedSuccessfully: 'Filtro criado com sucesso',
    FailedToCreateFilter: 'Falha ao criar filtro',
    TagCreatedSuccessfully: 'Tag criada com sucesso',
    FailedToCreateTag: 'Falha ao criar tag',
    FailedToLoadSignals: 'Falha ao carregar sinais',
    FailedToApplyTags: 'Falha ao aplicar tags',
    TestSignalCreatedSuccessfully: 'Sinal de teste criado com sucesso',
    FailedToCreateTestSignal: 'Falha ao criar sinal de teste',

    // SuggestionsList.vue
    SuggestedUsers: 'Usuários sugeridos',
    SignalCount: 'Contagem de sinais',
    LastActivity: 'Última atividade',
    AlreadyInvited: 'Já convidado',
    NewLabel: 'Novo',
    InvitationSent: 'Convite enviado',
    ReadyToInvite: 'Pronto para convidar',
    ForceProcess: 'Forçar processamento',
    FailedToLoadSuggestedUsers: 'Falha ao carregar usuários sugeridos',
    ProcessedSignals: '{count} sinais processados',
    FailedToProcessSignals: 'Falha ao processar sinais',

    // Profile.vue
    Hey: 'Olá',
    Stranger: 'Estranho',
    SOPsOpened: 'SOPs abertos',
    SOPsCompleted: 'SOPs concluídos',
    StepsCompleted: 'Etapas concluídas',
    RatingsGiven: 'Avaliações dadas',
    CertificatesEarned: 'Certificados obtidos',
    Filters: 'Filtros',
    Position: 'Posição',
    Manager: 'Gerente',
    Supervisor: 'Supervisor',
    Status: 'Status',
    Completed: 'Concluído',
    Pending: 'Pendente',
    ManagerPosition: 'Posição de gerente',
    SupervisorPosition: 'Posição de supervisor',
    Completion: 'Conclusão',
    OpeningProcedures: 'Procedimentos de abertura',
    ClosingProcedures: 'Procedimentos de fechamento',
    SafetyProtocol: 'Protocolo de segurança',
    EmployeeTraining: 'Treinamento de funcionários',

    // UserJourneyTimeline.vue
    YourJourney: 'Sua jornada',
    Last7Days: 'Últimos 7 dias',
    Last30Days: 'Últimos 30 dias',
    Last90Days: 'Últimos 90 dias',
    LastYear: 'Último ano',
    LoadingYourJourney: 'Carregando sua jornada...',
    FailedToLoadJourneyTimeline: 'Falha ao carregar sua linha do tempo de jornada. Tente novamente.',
    TryAgain: 'Tentar novamente',
    NoActivityYet: 'Nenhuma atividade ainda',
    JourneyTimelineWillAppear: 'Sua linha do tempo de jornada aparecerá aqui assim que você começar a interagir com SOPs.',
    Resolved: 'Resolvido',
    PendingResolution: 'Resolução pendente',
    Reason: 'Motivo',
    Resolution: 'Resolução',
    StepCompletedSuccessfully: 'Etapa {stepId} concluída com sucesso',
    Stars: 'estrelas',
    Comment: 'Comentário',
    Helpful: 'Útil',
    SavedMinutes: '{minutes} minutos economizados',
    AlreadyKnewThis: 'Já sabia disso',
    ViewSOP: 'Ver SOP',
    Today: 'Hoje',
    Yesterday: 'Ontem',
    DaysAgo: 'há {days} dias',
    WeekAgo: 'há {weeks} semana',
    WeeksAgo: 'há {weeks} semanas',
    Times: 'vezes',
    Opened: 'Aberto',
    EarnedCertificateFor: 'Certificado obtido para',
    FlaggedStepIn: 'Etapa sinalizada em',
    CompletedStepIn: 'Etapa concluída em',
    Rated: 'Avaliado',

    // Onboarding.vue
    NothingMatchesThisPage: 'Nada corresponde a esta página.',
    YouCanAddInfo: 'Você pode adicionar informações e tornar esta página parte de um onboarding existente ou novo usando o botão abaixo.',
    ShareAsEmail: 'Compartilhar por e-mail',
    SubjectLabel: 'Assunto:',
    EmailsCommaSeparated: 'E-mails (separados por vírgulas)',
    SendEmail: 'Enviar e-mail',
    PreviewLink: 'Link de pré-visualização',
    PreviewLinkLabel: 'Link de pré-visualização:',
    SavePopupTitle: 'Salvar',
    TitleLabel: 'Título:',
    DescriptionLabel: 'Descrição',
    ExternalUrl: 'URL externa',
    ManageNDomains: 'Gerenciar {count} domínios',
    SpaceLabel: 'Space:',
    OpenPreviewInNewTab: 'Abrir pré-visualização em nova aba',
    Publish: 'Publicar',
    SaveChangesToVersion: 'Salvar alterações para v. {major}.{minor}',
    SaveChangesToNewDraft: 'Salvar alterações em novo rascunho',
    ManageDomains: 'Gerenciar domínios',
    OpenOnboarding: 'Abrir Onboarding',
    SearchPlaceholder: 'Digite algo e pressione Enter...',
    ArtefactsDiscovered: 'Artefatos descobertos',
    OnboardingsForThisUrl: 'Onboardings para esta URL',
    ViewInNewTab: 'Ver em nova aba',
    GuideMode: 'Modo guia',
    AddStep: 'Adicionar etapa',
    EditStep: 'Editar etapa',
    DeleteStep: 'Excluir etapa',
    AddOnboardingToSpaceTitle: 'Adicionar onboarding ao Space',
    OnboardingProperties: 'Propriedades do onboarding'
    ,
    // Spaces.vue
    PremiumSpace: 'Espaço Premium',
    PremiumSpaceDescription: 'Este é um espaço premium que requer pagamento para acesso.',
    ProceedToPayment: 'Prosseguir para o pagamento',
    PropertiesTitle: 'Propriedades',
    ShareSpace: 'Compartilhar Espaço',
    AssignSpace: 'Atribuir Espaço',
    Verification: 'Verificação',
    PleaseEnterYourEmail: 'Por favor, insira seu e-mail.',
    EmailLabel: 'Email:',
    Send: 'Enviar',
    PinVerification: 'Verificação de PIN',
    CodeSentPrompt: 'Acabamos de enviar um e-mail com um código. Insira-o abaixo para prosseguir.',
    YourCode: 'Seu código',
    DidntReceiveCode: 'Não recebeu um código?',
    ClickHereToResend: 'Clique aqui para reenviar',
    ClickHereToLogin: 'Clique aqui para entrar.',
    Validate: 'Validar',
    CreateSubspace: 'Criar subespaço',
    CreateSpace: 'Criar Espaço',
    NoDescriptionYet: 'Este espaço ainda não tem descrição.',
    NoSubspacesHere: 'Nenhum subespaço aqui',
    NothingHere: 'Nada aqui...',
    SOPs: 'SOPs',
    NoSOPsInThisSpace: 'Nenhuma SOP neste Espaço',
    NoSOPsInThisSpaceDesc: 'Este espaço ainda não possui Procedimentos Operacionais Padrão (SOPs). Você pode começar a capturar seus processos usando qualquer um destes métodos:',
    SaveOnboardingOrder: 'Salvar ordem dos onboardings',
    SaveSubspaceOrder: 'Salvar ordem dos subespaços',
    OnboardingsHeader: 'Onboardings',
    SubspacesHeader: 'Subespaços',
    GridView: 'Visualização em grade',
    GoBack: 'Voltar',
    PDFLinkedInFormat: 'PDF (Formato LinkedIn)',
    HTMLFull: 'HTML Completo',
    AssignSpaceToUser: 'Atribuir espaço ao usuário',
    AddSubspace: 'Adicionar subespaço',
    // App.vue
    NoPasswordWarning: 'Sua conta não tem uma senha.',
    CreatePasswordCTA: 'Clique aqui para criar uma.',
    TCVelikTip: 'Dica TCVelik',
    RecommendExtensionText: 'Recomendamos usar o Chrome com a extensão instalada para a melhor experiência e resultados contextuais. Clique aqui para instalar.',
    AutoLoginSuccessful: 'Login automático bem-sucedido',
    AutoLoginSuccessfulText: 'Você foi conectado automaticamente via a extensão TCVelik.',
    PasswordResetEmailSent: 'Um e-mail foi enviado com um link para definir uma nova senha.',
    PleaseCheckInbox: 'Por favor, verifique sua caixa de entrada.',
    UserErrorPleaseLogin: 'Ocorreu um erro com seu usuário. Por favor, faça login novamente.',
    LicenseWarningTitle: 'Aviso de licença:',
    ManageLicenseCTA: 'Clique aqui para gerenciar sua licença.',
    // Cadence options
    Now: 'Agora',
    Daily: 'Diário',
    Weekly: 'Semanal',
    Monthly: 'Mensal',
    Quarterly: 'Trimestral',
    Yearly: 'Anual',
    SpecificDate: 'Data específica'
    ,
    // OnboardingScheduleComponent
    Reviewer: 'Revisor',
    Cadence: 'Cadência',
    DateDue: 'Data de vencimento',
    SetReviewCadence: 'Defina a cadência de revisão deste onboarding'
    ,
    // AssignComponent.vue
    AllUsers: 'Todos os usuários',
    AssignedUsers: 'Usuários atribuídos',
    SuccessfullyAssignedItem: 'Item atribuído com sucesso.',
    NoSuchUserExists: 'Este usuário não existe.',
    ProblemSharingOnboarding: 'Ocorreu um problema ao tentar compartilhar este onboarding.',
    ErrorFetchingUsers: 'Ocorreram erros ao buscar os usuários',
    SelectedUsers: 'Usuários selecionados',
    ZeroSelected: '0 selecionado'
    ,
    // AssignToRoleComponent.vue
    ErrorFetchingAssignedRoles: 'Ocorreram erros ao buscar as funções atribuídas',
    ErrorFetchingRoles: 'Ocorreram erros ao buscar as funções',
    NoSuchRoleExists: 'Esta função não existe.',
    ProblemAssigningItemToRole: 'Ocorreu um problema ao tentar atribuir este item à função.',
    SuccessfullyUnassignedItem: 'Atribuição do item removida com sucesso.'
    ,
    // AssignComponent placeholders
    SearchUserPlaceholder: 'Pesquisar usuário ...',
    SortByPlaceholder: 'Ordenar por...',
    OrderOfSortPlaceholder: 'Ordem de classificação',
    FullNameHeader: 'Nome completo',
    ActionsHeader: 'Ações'
    ,
    // LicensingCatalog.vue
    TCVelikLicensing: 'Licenciamento',
    ChoosePerfectPlan: 'Escolha o plano perfeito para sua organização.',
    LicensingHelpText: 'Se tiver dúvidas ou precisar de orientação sobre como funciona nosso licenciamento - visite nosso',
    Website: 'site',
    Or: 'ou',
    BookMeeting: 'agende uma reunião',
    WithUsDirectly: 'diretamente conosco.',
    YourLicenses: 'Suas licenças',
    LicenseHolder: 'Titular da licença',
    Edition: 'Edição',
    RenewsAt: 'Renova em',
    Domain: 'Domínio',
    NA: 'N/D',
    AvailableForUse: 'Disponível para uso',
    UseThisLicense: 'Usar esta licença',
    PurchaseAdditionalLicenses: 'Comprar licenças adicionais:',
    NoDescriptionAvailable: 'Nenhuma descrição disponível',
    Here: 'aqui',
    LoadingLicensingOptions: 'Carregando opções de licenciamento...',
    NoLicensingOptionsAvailable: 'Nenhuma opção de licenciamento disponível',
    NoLicensingOptionsText: 'Atualmente não há opções de licenciamento disponíveis. Entre em contato com o suporte.',
    ActivateLicense: 'Ativar licença',
    EnterEmailToActivate: 'Por favor, insira seu endereço de e-mail para ativar esta licença:',
    EmailPlaceholder: 'seu.email@exemplo.com',
    EmailAddress: 'Endereço de e-mail',
    Cancel: 'Cancelar',
    Processing: 'Processando...',
    OnlyAvailableOnPersonal: 'Disponível apenas em personal.tcvelik.com',
    FreeForever: 'Grátis para sempre',
    ContactSales: 'Contatar vendas',
    NoCreditCardRequired: 'Não é necessário cartão de crédito',
    Per: 'por',
    OneTimePayment: 'Pagamento único',
    PurchaseNow: 'Comprar agora',
    YouAndYourTeamCanDownload: 'Você e sua equipe podem baixar e usar o TCVelik Personal Edition',
    FailedToLoadProducts: 'Falha ao carregar produtos de licenciamento',
    NoPricingAvailable: 'Nenhum preço disponível',
    NoPricingOptionsText: 'Este produto não tem opções de preços',
    SelectionRequired: 'Seleção necessária',
    PleaseSelectPricing: 'Por favor, selecione uma opção de preço',
    FailedToCreatePaymentLink: 'Falha ao criar link de pagamento. Por favor, tente novamente.',
    InvalidEmail: 'E-mail inválido',
    PleaseEnterValidEmail: 'Por favor, insira um endereço de e-mail válido',
    LicenseActivated: 'Licença ativada!',
    LicenseActivatedSuccess: 'Sua licença foi ativada com sucesso.',
    ActivationFailed: 'Falha na ativação',
    FailedToActivateLicense: 'Falha ao ativar licença. Por favor, tente novamente.',
    LicenseSwitched: 'Licença trocada!',
    LicenseSwitchedSuccess: 'Você está agora usando uma licença diferente. O domínio anterior parará de funcionar em 2 horas.',
    SwitchFailed: 'Falha na troca',
    FailedToSwitchLicense: 'Falha ao trocar licença. Por favor, tente novamente.',
    SwitchLicenseConfirmation: 'Tem certeza de que deseja trocar para a licença {product}?\n\n⚠️ Importante: Isso tornará sua licença atual indisponível neste domínio por até 2 horas devido ao cache. O outro domínio parará de funcionar temporariamente.\n\nDeseja continuar?',
    Renewed: 'Renovado',
    RenewsToday: 'Renova hoje',
    RenewsTomorrow: 'Renova amanhã',
    RenewsInDays: 'Renova em {days} dias',
    Expired: 'Expirado',
    ExpiresToday: 'Expira hoje',
    ExpiresTomorrow: 'Expira amanhã',
    ExpiresInDays: 'Expira em {days} dias',

    // Search.vue
    BasicSearch: 'Pesquisa básica',
    Results: 'resultados',
    FoundNothing: 'nada encontrado.',
    NoResults: 'Nenhum resultado',
    SearchReturnedNoResults: 'A pesquisa não retornou resultados.',
    KeepTrying: 'Continue tentando...',
    WorkingSearch: 'Trabalhando ...',
    ResultsComingShortly: 'Resultados chegando em breve ...',
    IntentFilters: 'Filtros de intenção:',
    ShowAll: 'Mostrar todos',
    ClearAll: 'Limpar todos',
    Filter: 'Filtrar',
    SuccessNotification: 'Sucesso!',
    TextCopiedSuccessfully: 'Texto copiado com sucesso.',
    Failed: 'Falhou!',
    ErrorInCopyingText: 'Erro ao copiar texto.',

    // AccountBranding.vue
    AccountBranding: 'Marca da Conta',
    Favicon: 'Favicon',
    ChangedIcon: 'Ícone alterado.',
    ProblemSavingIcon: 'Houve um problema ao salvar seu ícone.',
    Saved: 'Salvo',

    // AdminControlPanel.vue
    CreateWebhook: 'Criar Webhook',
    Database: 'Banco de dados',
    SystemSettings: 'Configurações do sistema',
    ChangeLanguage: 'Alterar idioma',
    CreateMagicLink: 'Criar um link mágico',
    Webhooks: 'Webhooks',
    CreateEmbedScript: 'Criar um script de incorporação para execução',
    EventType: 'Tipo de evento',
    FilterByRoles: 'Filtrar por funções',
    MagicLink: 'Link mágico',
    CampaignName: 'Nome da campanha',
    ExistingMagicLinkTokens: 'Tokens de link mágico existentes',
    LoadTokens: 'Carregar tokens',
    DateCreated: 'Data de criação',
    TargetURL: 'URL de destino',
    RoleToken: 'Token de função',
    CopyLink: 'Copiar link',
    LoadingMagicLinkTokens: 'Carregando tokens de link mágico...',
    CreateWebhookButton: 'Criar webhook',
    FormatDocument: 'Formatar documento',
    SuccessfullyUpdatedSettings: 'Configurações atualizadas com sucesso.',
    ProblemOccurredDownloading: 'Ocorreu um problema ao baixar o banco de dados.',
    ProblemOccurredSaving: 'Ocorreu um problema ao tentar salvar as alterações.',
    ProblemOccurredCreating: 'Ocorreu um problema ao tentar criar um webhook.',
    ProblemOccurredFetching: 'Ocorreu um problema ao tentar buscar os webhooks.',
    ProblemOccurredDeleting: 'Ocorreu um problema ao tentar excluir este webhook.',
    ProblemOccurredLoading: 'Ocorreu um problema ao tentar carregar o código do script de injeção.',
    SuccessfullyCreatedMagicLink: 'Link mágico criado com sucesso.',
    SuccessfullyCreatedWebhook: 'Webhook criado com sucesso.',
    SuccessfullyDeletedWebhook: 'Webhook excluído com sucesso.',
    FailedToLoadMagicLinkTokens: 'Falha ao carregar tokens de link mágico',
    LinkCopiedToClipboard: 'Link copiado para a área de transferência',
    
    // Additional notification messages
    SuccessExclamation: 'Sucesso!',
    SuccessfullyDeletedSubspace: 'Subespaço excluído com sucesso!',
    ProblemOccurredDeletingSubspace: 'Ocorreu um problema ao tentar excluir este subespaço!',
    InvalidPassword: 'Senha inválida',
    NoAccessToResource: 'Sem acesso a este recurso',
    NoAccessToResourceText: 'Parece que você está tentando acessar este artigo com um e-mail que não tem acesso. Se você acredita que isso é um erro - entre em contato com a pessoa que compartilhou.',
    CodeSentToEmail: 'Um código foi enviado para seu e-mail.',
    CodeAlreadySentToEmail: 'Um código já foi enviado para seu e-mail.',
    SavedOrderOfOnboardings: 'Ordem das integrações salva',
    FailedToSaveOrder: 'Falha ao salvar a ordem.',
    SavedOrderOfSubspaces: 'Ordem dos subespaços salva',
    LinkSent: 'Link enviado',
    SomethingWentWrongSendingLink: 'Algo deu errado ao tentar enviar o link...',
    CouldNotLoadSpaceDetails: 'Não foi possível carregar os detalhes do espaço',
    FailedToLoadSpaceInformation: 'Falha ao carregar informações do espaço',
    SavedChanges: 'Alterações salvas',
    ProblemAddingImage: 'Houve um problema ao adicionar sua imagem.',
    TCVelikContentPasted: 'Conteúdo TCVelik colado',
    StepsAddedSuccessfully: '{count} etapa(s) adicionada(s) com sucesso',
    CursorNotInsideCustomNode: 'O cursor não está dentro de um nó personalizado.',
    SOPFormatExport: 'Exportação de Formato SOP',
    SOPFormatExportComingSoon: 'A funcionalidade de exportação de formato SOP será implementada em breve!',
    SuccessfullySavedImage: 'Imagem salva com sucesso!',
    DocumentFormatted: 'Documento formatado',
    UserHasBeenDeleted: 'Usuário foi excluído',
    SomethingWentWrongDeletingUser: 'Algo deu errado ao tentar excluir este usuário...',
    CannotGeneratePreviewForUnsavedOnboarding: 'Não é possível gerar visualização para integração não salva!',
    CameraNotAllowed: 'Câmera não permitida. Por favor, permita o acesso.',
    ErrorAccessingCamera: 'Erro ao acessar a câmera.',
    PleaseOpenAnOnboarding: 'Por favor, abra uma integração',
    OnboardingNotSavedCannotBeShared: 'A integração não foi salva e não pode ser compartilhada',
    DraftDeleted: 'Rascunho excluído',
    ErrorOccurredDeletingDraft: 'Ocorreu um erro ao tentar excluir este rascunho.',
    OnboardingDeleted: 'Integração excluída',
    ErrorOccurredDeletingOnboarding: 'Ocorreu um erro ao tentar excluir esta integração.',
    InvalidURL: 'URL inválida',
    PleaseFillInValidURL: 'Por favor, preencha uma URL válida',
    OnboardingWasSaved: '{name} foi salvo.',
    SuccessfullyCreatedAndAddedOnboardingToSpace: 'Integração criada e adicionada ao espaço com sucesso!',
    DomainLabelsHaveBeenApplied: 'Os rótulos de domínio foram aplicados.',
    
    // Navbar and Sidebar localization
    SearchWithAI: 'Pesquisar com IA',
    SearchPlaceholderNavbar: 'Pesquisar...',
    ManageUsers: 'Gerenciar usuários',
    Skills: 'Habilidades',
    Focus: 'Foco',
    AnalysisCompleted: 'Análise concluída',
    ProjectWasAnalyzed: 'Projeto {projectName} foi analisado.',
    AnalysisStarted: 'Análise iniciada',
    AnalysisWithTitle: 'Análise {title}',
    UserDoesNotHaveSlug: 'Este usuário não tem um slug, por favor vá para Admin da conta e atualize o slug do usuário.',
    YearsAgo: 'há {years} {yearsText}',
    YearAgo: 'há {years} Ano',
    DaysAgoSidebar: 'há {days} {daysText}',
    DayAgo: 'há {days} Dia',
    HoursAgo: 'há {hours} {hoursText}',
    HourAgo: 'há {hours} Hora',
    MinutesAgo: 'há {minutes} {minutesText}',
    MinuteAgo: 'há {minutes} Min',
    SecondsAgo: 'há {seconds} seg',
    JustNow: 'Agora mesmo',
    Years: 'Anos',
    Days: 'Dias',
    Hours: 'Hrs',
    Min: 'Min',
    NoInfo: 'Sem informações',
    UnknownAccount: 'Conta desconhecida',
    English: 'Inglês',
    Portuguese: 'Português',
    French: 'Francês',
    German: 'Alemão',
    DownloadDatabase: 'Baixar banco de dados',
    DownloadVersionHistoryDatabase: 'Baixar banco de dados do histórico de versões',
    SaveChanges: 'Salvar alterações',
    NoMagicLinkTokensFound: 'Nenhum token de link mágico encontrado.',
    SafelyReloading: 'Recarregando página com segurança...',

    // NoItemsCard.vue
    NoSOPsAvailable: 'Nenhuma SOP disponível',
    NoSOPsAvailableDescription: 'Parece que ainda não há Procedimentos Operacionais Padrão (SOPs) em sua conta. Você pode começar a capturar seus processos usando qualquer um destes métodos:',
    SubspacesDescription: 'O TCVelik oferece a capacidade de agrupar ainda mais seus itens criando subespaços dentro dos espaços.',
    ManualCreation: 'Criação manual',
    ManualCreationDescription: 'Crie SOPs passo a passo usando nosso editor manual',
    ChromeExtension: 'Extensão Chrome',
    ChromeExtensionDescription: 'Instale nossa extensão do navegador para gravação perfeita enquanto você trabalha',
    DesktopRecorder: 'Gravador de desktop',
    DesktopRecorderDescription: 'Use nossa aplicação de desktop para gravação avançada de tela',
    MobileRecording: 'Gravação móvel',
    MobileRecordingDescription: 'Grave SOPs do mundo físico com seu telefone móvel - nenhum aplicativo necessário',
    MoreInformationText: 'Mais informações sobre capturar seus SOPs podem ser encontradas',

    // Login.vue and Register.vue notifications
    WelcomeAdminCreated: '🎉 Bem-vindo! Sua conta de administrador foi criada com sucesso.',
    PleaseLoginWithCredentials: 'Por favor, faça login com suas credenciais para acessar o sistema.',
    LinkedInAuthentication: 'Autenticação LinkedIn',
    ConnectingToLinkedIn: 'Conectando ao LinkedIn...',
    LoginFailed: 'Falha no login',
    LinkedInAuthNotConfigured: 'O serviço de autenticação LinkedIn não está configurado corretamente.',
    CannotConnectLinkedIn: 'Não é possível conectar ao serviço de autenticação LinkedIn.',
    LoginAttempt: 'Tentativa de login',
    AlreadyLoggedIn: 'Você já está logado!',
    CreateAccount: 'Criar conta',
    WelcomeToTCVelik: '🎉 Bem-vindo ao TCVelik! Esta é sua primeira configuração.',
    YouWillBeAdmin: 'Você será criado como o Administrador deste sistema.',
    FillFormToCreateAccount: 'Preencha o formulário abaixo para criar uma nova conta.',
    AcceptTermsConditions: 'Eu aceito os termos e condições.',
    RegistrationInProgress: 'Registro em andamento!',
    PleaseWait: 'Por favor, aguarde..',
    AdminAccountCreatedSuccessfully: 'Conta de administrador criada com sucesso! Por favor, faça login para continuar.',
    AccountCreatedRedirecting: 'Conta criada. Redirecionando você para o login..',
    AccountNotCreated: 'Conta não criada.',

    // ImageUploadPopup.vue
    UploadImage: 'Carregar imagem',
    DragDropImageOrClick: 'Arraste e solte uma imagem aqui ou clique para selecionar',
    Preview: 'Pré-visualização',
    OR: 'OU',
    EnterImageURL: 'Digite a URL da imagem',
    Submit: 'Enviar',

    // GenericProgressPopup.vue
    YourTypeIsInProgress: 'Seu {type} está em andamento',
    ContinueWorkingFileWillDownload: 'Você pode continuar trabalhando. Quando pronto - o arquivo será baixado automaticamente.',
    Step: 'Passo',

    // CameraStepScreen.vue
    Capture: 'Capturar',
    Done: 'Concluído',
    ImagesCaptured: '{count} imagens capturadas',
    SaveSteps: 'Salvar passos',
    StepImage: 'Imagem do passo',
    StepTitle: 'Título do passo',
    StepDescription: 'Descrição do passo',
    BrowserNotSupportCamera: 'Seu navegador não suporta acesso à câmera.',

    // OnboardingAnalytics.vue
    ResolveFlaggedStepTitle: 'Resolver passo sinalizado',
    CommentLabel: 'Comentário',
    NotifyReporter: 'Notificar a pessoa que relatou isso',
    MarkAsResolved: 'Marcar como resolvido',
    SaveSearchQueryTitle: 'Salvar consulta de pesquisa',
    NameLabel: 'Nome',
    UrlLabel: 'URL',
    EditSearchQueryTitle: 'Editar consulta de pesquisa',
    FilterBySpaces: 'Filtrar por espaços',
    FilterByOnboardings: 'Filtrar por onboardings',
    DateRange: 'Intervalo de datas',
    SaveThisSearchQuery: 'Salvar esta consulta de pesquisa',
    SaveFilters: 'Salvar filtros',
    Options: 'Opções',
    DeleteThisSearchQuery: 'Excluir esta consulta de pesquisa',
    EditNameAndUrl: 'Editar nome e URL',
    EditFilters: 'Editar filtros',
    TotalSOPs: 'Total de SOPs',
    TotalUsers: 'Total de usuários',
    CompletionRate: 'Taxa de conclusão',
    InProgressLabel: 'Em andamento',
    NotStarted: 'Não iniciado',
    EstimatedHoursSaved: 'Horas economizadas estimadas',
    DocumentationRequests: 'Solicitações de documentação',
    FlaggedSteps: 'Passos sinalizados',
    UsersCompletedMostOnboardings: 'Usuários que completaram mais onboardings',
    CompletedCountForPeriod: '{count} onboardings concluídos para este período',
    NoDataForThisOnboarding: 'Nenhum dado para este onboarding',
    SOPStats: 'Estatísticas de SOP',
    RatingsCount: '{count} avaliações',
    EstimatedHoursSavedShort: '{hours} horas economizadas',
    NoItemsToShow: 'Nenhum item para mostrar',
    ErrorFetchingData: 'Ocorreu um erro ao buscar os dados',
    ResolvedStep: 'O passo foi resolvido',
    ProblemResolvingStep: 'Ocorreu um problema ao resolver este passo',
    ErrorFetchingHeatmap: 'Ocorreu um erro ao buscar os dados do mapa de calor',
    SavedQuery: 'Consulta de pesquisa salva com sucesso',
    ProblemSavingQuery: 'Ocorreu um problema ao salvar a consulta',
    DeletedQuery: 'Consulta de pesquisa excluída com sucesso',
    SavedChangesGeneric: 'Alterações salvas com sucesso',
    ProblemSavingFilters: 'Ocorreu um problema ao salvar os filtros',

    // Users.vue
    UsersTitle: 'Usuários',
    InviteUser: 'Convidar usuário',
    Invitations: 'Convites',
    Suggestions: 'Sugestões',

    // InviteUserModal.vue
    InviteUserTitle: 'Convidar usuário',
    EmailAddressLabel: 'Endereço de e-mail',
    EmailPlaceholderUser: 'usuario@exemplo.com',
    SelectRoles: 'Selecionar funções',
    CustomMessagePlaceholder: 'Opcional: Adicione uma mensagem pessoal...',
    CustomMessageLabel: 'Mensagem personalizada (Opcional)',
    LinkExpirationLabel: 'Expiração do link (horas)',
    ExpirationPlaceholder: '120',
    AllowUserRegistration: 'Permitir que o usuário se registre se não existir',
    Sending: 'Enviando...',
    SendInvitation: 'Enviar convite',
    FailedToLoadRoles: 'Falha ao carregar funções',
    RoleCreatedSuccessfully: 'Função criada com sucesso',
    RoleAlreadyExists: 'Uma função com este nome já existe',
    FailedToCreateRole: 'Falha ao criar função',
    InvitationSentSuccessfully: 'Convite enviado com sucesso para {count} função(ões).',
    FailedToSendInvitation: 'Falha ao enviar convite',

    // InvitationList.vue
    InvitationLinkTitle: 'Link de convite',
    UseThisLinkToInvite: 'Use este link para convidar o usuário.',
    EmailHeader: 'E-mail',
    RolesHeader: 'Funções',
    CreatedHeader: 'Criado',
    ExpiresHeader: 'Expira',
    StatusHeader: 'Status',
    VisitsHeader: 'Visitas',
    InvitedByHeader: 'Convidado por',
    ExpiredStatus: 'Expirado',
    ActiveStatus: 'Ativo',
    LastVisit: 'Última:',
    InvitationGroup: 'Convite',
    CopyLinkAction: 'Copiar link',
    ResendEmailAction: 'Reenviar e-mail',
    ErrorLoadingInvitations: 'Erro ao carregar convites',
    InvitationLinkCopied: 'Link de convite copiado com sucesso.',
    ResendInvitationConfirm: 'Reenviar e-mail de convite para {email}?',
    InvitationResent: 'Convite reenviado',
    ErrorResendingInvitation: 'Erro ao reenviar convite',

    // UserList.vue
    LoginLinkTitle: 'Link de login',
    UseThisLinkToSignIn: 'Use o link para entrar como este usuário.',
    LastLoginHeader: 'Último login',
    RoleHeader: 'Função',
    SourceHeader: 'Fonte',
    NotAvailable: 'N/D',
    EditGroup: 'Editar',
    EditAction: 'Editar',
    DeleteAction: 'Excluir',
    SendLoginLinkAction: 'Enviar link de login',
    ResetPasswordAction: 'Redefinir senha',
    AscendingSort: 'Crescente',
    DescendingSort: 'Decrescente',
    LastLoginDateSort: 'Data do último login',
    CreatedSort: 'Criado',
    ProblemsSavingChanges: 'Houve alguns problemas ao salvar suas alterações.',
    ResetPasswordConfirm: 'Redefinir a senha deste usuário?',
    ResetPasswordError: 'Redefinir senha',
    SendLoginLinkConfirm: 'Enviar um link de login?',
    DeleteUserConfirm: 'Você tem CERTEZA ABSOLUTA, esta ação não pode ser desfeita!',

    // UserEditorScreen.vue
    EditUserTitle: 'Editar usuário',
    AddNewUserTitle: 'Adicionar novo usuário',
    UploadImageTitle: 'Carregar imagem',
    CreateUserTab: 'Criar usuário',
    AddUserToRoleTab: 'Adicionar usuário à função',
    ChangePasswordTab: 'Alterar senha',
    APIAccessTab: 'Acesso à API',
    InviteUserTab: 'Convidar usuário',
    FirstNameLabel: 'Primeiro nome',
    LastNameLabel: 'Sobrenome',
    NewPasswordLabel: 'Nova senha',
    ConfirmPasswordLabel: 'Confirmar senha',
    APIKeyLabel: 'Chave API',
    ManageRoles: 'Gerenciar funções',
    SaveButton: 'Salvar',
    CreateUserButton: 'Criar usuário',
    ChangeButton: 'Alterar',
    ResetAPIKeyButton: 'Redefinir chave API',
    GenerateNewButton: 'Gerar novo',
    InviteButton: 'Convidar',
    AddedRole: 'Função adicionada.',
    RoleNameAlreadyExists: 'Uma função com este nome já existe.',
    ChangedAvatar: 'Avatar alterado.',
    ProblemSavingAvatar: 'Houve um problema ao salvar seu avatar.',
    UserInvited: '{email} foi convidado. Continue adicionando.',
    SuccessfullyCreatedUser: 'Usuário criado com sucesso!',
    ProblemCreatingUser: 'Ocorreu um problema ao tentar criar o usuário.',
    GeneratedAPIKey: 'Chave API gerada.',
    ProblemGeneratingAPIKey: 'Algo deu errado ao tentar gerar uma chave API...',
    ResetAPIKey: 'Chave API redefinida.',
    ProblemResettingAPIKey: 'Algo deu errado ao tentar redefinir a chave API...',
    PasswordResetEmailSentUserEditor: 'Se seu e-mail estiver em nosso sistema - você receberá um e-mail de redefinição de senha.',
    GenerateAPIKeyConfirm: 'Gerar uma chave API para este usuário?',
    ResetAPIKeyConfirm: 'Redefinir a chave API para este usuário?'

  } ,
  bg: {
    Dashboard: 'Табло',
    eCommerce: 'Електронна търговия',
    KnowledgeTree: 'Дърво на знанията',
    codesearch: 'Търсене в код',
    Apps: 'Приложения',
    Use:'Използвай',
    Todo: 'Задачи',
    Chat: 'Чат',
    Email: 'Имейл',
    Calendar: 'Календар',
    Projects: 'Проекти',
    People: 'Хора',
    FullCalendar: 'Пълен календар',
    SimpleCalendar: 'Опростен календар',
    Shop: 'Магазин',
    Cart: 'Количка',
    WishList: 'Списък с желания',
    Checkout: 'Плащане',
    UIElements: 'Елементи на интерфейса',
    DataList: 'Списък с данни',
    ListView: 'Списъчен изглед',
    ThumbView: 'Преглед с миниатюри',
    Grid: 'Решетка',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Цветове',
    Card: 'Карта',
    Basic: 'Основни',
    Statistics: 'Статистика',
    Analytics: 'Анализ',
    CardActions: 'Действия на карта',
    CardColors: 'Цветове на карта',
    Table: 'Таблица',
    agGridTable: 'agGrid Таблица',
    Components: 'Компоненти',
    Alert: 'Предупреждение',
    Avatar: 'Аватар',
    Badge: 'Значка',
    Breadcrumb: 'Навигационна следа',
    Button: 'Бутон',
    ButtonGroup: 'Група бутони',
    Chip: 'Чип',
    Collapse: 'Свиване',
    Dialogs: 'Диалози',
    Divider: 'Разделител',
    DropDown: 'Падащо меню',
    List: 'Списък',
    Loading: 'Зареждане',
    Navbar: 'Навигация',
    Notifications: 'Известия',
    Pagination: 'Пагинация',
    Popup: 'Изскачащ прозорец',
    Progress: 'Прогрес',
    Sidebar: 'Странична лента',
    Slider: 'Плъзгач',
    Tabs: 'Табове',
    Tooltip: 'Подсказка',
    Upload: 'Качване',
    FormsAndTable: 'Формуляри и таблица',
    FormElements: 'Елементи на формуляр',
    Select: 'Избери',
    Switch: 'Смени',
    Checkbox: 'Oтметка',
    Radio: 'Радио бутон',
    Input: 'Поле за въвеждане',
    NumberInput: 'Числово поле',
    Textarea: 'Текстово поле',
    FormLayouts: 'Оформления на формуляри',
    FormWizard: 'Помощник за формуляри',
    FormValidation: 'Валидиране на формуляри',
    FormInputGroup: 'Група входове',
    Pages: 'Страници',
    Authentication: 'Удостоверяване',
    Login: 'Влизане',
    Register: 'Регистрация',
    Password: 'Парола',
    ForgotPassword: 'Забравена парола',
    ResetPassword: 'Подновяване на парола',
    Reset: 'Поднови',
    RecoverPassword: 'Възстанови парола',
    ConfirmPassword: 'Повтори парола',
    RememberMe:'Запомни ме',
    LockScreen: 'Заключен екран',
    Miscellaneous: 'Разни',
    ComingSoon: 'Очаквайте скоро',
    Error: 'Грешка',
    404: '404',
    500: '500',
    NotAuthorized: 'Нямате достъп',
    ToggleFullscreen: 'Превключване на цял екран',
    SomethingIsntQuiteRight: 'Нещо не е наред',
    // OnboardingPDF Tour
    SopTitleTour: 'Това е заглавието на вашия SOP. Тук виждате името и описанието.',
    StepsTour: 'Това са вашите стъпки. Кликнете на заглавието, за да разгънете/свиете съдържанието.',
    ToolsTour: 'Използвайте тези инструменти, за да маркирате стъпките като завършени или да ги отбележите за преглед.',
    MenuTour: 'Накрая – действията за onboarding са тук, заедно с по-напреднали опции.',
    // OnboardingPDF.vue additions (bg)
    VerifyYourEmail: 'Потвърдете вашия имейл',
    VerificationCode: 'Код за потвърждение',
    PleaseEnterYourEmailVerification: 'Моля, въведете имейл, за да продължите.',
    WeHaveJustSentEmailWithPin: 'Току-що изпратихме имейл с PIN. Моля, въведете го по-долу, за да продължите.',
    Code: 'Код',
    ViewAsSlideshow: 'Виж като слайдшоу',
    RecordedWith: 'Записано с',
    ClickLinkBetterExperience: 'Натиснете линка за по-добро изживяване',
    ExternalContentMessage: 'Тази стъпка сочи към външно съдържание. Ще бъдете пренасочени към външна страница.',
    IUnderstandProceed: 'Разбирам, продължи',
    ImageView: 'Преглед на изображение',
    GuestUsersViewOnly: 'Гостите могат само да преглеждат съдържание.',
    ProblemCompletingStep: 'Възникна проблем при завършване на тази стъпка.',
    OnboardingSharedSuccessfully: 'Onboarding-ът е споделен успешно.',
    ErrorsSharingOnboarding: 'Възникнаха грешки при споделяне на този onboarding.',
    FieldCannotBeEmpty: 'Това поле не може да е празно',
    SuccessfullyAddedToSpace: 'Успешно добавено към пространството.',
    ProblemAddingToSpace: 'Проблем при добавяне към пространството.',
    SuccessfullyRemovedFromSpace: 'Успешно премахнато от пространството.',
    ProblemRemovingFromSpace: 'Проблем при премахване от пространството.',
    SendLoginLink: 'Изпрати линк за вход?',
    ProblemSendingLink: 'Възникна проблем при изпращането на линка.',
    PageBeingConverted: 'Страницата се конвертира...',
    ProblemConvertingToPDF: 'Възникна проблем при конвертиране в PDF.',
    PageCannotBeAccessed: 'Тази страница не може да бъде достъпена.',
    InvalidLink: 'Невалиден линк.',
    NoAccessEmailMessage: 'Достъпът е отказан за този имейл. Свържете се с човека, който е споделил.',
    EditorNotFound: 'Редакторът не е намерен',
    CopyToClipboard: 'Копирай в клипборда',
    ExpandStepContents: 'Разгърни съдържанието на стъпката',
    CollapseStepContent: 'Свий съдържанието на стъпката',
    MarkStepCompleted: 'Маркирай стъпката като завършена',
    Fullscreen: 'Цял екран',
    FlagThisStep: 'Маркирай тази стъпка',
    AddCommentToStep: 'Маркирай тази стъпка',
    ContentMissingOrNoPermissions: 'Съдържанието, което търсите, липсва или нямате разрешение за достъп до него.',
    SubmitFeedbackIfError: 'Ако смятате, че това е грешка - изпратете обратна връзка.',
    BackToHome: 'Обратно към началото',
    LoginAndRetry: 'Влезте и опитайте отново',
    Maintenance: 'Поддръжка',
    Profile: 'Профил',
    Invoice: 'Фактура',
    FAQ: 'ЧЗВ',
    Search: 'Търсене',
    KnowledgeBase: 'База от знания',
    ChartsAndMaps: 'Графики и карти',
    Charts: 'Графики',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Maps',
    Extensions: 'Приставки',
    QuillEditor: 'Редактор Quill',
    DragAndDrop: 'Плъзни и пусни',
    Datepicker: 'Избор на дата',
    DatetimePicker: 'Избор на дата/час',
    AccessControl: 'Контрол на достъпа',
    EditorView: 'Изглед редактор',
    AdminView: 'Администраторски изглед',
    I18n: 'I18n',
    Carousel: 'Въртележка',
    Clipboard: 'Клипборд',
    ContextMenu: 'Контекстно меню',
    StarRatings: 'Оценки със звезди',
    Autocomplete: 'Автодовършване',
    Tree: 'Дърво',
    Others: 'Други',
    MenuLevels: 'Нива на менюто',
    MenuLevel2p1: 'Ниво на меню 2.1',
    MenuLevel2p2: 'Ниво на меню 2.2',
    MenuLevel3p1: 'Ниво на меню 3.1',
    MenuLevel3p2: 'Ниво на меню 3.2',
    DisabledMenu: 'Деактивирано меню',
    Support: 'Помощ',
    Documentation: 'Документация',
    RaiseSupport: 'Създай тикет',
    demoTitle: 'Демо заглавие',
    Learning: 'Обучение',
    Exercises: 'Упражнения',
    Tags: 'Етикети',
    Logs: 'Дневници',
    CloudAdmin: 'Облачен админ',
    Users: 'Потребители',
    Accounts: 'Акаунти',
    Embeds: 'Вграждания',
    AccountLogs: 'Дневници на акаунта',
    AccountAdmin: 'Админ на акаунта',
    Helping: 'Помагане',
    Positions: 'Позиции',
    Working: 'Работа',
    Guides: 'Ръководства',
    CodeReviews: 'Прегледи на код',
    WorkAnalytics: 'Анализ на работата',
    Tours: 'Обиколки',
    OnboardingAndContext: 'Моето подравняване',
    demoText: 'Това е демо текст.',
    Record: 'Записване',
    Open: 'Отвори',
    Save: 'Запази',
    Share:'Сподели',
    SOPEditor:"Редактор",
    DiscoverImprove: 'Открий и подобри',
    Spaces: 'Пространства',
    SpaceManager: 'Управление на пространства',
    Latest: 'Най-нови',
    MostUseful: 'Най-полезни',
    TailoredForYou: 'Специално за вас',
    Browse: 'Разгледайте',
    Logout: 'Излез',
    MarkAsComplete: 'Маркирай като завършен',
    COMPLETED: "ЗАВЪРШЕН",
    Yes: "Да",
    No: "Не",
    Next: "Напред",
    Back: "Назад",
    Folders: 'Папки',
    BackToLogin: "Обратно към Login",
    //FEEDBACK CARD SPECIFIC(FeedbackCard.vue)
    FeedbackTitle: "Ще се радваме да получим вашето мнение",
    RateTitle: "Как бихте оценили този SOP?",
    SaveTimeTitle: "Този SOP спести ли ви време?",
    SaveTimeDescription: "Това ще ни помогне да приоритизираме подобренията.",
    SaveTimeApproxTitle: "Приблизително колко време ви спести?",
    SaveTimeApproxDescription: "По груба преценка – това ще ни помогне да разберем въздействието.",
    LessThanAnHour: "По-малко от 1 час",
    OneToTwoHours: "1-2 часа",
    TwoToFourHours: "2-4 часа",
    MoreThanFourHours: "Повече от 4 часа",
    NotSure: 'Не съм сигурен/на',
    AlreadyKnowHowTitle: "Вече знаехте ли как да направите това?",
    AlreadyKnowHowDescription: "Това ще ни помогне да разберем дали добавяме стойност отвъд съществуващите знания.",
    DocumentationBetterTitle: "Документацията ни беше ли по-добра от това, което знаехте?",
    RecommendSOPTitle: "Бихте ли препоръчали този на SOP на други?",
    RecommendSOPDescriptiion: "Това ще ни помогне да разберем ефективността на този SOP.",
    SOPEasyToFollowTitle: "Беше ли лесно да следвате този SOP?",
    CommentsTitle: "Имате ли коментари или предложения за подобрения?",
    CommentsDescription: "По желание: това ще ни помогне да се подобрим.",
    CommentTextAreaPlaceholder: "Кажете ни какво можем да подобрим...",
    SubmitFeedback: "Изпрати мнение",
    PopupFeedbackCompletionText: "Thank you for your feedback!",

    //FORGOTTEN PASSWORD SPECIFIC (ForgottenPassword.vue)
    RecoverYourPassword: 'Възстановете вашата паролата',
    RecoverYourPasswordInstuctions: 'Моля, въведете вашия имейл адрес и ние ще ви изпратим инструкции как да възстановите паролата си.',
    RecoverPasswordMessage: 'Ако вашият имейл адрес е в нашата система, ще получите имейл за възстановяване на паролата.',

    //ResetPassword.vue
    ResetPasswordPrompt: "Моля въведете нова парола.",

    // SOPEditorMenu
    File: 'Файл',
    Import: 'Импорт',
    Export: 'Експорт',
    ExportAs: 'Експорт като...',
    DownloadAsPPTX: 'Изтегли като PPTX',
    TCVelikSOPFormat: 'TCVelik SOP формат',
    AddToSpace: 'Добави към пространство',
    OpenReviewMenu: 'Отвори меню за преглед',
    GeneratePreviewLink: 'Генерирай линк за преглед',
    Delete: 'Изтрий',
    Close: 'Затвори',
    Edit: 'Редакция',
    Undo: 'Отмени',
    Redo: 'Повтори',
    SelectAll: 'Избери всички',
    View: 'Изглед',
    HTMLSource: 'HTML код',
    Tools: 'Инструменти',
    Properties: 'Свойства',
    Assign: 'Възложи',
    AssignToRole: 'Възложи(роля)',
    EditIntent: 'Редактирай Intent',
    ExitEditor: 'Изход от редактора',
    Menu: 'Меню',

    // MainToolbar and Components
    // AlignmentButtons
    AlignLeft: 'Подравни вляво',
    AlignCenter: 'Центрирай',
    AlignRight: 'Подравни вдясно',
    // TextFormattingButtons
    Heading: 'Заглавие',
    Paragraph: 'Параграф',
    Bold: 'Удебелен',
    Italic: 'Курсив',
    Underline: 'Подчертан',
    // ListButtons
    BulletList: 'Списък с точки',
    NumberedList: 'Номериран списък',
    ManualSteps: 'Ръчни стъпки',
    DefaultManual: 'По подразбиране',
    Warning: 'Предупредителна',
    Success: 'Успешна',
    Informational: 'Информационна',
    CameraPicture: 'Камера',
    CodeStep: 'Кодова',
    ErrorStep: 'Грешна',
    Image: 'Изображение',
    Line: 'Линия',
    // ContentButtons
    AddLink: 'Добави линк',
    AddImage: 'Добави изображение',
    // AdvancedButtons
    EditHTML: 'Редактирай HTML',
    // LineManagementButtons
    AddBlankLineAbove: 'Добави празен ред отгоре',
    AddBlankLineBelow: 'Добави празен ред отдолу',
    // FileOperationsButtons
    ShareOnboarding: 'Сподели onboarding',
    AssignOnboarding: 'Възложи onboarding',
    AssignToRoleTitle: 'Възложи на роля',
    OpenPropertiesMenu: 'Свойства',
    DeleteOnboarding: 'Изтрий onboarding',

    // SignalsView.vue
    SignalsManagement: 'Управление на сигнали',
    QuickFilters: 'Бързи филтри',
    System: 'Система',
    Action: 'Действие',
    UserEmail: 'Имейл на потребител',
    ProcessedStatus: 'Статус на обработка',
    All: 'Всички',
    Processed: 'Обработен',
    Unprocessed: 'Необработен',
    Refresh: 'Обнови',
    ManageFilters: 'Управление на филтри',
    ManageTags: 'Управление на тагове',
    ApplyTags: 'Приложи тагове',
    CreateTestSignal: 'Създай тестов сигнал',
    Context: 'Контекст',
    SOPHint: 'SOP подсказка',
    Created: 'Създаден',
    ViewDetails: 'Виж детайли',
    EditTags: 'Редактирай тагове',
    Showing: 'Показване',
    to: 'до',
    of: 'от',
    signals: 'сигнала',
    CreateNewFilter: 'Създай нов филтър',
    Name: 'Име',
    Field: 'Поле',
    Operation: 'Операция',
    Value: 'Стойност',
    CreateFilter: 'Създай филтър',
    FilterName: 'Име на филтър',
    Description: 'Описание',
    SelectField: 'Избери поле',
    SelectOperation: 'Избери операция',
    SecondValue: 'Втора стойност',
    CreateNewTag: 'Създай нов таг',
    Color: 'Цвят',
    CreateTag: 'Създай таг',
    TagName: 'Име на таг',
    ColorHex: 'Цвят (Hex)',
    ApplyTagsToSignals: 'Приложи тагове към сигнали',
    SelectFilters: 'Избери филтри',
    SelectFiltersToApply: 'Избери филтри за прилагане',
    SelectTags: 'Избери тагове',
    SelectTagsToApply: 'Избери тагове за прилагане',
    FilterCreatedSuccessfully: 'Филтърът е създаден успешно',
    FailedToCreateFilter: 'Неуспешно създаване на филтър',
    TagCreatedSuccessfully: 'Тагът е създаден успешно',
    FailedToCreateTag: 'Неуспешно създаване на таг',
    FailedToLoadSignals: 'Неуспешно зареждане на сигнали',
    FailedToApplyTags: 'Неуспешно прилагане на тагове',
    TestSignalCreatedSuccessfully: 'Тестовият сигнал е създаден успешно',
    FailedToCreateTestSignal: 'Неуспешно създаване на тестов сигнал',

    // SuggestionsList.vue
    SuggestedUsers: 'Предложени потребители',
    SignalCount: 'Брой сигнали',
    LastActivity: 'Последна активност',
    AlreadyInvited: 'Вече поканен',
    NewLabel: 'Нов',
    InvitationSent: 'Поканата е изпратена',
    Invite:'Invite',
    ReadyToInvite: 'Готов за покана',
    ForceProcess: 'Форсирай обработка',
    FailedToLoadSuggestedUsers: 'Неуспешно зареждане на предложените потребители',
    ProcessedSignals: 'Обработени {count} сигнала',
    FailedToProcessSignals: 'Неуспешна обработка на сигналите',

    // Profile.vue
    Hey: 'Здравей',
    Stranger: 'Непознат',
    SOPsOpened: 'Отворени SOP',
    SOPsCompleted: 'Завършени SOP',
    StepsCompleted: 'Завършени стъпки',
    RatingsGiven: 'Дадени оценки',
    CertificatesEarned: 'Получени сертификати',
    Filters: 'Филтри',
    Position: 'Позиция',
    Manager: 'Мениджър',
    Supervisor: 'Супервайзор',
    Status: 'Статус',
    Completed: 'Завършен',
    Pending: 'В очакване',
    ManagerPosition: 'Позиция мениджър',
    SupervisorPosition: 'Позиция супервайзор',
    Completion: 'Завършване',
    OpeningProcedures: 'Процедури за отваряне',
    ClosingProcedures: 'Процедури за затваряне',
    SafetyProtocol: 'Протокол за безопасност',
    EmployeeTraining: 'Обучение на служители',

    // UserJourneyTimeline.vue
    YourJourney: 'Вашето пътуване',
    Last7Days: 'Посл. 7 дни',
    Last30Days: 'Посл. 30 дни',
    Last90Days: 'Посл. 90 дни',
    LastYear: 'Миналата година',
    LoadingYourJourney: 'Зареждане на вашето пътуване...',
    FailedToLoadJourneyTimeline: 'Неуспешно зареждане на вашата времева линия на пътуването. Моля, опитайте отново.',
    TryAgain: 'Опитайте отново',
    NoActivityYet: 'Все още няма активност',
    JourneyTimelineWillAppear: 'Вашата времева линия на пътуването ще се появи тук, след като започнете да взаимодействате със SOP.',
    Resolved: 'Решено',
    PendingResolution: 'Очаква решение',
    Reason: 'Причина',
    Resolution: 'Решение',
    StepCompletedSuccessfully: 'Стъпка {stepId} завършена успешно',
    Stars: 'звезди',
    Comment: 'Коментар',
    Helpful: 'Полезно',
    SavedMinutes: '{minutes} минути спестени',
    AlreadyKnewThis: 'Вече знаех това',
    ViewSOP: 'Прегледай SOP',
    Today: 'Днес',
    Yesterday: 'Вчера',
    DaysAgo: 'преди {days} дни',
    WeekAgo: 'преди {weeks} седмица',
    WeeksAgo: 'преди {weeks} седмици',
    Times: 'пъти',
    Opened: 'Отворено',
    EarnedCertificateFor: 'Получен сертификат за',
    FlaggedStepIn: 'Маркирана стъпка в',
    CompletedStepIn: 'Завършена стъпка в',
    Rated: 'Оценено',

    // Onboarding.vue
    NothingMatchesThisPage: 'Нищо не съвпада за тази страница.',
    YouCanAddInfo: 'Може да добавите информация и да направите тази страница част от съществуващ или нов onboarding, като използвате бутона по-долу.',
    ShareAsEmail: 'Сподели като имейл',
    SubjectLabel: 'Тема:',
    EmailsCommaSeparated: 'Имейли (разделени със запетая)',
    SendEmail: 'Изпрати имейл',
    PreviewLink: 'Линк за преглед',
    PreviewLinkLabel: 'Линк за преглед:',
    SavePopupTitle: 'Запази',
    TitleLabel: 'Заглавие:',
    DescriptionLabel: 'Описание',
    ExternalUrl: 'Външен URL',
    ManageNDomains: 'Управлявай {count} домейна',
    SpaceLabel: 'Пространство:',
    OpenPreviewInNewTab: 'Отвори преглед в нов таб',
    Publish: 'Публикувай',
    SaveChangesToVersion: 'Запази промените към v. {major}.{minor}',
    SaveChangesToNewDraft: 'Запази промените в нов драфт',
    ManageDomains: 'Управление на домейни',
    OpenOnboarding: 'Отвори Onboarding',
    SearchPlaceholder: 'Въведете текст и натиснете Enter...',
    ArtefactsDiscovered: 'Открити артефакти',
    OnboardingsForThisUrl: 'Onboarding-и за този адрес',
    ViewInNewTab: 'Виж в нов таб',
    GuideMode: 'Режим ръководство',
    AddStep: 'Добави стъпка',
    EditStep: 'Редактирай стъпка',
    DeleteStep: 'Изтрий стъпка',
    AddOnboardingToSpaceTitle: 'Добави onboarding към пространство',
    OnboardingProperties: 'Свойства на onboarding'
    ,
    // Spaces.vue
    PremiumSpace: 'Премиум пространство',
    PremiumSpaceDescription: 'Това е премиум пространство, което изисква плащане за достъп.',
    ProceedToPayment: 'Премини към плащане',
    PropertiesTitle: 'Свойства',
    ShareSpace: 'Сподели пространство',
    AssignSpace: 'Възложи пространство',
    Verification: 'Потвърждение',
    PleaseEnterYourEmail: 'Моля, въведете вашия имейл.',
    EmailLabel: 'Имейл:',
    Send: 'Изпрати',
    PinVerification: 'Проверка на ПИН',
    CodeSentPrompt: 'Току-що изпратихме имейл с код. Моля въведете го по-долу, за да продължите.',
    YourCode: 'Вашият код',
    DidntReceiveCode: 'Не получихте код?',
    ClickHereToResend: 'Натиснете тук за ново изпращане',
    ClickHereToLogin: 'Натиснете тук за вход.',
    Validate: 'Потвърди',
    CreateSubspace: 'Създай подпространство',
    CreateSpace: 'Създай пространство',
    NoDescriptionYet: 'Това пространство все още няма описание.',
    NoSubspacesHere: 'Няма подпространства',
    NothingHere: 'Няма нищо...',
    SOPs: 'SOP-ове',
    NoSOPsInThisSpace: 'Няма SOP-и в това пространство',
    NoSOPsInThisSpaceDesc: 'Това пространство няма стандартни оперативни процедури (SOP) все още. Можете да започнете да записвате процесите си чрез някой от следните методи:',
    SaveOnboardingOrder: 'Запази реда на Onboarding-и',
    SaveSubspaceOrder: 'Запази реда на подпространствата',
    OnboardingsHeader: 'Onboarding-и',
    SubspacesHeader: 'Подпространства',
    GridView: 'Мрежов изглед',
    GoBack: 'Назад',
    PDFLinkedInFormat: 'PDF (LinkedIn формат)',
    HTMLFull: 'Пълен HTML',
    AssignSpaceToUser: 'Възложи пространство на потребител',
    AddSubspace: 'Добави подпространство'
    ,
    // SpacesManage.vue (Space Manager)
    Link: 'Линк',
    CreateSpaceTitle: 'Създай пространство',
    HideSpaceFromSidebar: 'Скрий пространството от страничната лента',
    ManageSpaces: 'Управление на пространства',
    ManageSpacesDescription: 'Използвайте командите по-долу, за да управлявате пространства, възлагате потребители и добавяте onboarding-и.',
    CreateNewSpace: 'Създай ново пространство',
    NoSpacesYet: 'Няма пространства',
    NoSpacesYetDescription: 'Започнете, като създадете първото си пространство, за да организирате onboarding-ите.',
    CreateYourFirstSpace: 'Създай първото си пространство',
    OnboardingNoDescriptionYet: 'Този onboarding все още няма описание.',
    // App.vue
    NoPasswordWarning: 'Вашият акаунт няма парола.',
    CreatePasswordCTA: 'Натиснете тук, за да създадете.',
    TCVelikTip: 'TCVelik съвет',
    RecommendExtensionText: 'Препоръчваме да използвате Chrome с инсталирано разширение за най-добро изживяване и контекстни резултати. Натиснете тук за инсталация.',
    AutoLoginSuccessful: 'Автоматичният вход е успешен',
    AutoLoginSuccessfulText: 'Бяхте автоматично влезли чрез разширението TCVelik.',
    PasswordResetEmailSent: 'Изпратен е имейл с линк за нова парола.',
    PleaseCheckInbox: 'Моля, проверете пощата си.',
    UserErrorPleaseLogin: 'Възникна грешка с вашия потребител. Моля, влезте отново.',
    LicenseWarningTitle: 'Лицензионно предупреждение:',
    ManageLicenseCTA: 'Натиснете тук, за да управлявате лиценза си.',
    // Cadence options
    Now: 'Сега',
    Daily: 'Ежедневно',
    Weekly: 'Еженеделно',
    Monthly: 'Ежемесечно',
    Quarterly: 'На тримесечие',
    Yearly: 'Ежегодно',
    SpecificDate: 'Конкретна дата'
    ,
    // OnboardingScheduleComponent
    Reviewer: 'Рецензент',
    Cadence: 'Честота',
    DateDue: 'Краен срок',
    SetReviewCadence: 'Задайте честотата на преглед за този onboarding'
    ,
    // AssignComponent.vue
    AllUsers: 'Всички потребители',
    AssignedUsers: 'Възложено на тези потребители',
    SuccessfullyAssignedItem: 'Възложено.',
    NoSuchUserExists: 'Този потребител не съществува.',
    ProblemSharingOnboarding: 'Възникна проблем при споделянето на този onboarding.',
    ErrorFetchingUsers: 'Възникнаха грешки при извличането на потребителите',
    SelectedUsers: 'Избрани потребители',
    ZeroSelected: '0 избрани'
    ,
    // AssignComponent placeholders
    SearchUserPlaceholder: 'Търси потребител ...',
    SortByPlaceholder: 'Сортирай по...',
    OrderOfSortPlaceholder: 'Ред на сортиране',
    FullNameHeader: 'Пълно име',
    ActionsHeader: 'Действия'
    ,
    // AssignToRoleComponent.vue
    ErrorFetchingAssignedRoles: 'Възникнаха грешки при извличането на ролите',
    ErrorFetchingRoles: 'Възникнаха грешки при извличането на ролите',
    NoSuchRoleExists: 'Тази роля не съществува.',
    ProblemAssigningItemToRole: 'Възникна проблем при възлагането на ролята.',
    SuccessfullyUnassignedItem: 'Възложението на ролятаа беше премахнато.'
    ,
    // LicensingCatalog.vue
    TCVelikLicensing: 'Лицензиране',
    ChoosePerfectPlan: 'Изберете перфектния план за вашата организация.',
    LicensingHelpText: 'Ако имате въпроси или се нуждаете от насоки как работи нашето лицензиране - моля посетете нашия',
    Website: 'уебсайт',
    Or: 'или',
    BookMeeting: 'запазете среща',
    WithUsDirectly: 'директно с нас.',
    YourLicenses: 'Вашите лицензи',
    LicenseHolder: 'Притежател на лиценза',
    Edition: 'Издание',
    RenewsAt: 'Подновява се на',
    Domain: 'Домейн',
    NA: 'Н/П',
    AvailableForUse: 'Налична за използване',
    UseThisLicense: 'Използвай този лиценз',
    PurchaseAdditionalLicenses: 'Закупи допълнителни лицензи:',
    NoDescriptionAvailable: 'Няма налично описание',
    Here: 'тук',
    LoadingLicensingOptions: 'Зареждане на опции за лицензиране...',
    NoLicensingOptionsAvailable: 'Няма налични опции за лицензиране',
    NoLicensingOptionsText: 'В момента няма налични опции за лицензиране. Моля, свържете се с поддръжката.',
    ActivateLicense: 'Активирай лиценз',
    EnterEmailToActivate: 'Моля, въведете вашия имейл адрес за да активирате този лиценз:',
    EmailPlaceholder: 'вашият.имейл@пример.bg',
    EmailAddress: 'Имейл адрес',
    Cancel: 'Отказ',
    Processing: 'Обработва се...',
    OnlyAvailableOnPersonal: 'Достъпно само на personal.tcvelik.com',
    FreeForever: 'Безплатно завинаги',
    ContactSales: 'Свържете се с продажбите',
    NoCreditCardRequired: 'Не се изисква кредитна карта',
    Per: 'за',
    OneTimePayment: 'Еднократно плащане',
    PurchaseNow: 'Купи сега',
    YouAndYourTeamCanDownload: 'Вие и вашият екип може да изтеглите и използвате TCVelik Personal Edition',
    FailedToLoadProducts: 'Неуспешно зареждане на продуктите за лицензиране',
    NoPricingAvailable: 'Няма налични цени',
    NoPricingOptionsText: 'Този продукт няма опции за ценообразуване',
    SelectionRequired: 'Изисква се избор',
    PleaseSelectPricing: 'Моля, изберете опция за ценообразуване',
    FailedToCreatePaymentLink: 'Неуспешно създаване на линк за плащане. Моля, опитайте отново.',
    InvalidEmail: 'Невалиден имейл',
    PleaseEnterValidEmail: 'Моля, въведете валиден имейл адрес',
    LicenseActivated: 'Лицензът е активиран!',
    LicenseActivatedSuccess: 'Вашият лиценз беше успешно активиран.',
    ActivationFailed: 'Активацията се провали',
    FailedToActivateLicense: 'Неуспешна активация на лиценза. Моля, опитайте отново.',
    LicenseSwitched: 'Лицензът е сменен!',
    LicenseSwitchedSuccess: 'Сега използвате различен лиценз. Предишният домейн ще спре да работи в рамките на 2 часа.',
    SwitchFailed: 'Смяната се провали',
    FailedToSwitchLicense: 'Неуспешна смяна на лиценза. Моля, опитайте отново.',
    SwitchLicenseConfirmation: 'Сигурни ли сте, че искате да превключите към лиценз {product}?\n\n⚠️ Важно: Това ще направи вашия текущ лиценз недостъпен на този домейн за до 2 часа поради кеширането. Другият домейн временно ще спре да работи.\n\nИскате ли да продължите?',
    Renewed: 'Подновен',
    RenewsToday: 'Подновява се днес',
    RenewsTomorrow: 'Подновява се утре',
    RenewsInDays: 'Подновява се след {days} дни',
    Expired: 'Изтекъл',
    ExpiresToday: 'Изтича днес',
    ExpiresTomorrow: 'Изтича утре',
    ExpiresInDays: 'Изтича след {days} дни',

    // Search.vue
    BasicSearch: 'Основно търсене',
    Results: 'резултата',
    FoundNothing: 'нищо не е намерено.',
    NoResults: 'Няма резултати',
    SearchReturnedNoResults: 'Търсенето не върна резултати.',
    KeepTrying: 'Продължете да опитвате...',
    WorkingSearch: 'Обработване ...',
    ResultsComingShortly: 'Резултатите идват скоро ...',
    IntentFilters: 'Филтри за намерение:',
    ShowAll: 'Покажи всички',
    ClearAll: 'Изчисти всички',
    Filter: 'Филтрирай',
    SuccessNotification: 'Готово!',
    TextCopiedSuccessfully: 'Текстът е копиран успешно.',
    Failed: 'Неуспешно!',
    ErrorInCopyingText: 'Грешка при копиране на текста.',

    // AccountBranding.vue
    AccountBranding: 'Брандинг на акаунта',
    Favicon: 'Favicon',
    ChangedIcon: 'Иконата е променена.',
    ProblemSavingIcon: 'Възникна проблем при запазването на вашата икона.',
    Saved: 'Запазено',

    // AdminControlPanel.vue
    CreateWebhook: 'Създай Webhook',
    Database: 'База данни',
    SystemSettings: 'Системни настройки',
    ChangeLanguage: 'Промени езика',
    CreateMagicLink: 'Създай магическа връзка',
    Webhooks: 'Webhooks',
    CreateEmbedScript: 'Създай вграден скрипт за изпълнение',
    EventType: 'Тип събитие',
    FilterByRoles: 'Филтър:роли',
    MagicLink: 'Магическа връзка',
    CampaignName: 'Име на кампанията',
    ExistingMagicLinkTokens: 'Съществуващи токени за магическа връзка',
    LoadTokens: 'Зареди токени',
    DateCreated: 'Дата на създаване',
    TargetURL: 'Целева URL',
    RoleToken: 'Токен за роля',
    CopyLink: 'Копирай връзка',
    LoadingMagicLinkTokens: 'Зареждане на токени за магическа връзка...',
    CreateWebhookButton: 'Създай webhook',
    FormatDocument: 'Форматирай документ',
    SuccessfullyUpdatedSettings: 'Настройките са актуализирани успешно.',
    ProblemOccurredDownloading: 'Възникна проблем при изтеглянето на базата данни.',
    ProblemOccurredSaving: 'Възникна проблем при опита за запазване на промените.',
    ProblemOccurredCreating: 'Възникна проблем при опита за създаване на webhook.',
    ProblemOccurredFetching: 'Възникна проблем при опита за извличане на webhooks.',
    ProblemOccurredDeleting: 'Възникна проблем при опита за изтриване на този webhook.',
    ProblemOccurredLoading: 'Възникна проблем при опита за зареждане на кода на инжектиращия скрипт.',
    SuccessfullyCreatedMagicLink: 'Магическата връзка е създадена успешно.',
    SuccessfullyCreatedWebhook: 'Webhook-ът е създаден успешно.',
    SuccessfullyDeletedWebhook: 'Webhook-ът е изтрит успешно.',
    FailedToLoadMagicLinkTokens: 'Неуспешно зареждане на токени за магическа връзка',
    LinkCopiedToClipboard: 'Връзката е копирана в клипборда',
    
    // Additional notification messages
    SuccessExclamation: 'Успех!',
    SuccessfullyDeletedSubspace: 'Подпространството е изтрито успешно!',
    ProblemOccurredDeletingSubspace: 'Възникна проблем при опита за изтриване на това подпространство!',
    InvalidPassword: 'Невалидна парола',
    NoAccessToResource: 'Няма достъп до този ресурс',
    NoAccessToResourceText: 'Изглежда, че се опитвате да достъпите тази статия с имейл, който няма достъп. Ако смятате, че това е грешка - моля, свържете се с човека, който я е споделил.',
    CodeSentToEmail: 'Кодът е изпратен на вашия имейл.',
    CodeAlreadySentToEmail: 'Кодът вече е изпратен на вашия имейл.',
    SavedOrderOfOnboardings: 'Редът на onboarding-ите е запазен',
    FailedToSaveOrder: 'Неуспешно запазване на реда.',
    SavedOrderOfSubspaces: 'Редът на подпространствата е запазен',
    LinkSent: 'Връзката е изпратена',
    SomethingWentWrongSendingLink: 'Нещо се обърка при опита за изпращане на връзката...',
    CouldNotLoadSpaceDetails: 'Не можахме да заредим детайлите за пространството',
    FailedToLoadSpaceInformation: 'Неуспешно зареждане на информация за пространството',
    SavedChanges: 'Промените са запазени',
    ProblemAddingImage: 'Възникна проблем при добавянето на вашето изображение.',
    TCVelikContentPasted: 'TCVelik съдържание е поставено',
    StepsAddedSuccessfully: '{count} стъпка(и) добавени успешно',
    CursorNotInsideCustomNode: 'Курсорът не е в персонализиран възел.',
    SOPFormatExport: 'SOP Формат Експорт',
    SOPFormatExportComingSoon: 'Функционалността за експорт в SOP формат ще бъде внедрена скоро!',
    SuccessfullySavedImage: 'Изображението е запазено успешно!',
    DocumentFormatted: 'Документът е форматиран',
    UserHasBeenDeleted: 'Потребителят е изтрит',
    SomethingWentWrongDeletingUser: 'Нещо се обърка при опита за изтриване на този потребител...',
    CannotGeneratePreviewForUnsavedOnboarding: 'Не може да се генерира преглед за незапазен onboarding!',
    CameraNotAllowed: 'Камерата не е разрешена. Моля, разрешете достъпа.',
    ErrorAccessingCamera: 'Грешка при достъп до камерата.',
    PleaseOpenAnOnboarding: 'Моля, отворете onboarding',
    OnboardingNotSavedCannotBeShared: 'Onboarding-ът не е запазен и не може да бъде споделен',
    DraftDeleted: 'Черновата е изтрита',
    ErrorOccurredDeletingDraft: 'Възникна грешка при опита за изтриване на тази чернова.',
    OnboardingDeleted: 'Onboarding-ът е изтрит',
    ErrorOccurredDeletingOnboarding: 'Възникна грешка при опита за изтриване на този onboarding.',
    InvalidURL: 'Невалиден URL',
    PleaseFillInValidURL: 'Моля, попълнете валиден URL',
    OnboardingWasSaved: '{name} е запазен.',
    SuccessfullyCreatedAndAddedOnboardingToSpace: 'Onboarding-ът е създаден и добавен към пространството успешно!',
    DomainLabelsHaveBeenApplied: 'Етикетите на домейна са приложени.',
    
    // Navbar and Sidebar localization
    GetTheExtention: "Инсталирай приставката",
    SearchWithAI: 'Търсене с ИИ',
    SearchPlaceholderNavbar: 'Търсене...',
    ManageUsers: 'Управление на потребители',
    Skills: 'Умения',
    Focus: 'Фокус',
    AnalysisCompleted: 'Анализът е завършен',
    ProjectWasAnalyzed: 'Проектът {projectName} беше анализиран.',
    AnalysisStarted: 'Анализът започна',
    AnalysisWithTitle: 'Анализ {title}',
    UserDoesNotHaveSlug: 'Този потребител няма slug, моля отидете до Админ на акаунта и актуализирайте slug-а на потребителя.',
    YearsAgo: 'преди {years} {yearsText}',
    YearAgo: 'преди {years} Година',
    DaysAgoSidebar: 'преди {days} {daysText}',
    DayAgo: 'преди {days} Ден',
    HoursAgo: 'преди {hours} {hoursText}',
    HourAgo: 'преди {hours} Час',
    MinutesAgo: 'преди {minutes} {minutesText}',
    MinuteAgo: 'преди {minutes} Мин',
    SecondsAgo: 'преди {seconds} сек',
    JustNow: 'Току-що',
    Years: 'Години',
    Days: 'Дни',
    Hours: 'Час',
    Min: 'Мин',
    NoInfo: 'Няма информация',
    UnknownAccount: 'Неизвестен акаунт',
    English: 'Английски',
    Portuguese: 'Португалски',
    French: 'Френски',
    German: 'Немски',
    DownloadDatabase: 'Изтегли база данни',
    DownloadVersionHistoryDatabase: 'Изтегли база данни за история на версиите',
    SaveChanges: 'Запази промените',
    NoMagicLinkTokensFound: 'Не са намерени токени за магическа връзка.',
    SafelyReloading: 'Безопасно презареждане на страницата...',

    // NoItemsCard.vue
    NoSOPsAvailable: 'Няма налични SOP',
    NoSOPsAvailableDescription: 'Изглежда, че все още няма стандартни оперативни процедури (SOP) в вашия акаунт. Можете да започнете да записвате процесите си чрез някой от следните методи:',
    SubspacesDescription: 'TCVelik ви предоставя възможността да групирате допълнително вашите елементи чрез създаване на подпространства в пространствата.',
    ManualCreation: 'Ръчно създаване',
    ManualCreationDescription: 'Създавайте SOP стъпка по стъпка с нашия ръчен редактор',
    ChromeExtension: 'Chrome разширение',
    ChromeExtensionDescription: 'Инсталирайте нашето браузърно разширение за безпроблемно записване докато работите',
    DesktopRecorder: 'Desktop рекордер',
    DesktopRecorderDescription: 'Използвайте нашето desktop приложение за напреднало записване на екрана',
    MobileRecording: 'Мобилно записване',
    MobileRecordingDescription: 'Записвайте физически SOP с вашия мобилен телефон - не се изисква приложение',
    MoreInformationText: 'Повече информация за записването на вашите SOP може да намерите',

    // Login.vue and Register.vue notifications
    WelcomeAdminCreated: '🎉 Добре дошли! Вашият администраторски акаунт беше създаден успешно.',
    PleaseLoginWithCredentials: 'Моля, влезте с вашите данни за достъп, за да получите достъп до системата.',
    LinkedInAuthentication: 'LinkedIn удостоверяване',
    ConnectingToLinkedIn: 'Свързване с LinkedIn...',
    LoginFailed: 'Влизането се провали',
    LinkedInAuthNotConfigured: 'LinkedIn услугата за удостоверяване не е конфигурирана правилно.',
    CannotConnectLinkedIn: 'Не може да се свърже с LinkedIn услугата за удостоверяване.',
    LoginAttempt: 'Опит за влизане',
    AlreadyLoggedIn: 'Вече сте влезли!',
    CreateAccount: 'Създай акаунт',
    WelcomeToTCVelik: '🎉 Добре дошли в TCVelik! Това е вашето първо настройване.',
    YouWillBeAdmin: 'Ще бъдете създаден като Администратор на тази система.',
    FillFormToCreateAccount: 'Попълнете формуляра по-долу, за да създадете нов акаунт.',
    AcceptTermsConditions: 'Приемам условията и положенията.',
    RegistrationInProgress: 'Регистрацията е в ход!',
    PleaseWait: 'Моля, изчакайте..',
    AdminAccountCreatedSuccessfully: 'Администраторският акаунт е създаден успешно! Моля, влезте, за да продължите.',
    AccountCreatedRedirecting: 'Акаунтът е създаден. Пренасочваме ви към влизане..',
    AccountNotCreated: 'Акаунтът не е създаден.',

    // ImageUploadPopup.vue
    UploadImage: 'Качване на изображение',
    DragDropImageOrClick: 'Плъзнете и пуснете изображение тук или кликнете за избор',
    Preview: 'Преглед',
    OR: 'ИЛИ',
    EnterImageURL: 'Въведете URL на изображението',
    Submit: 'Изпрати',

    // GenericProgressPopup.vue
    YourTypeIsInProgress: 'Вашият {type} е в процес на изпълнение',
    ContinueWorkingFileWillDownload: 'Можете да продължите да работите. Когато е готов - файлът ще бъде автоматично изтеглен.',
    Step: 'Стъпка',

    // CameraStepScreen.vue
    Capture: 'Заснемане',
    Done: 'Готово',
    ImagesCaptured: '{count} изображения заснети',
    SaveSteps: 'Запази стъпки',
    StepImage: 'Изображение на стъпка',
    StepTitle: 'Заглавие на стъпка',
    StepDescription: 'Описание на стъпка',
    BrowserNotSupportCamera: 'Вашият браузър не поддържа достъп до камера.',

    // OnboardingAnalytics.vue
    ResolveFlaggedStepTitle: 'Реши маркирана стъпка',
    CommentLabel: 'Коментар',
    NotifyReporter: 'Уведоми човека, който е докладвал това',
    MarkAsResolved: 'Маркирай като решено',
    SaveSearchQueryTitle: 'Запази търсене',
    NameLabel: 'Име',
    UrlLabel: 'URL',
    EditSearchQueryTitle: 'Редактирай търсене',
    FilterBySpaces: 'Филтър:пространства',
    FilterByOnboardings: 'Филтър:onboarding-и',
    DateRange: 'Период',
    SaveThisSearchQuery: 'Запази това търсене',
    SaveFilters: 'Запази филтри',
    Options: 'Опции',
    DeleteThisSearchQuery: 'Изтрий това търсене',
    EditNameAndUrl: 'Редактирай име и URL',
    EditFilters: 'Редактирай филтри',
    TotalSOPs: 'Общо SOP',
    TotalUsers: 'Общо потребители',
    CompletionRate: 'Процент на завършване',
    InProgressLabel: 'В процес',
    NotStarted: 'Не е стартиран',
    EstimatedHoursSaved: 'Приблизително спестени часове',
    DocumentationRequests: 'Заявки за документация',
    FlaggedSteps: 'Маркирани стъпки',
    UsersCompletedMostOnboardings: 'Потребители със завършени onboarding-и',
    CompletedCountForPeriod: 'Завършени {count} onboarding-а за този период',
    NoDataForThisOnboarding: 'Няма данни за този onboarding',
    SOPStats: 'SOP статистики',
    RatingsCount: '{count} оценки',
    EstimatedHoursSavedShort: '{hours} часа спестени',
    NoItemsToShow: 'Няма елементи за показване',
    ErrorFetchingData: 'Възникна грешка при извличането на данните',
    ResolvedStep: 'Стъпката е решена',
    ProblemResolvingStep: 'Възникна проблем при решаването на тази стъпка',
    ErrorFetchingHeatmap: 'Възникна грешка при извличането на данните за топлинната карта',
    SavedQuery: 'Търсенето е запазено успешно',
    ProblemSavingQuery: 'Възникна проблем при запазването на търсенето',
    DeletedQuery: 'Търсенето е изтрито успешно',
    SavedChangesGeneric: 'Промените са запазени успешно',
    ProblemSavingFilters: 'Възникна проблем при запазването на филтрите',

    // Users.vue
    UsersTitle: 'Потребители',
    InviteUser: 'Покани потребител',
    Invitations: 'Покани',
    Suggestions: 'Предложения',

    // InviteUserModal.vue
    InviteUserTitle: 'Покани потребител',
    EmailAddressLabel: 'Имейл адрес',
    EmailPlaceholderUser: 'потребител@пример.bg',
    SelectRoles: 'Избери роли',
    CustomMessagePlaceholder: 'По избор: Добави персонално съобщение...',
    CustomMessageLabel: 'Персонално съобщение (По избор)',
    LinkExpirationLabel: 'Изтичане на линка (часове)',
    ExpirationPlaceholder: '120',
    AllowUserRegistration: 'Позволи на потребителя да се регистрира, ако не съществува',
    Sending: 'Изпращане...',
    SendInvitation: 'Изпрати покана',
    FailedToLoadRoles: 'Неуспешно зареждане на роли',
    RoleCreatedSuccessfully: 'Ролята е създадена успешно',
    RoleAlreadyExists: 'Роля с това име вече съществува',
    FailedToCreateRole: 'Неуспешно създаване на роля',
    InvitationSentSuccessfully: 'Поканата е изпратена успешно за {count} роля(и).',
    FailedToSendInvitation: 'Неуспешно изпращане на покана',

    // InvitationList.vue
    InvitationLinkTitle: 'Линк за покана',
    UseThisLinkToInvite: 'Използвай този линк, за да поканиш потребителя.',
    EmailHeader: 'Имейл',
    RolesHeader: 'Роли',
    CreatedHeader: 'Създаден',
    ExpiresHeader: 'Изтича',
    StatusHeader: 'Статус',
    VisitsHeader: 'Посещения',
    InvitedByHeader: 'Поканен от',
    ExpiredStatus: 'Изтекла',
    ActiveStatus: 'Активна',
    LastVisit: 'Последно:',
    InvitationGroup: 'Покана',
    CopyLinkAction: 'Копирай линк',
    ResendEmailAction: 'Изпрати имейл отново',
    ErrorLoadingInvitations: 'Грешка при зареждане на поканите',
    InvitationLinkCopied: 'Линкът за покана е копиран успешно.',
    ResendInvitationConfirm: 'Изпрати имейл за покана отново до {email}?',
    InvitationResent: 'Поканата е изпратена отново',
    ErrorResendingInvitation: 'Грешка при изпращане на поканата отново',

    // UserList.vue
    LoginLinkTitle: 'Линк за вход',
    UseThisLinkToSignIn: 'Използвай линка, за да влезеш като този потребител.',
    LastLoginHeader: 'Последен вход',
    RoleHeader: 'Роля',
    SourceHeader: 'Източник',
    NotAvailable: 'Н/Д',
    EditGroup: 'Редактирай',
    EditAction: 'Редактирай',
    DeleteAction: 'Изтрий',
    SendLoginLinkAction: 'Изпрати линк за вход',
    ResetPasswordAction: 'Нулирай парола',
    AscendingSort: 'Възходящ',
    DescendingSort: 'Низходящ',
    LastLoginDateSort: 'Дата на последен вход',
    CreatedSort: 'Създаден',
    ProblemsSavingChanges: 'Възникнаха проблеми при запазването на промените.',
    ResetPasswordConfirm: 'Нулирай паролата на този потребител?',
    ResetPasswordError: 'Нулирай парола',
    SendLoginLinkConfirm: 'Изпрати линк за вход?',
    DeleteUserConfirm: 'Сигурен ли сте?Това действие не може да бъде отменено!',

    // UserEditorScreen.vue
    EditUserTitle: 'Редактирай потребител',
    AddNewUserTitle: 'Добави нов потребител',
    UploadImageTitle: 'Качи изображение',
    CreateUserTab: 'Създай потребител',
    AddUserToRoleTab: 'Добави потребител към роля',
    ChangePasswordTab: 'Промени парола',
    APIAccessTab: 'API достъп',
    InviteUserTab: 'Покани потребител',
    FirstNameLabel: 'Първо име',
    LastNameLabel: 'Фамилия',
    NewPasswordLabel: 'Нова парола',
    ConfirmPasswordLabel: 'Потвърди парола',
    APIKeyLabel: 'API ключ',
    ManageRoles: 'Управлявай роли',
    SaveButton: 'Запази',
    CreateUserButton: 'Създай потребител',
    ChangeButton: 'Промени',
    ResetAPIKeyButton: 'Нулирай API ключ',
    GenerateNewButton: 'Генерирай нов',
    InviteButton: 'Покани',
    AddedRole: 'Ролята е добавена.',
    RoleNameAlreadyExists: 'Роля с това име вече съществува.',
    ChangedAvatar: 'Аватарът е променен.',
    ProblemSavingAvatar: 'Възникна проблем при запазването на аватара.',
    UserInvited: '{email} е поканен. Продължи да добавяш.',
    SuccessfullyCreatedUser: 'Потребителят е създаден успешно!',
    ProblemCreatingUser: 'Възникна проблем при опита за създаване на потребител.',
    GeneratedAPIKey: 'API ключът е генериран.',
    ProblemGeneratingAPIKey: 'Нещо се обърка при опита за генериране на API ключ...',
    ResetAPIKey: 'API ключът е нулиран.',
    ProblemResettingAPIKey: 'Нещо се обърка при опита за нулиране на API ключ...',
    PasswordResetEmailSentUserEditor: 'Ако имейлът ти е в нашата система - ще получиш имейл за нулиране на паролата.',
    GenerateAPIKeyConfirm: 'Генерирай API ключ за този потребител?',
    ResetAPIKeyConfirm: 'Нулирай API ключа за този потребител?'
  },
}
